/* Mine Binders 4.0 (beta) — samler-dashboardet.
   Hylde m. Overblik-strip → "Start en ny samling"-browser (sæt-grid m.
   completion, Pokémon- og Illustrator-søgning) → binder-detalje m.
   stempel-interaktion → fuldskærms katalog-ark.
   Nyt i 4.0: binder-værdi (vejledende Cardmarket), Fuldfør-hjælper
   (billigste vej til 100 %), social proof på tiles, guld-medalje +
   fejring ved 100 %, antal pr. slot (trade-stakken), print af
   mangellisten, binder-side-visning (3x3-lommer), deling via
   offentligt link (?del=<token> — virker uden login) og CSV-import
   af samlinger fra andre platforme (client-side parsing, max 500 rk).
   Performance: saet_liste/opdag/popularitet hentes PARALLELT med
   hylde-GET'et og caches i sessionStorage (TTL 1 time).
   Samme backend-protokol som før: App Proxy /apps/portal/binders/v2
   (signeret kunde-id) + Shopify /cart/add.js. */
(function () {
  'use strict';
  if (window.__mtwB2) return;
  window.__mtwB2 = 1;

  var PROXY = '/apps/portal/binders/v2';
  var rod = document.querySelector('[data-mtwb2-rod]') || document.querySelector('.mtwb2');
  var hylde = document.querySelector('[data-mtwb2-hylde]');
  var detalje = document.querySelector('[data-mtwb2-detalje]');
  var pub = document.querySelector('[data-mtwb2-offentlig]');
  var erKunde = !!(rod && rod.getAttribute('data-mtwb2-kunde'));

  function urlParam(navn) {
    var m = window.location.search.match(new RegExp('[?&]' + navn + '=([^&#]+)'));
    return m ? decodeURIComponent(m[1].replace(/\+/g, ' ')) : null;
  }
  var delToken = urlParam('del');

  /* Delt visning kræver kun pub-containeren; app'en kræver hylde+detalje */
  if (!pub && (!hylde || !detalje)) return;

  var liste = document.querySelector('[data-mtwb2-liste]');
  var overblik = document.querySelector('[data-mtwb2-overblik]');
  var browserKrop = document.querySelector('[data-mtwb2-browser-krop]');
  var opretModal = document.querySelector('[data-mtwb2-opret]');
  var soegInput = document.querySelector('[data-mtwb2-soeg]');
  var forslagHolder = document.querySelector('[data-mtwb2-forslag]');
  var aktivBinder = null;
  var aktivFilter = 'alle';
  var aktivUdgave = 'alle';   /* master set: 'alle' | 'normal' | 'rh', virker sammen med aktivFilter */
  var fyldUdgave = 'normal';  /* master set: hvilken udgave fyld-numrene markeres på */
  var udgaveBinderId = null;  /* udgave-valgene huskes, mens den samme binder tegnes forfra */
  var goerMasterIGang = false; /* banner-knappen og menupunktet deler ét goer_master-kald */
  var paaEscape = null; /* sættes af detalje-visningen: lukker popover/ark */

  /* 4.0-tilstand */
  var aktivSlots = [];        /* levende kopi af detaljens slots (toggle/antal/fjern synker den) */
  var bulkMatches = [];       /* mangler-på-lager fra broen — deles med Fuldfør-hjælperen */
  var forrigePct = null;      /* til at fange øjeblikket hvor 100 % rammes */
  var fejret = {};            /* én fejring pr. binder pr. session */
  var visningsValg = 'grid';  /* 'grid' | 'sider' — huskes på tværs af binders i sessionen */
  var sideNr = 0;             /* aktuel side i binder-side-visningen */
  var aktivTegnSider = null;  /* gen-tegner siderne ved breakpoint-skift */

  /* 5.0-tilstand */
  var pendingSortKey = null;  /* "Tilføj kort her": næste tilføjelse lander på denne lomme */
  var fortrydT = null;        /* timer for Fortryd-toasten */
  var galleriData = null;     /* ?galleri=1-svaret — hentes én gang pr. sidevisning */

  var REDUCERET = false;
  try {
    REDUCERET = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  } catch (eRm) { /* gamle browsere */ }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* da-DK tusindtal: 12400 → "12.400" */
  function fmtKr(n) {
    n = Math.round(n || 0);
    var s;
    try { s = n.toLocaleString('da-DK'); } catch (eL) { s = null; }
    if (!s || s === String(n) && n >= 10000) {
      s = String(n).replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    }
    return s;
  }

  /* ---------- Ikonbibliotek: egne SVG'er i mtw-streg (aldrig Pokémon-IP).
     Covers gemmes som nøgler (fx 'ball-roed'); ukendte nøgler falder
     tilbage til ren tekst. ---------- */
  function svgBall(farve) {
    return '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="12" r="10.5" fill="#fff" stroke="#1a1a1a" stroke-width="2"/>' +
      '<path d="M1.5 12a10.5 10.5 0 0 1 21 0z" fill="' + farve + '" stroke="#1a1a1a" stroke-width="2"/>' +
      '<line x1="1.5" y1="12" x2="22.5" y2="12" stroke="#1a1a1a" stroke-width="2"/>' +
      '<circle cx="12" cy="12" r="3.4" fill="#fff" stroke="#1a1a1a" stroke-width="2"/></svg>';
  }
  var IKON_SVG = {
    'ball-roed': svgBall('#e94b4b'),
    'ball-blaa': svgBall('#3b76e0'),
    'ball-ink': svgBall('#1a1a1a'),
    'ball-lilla': svgBall('#8e4bd8'),
    'ball-guld': svgBall('#e0a90f'),
    dex: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<rect x="3" y="2" width="18" height="20" rx="2.5" fill="#e94b4b" stroke="#1a1a1a" stroke-width="2"/>' +
      '<circle cx="7.4" cy="6.3" r="2.5" fill="#9fd9ff" stroke="#1a1a1a" stroke-width="1.5"/>' +
      '<circle cx="12.8" cy="4.8" r="0.95" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1"/>' +
      '<circle cx="15.8" cy="4.8" r="0.95" fill="#9fd9ff" stroke="#1a1a1a" stroke-width="1"/>' +
      '<circle cx="18.6" cy="4.8" r="0.95" fill="#fff" stroke="#1a1a1a" stroke-width="1"/>' +
      '<rect x="5.8" y="10" width="12.4" height="7.4" rx="1.2" fill="#fff" stroke="#1a1a1a" stroke-width="1.5"/>' +
      '<rect x="7.6" y="11.6" width="8.8" height="4.2" rx="0.6" fill="#1a1a1a"/>' +
      '<rect x="5.8" y="19" width="4.6" height="1.9" rx="0.6" fill="#9fd9ff" stroke="#1a1a1a" stroke-width="1"/>' +
      '<circle cx="17.4" cy="19.9" r="1.25" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1"/></svg>',
    kort: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<rect x="4.5" y="3" width="15" height="19" rx="2.5" fill="#fff" stroke="#1a1a1a" stroke-width="2"/>' +
      '<rect x="7.2" y="5.8" width="9.6" height="7" rx="1" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1.5"/>' +
      '<line x1="7.5" y1="16" x2="16.5" y2="16" stroke="#1a1a1a" stroke-width="1.5"/>' +
      '<line x1="7.5" y1="19" x2="13" y2="19" stroke="#1a1a1a" stroke-width="1.5"/>' +
      '<path d="M19 1l1 2.4L22.4 4.4 20 5.4 19 7.8 18 5.4 15.6 4.4 18 3.4z" fill="#fff" stroke="#1a1a1a" stroke-width="1.3" stroke-linejoin="round"/></svg>',
    lyn: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M13.5 2L5.5 13.5h5L10.5 22l8-12h-5z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/></svg>',
    diamant: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M7 3h10l4 6-9 12L3 9z" fill="#9fd9ff" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M3 9h18M7 3l5 6 5-6M7.2 9L12 21l4.8-12" fill="none" stroke="#1a1a1a" stroke-width="1.3" stroke-linejoin="round"/></svg>',
    krone: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M3.5 17.5L5 7.5l4.2 3.8L12 5l2.8 6.3L19 7.5l1.5 10z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '<rect x="3.5" y="17.5" width="17" height="3.5" rx="1" fill="#fff" stroke="#1a1a1a" stroke-width="2"/></svg>',
    klokke: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 2.5a6.5 6.5 0 0 1 6.5 6.5c0 3.6 1 5.4 2 6.5H3.5c1-1.1 2-2.9 2-6.5A6.5 6.5 0 0 1 12 2.5z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M9.5 18.5a2.5 2.5 0 0 0 5 0" fill="#fff" stroke="#1a1a1a" stroke-width="2"/></svg>',
    stjerne: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 2l2.2 5.4L20 8.6l-4.4 4 1.3 6.4L12 15.8 7.1 19l1.3-6.4-4.4-4 5.8-1.2z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/></svg>',
    flamme: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 2c1 3.2-.6 4.6-2 6C8.4 9.6 7 11.4 7 14a5 5 0 0 0 10 0c0-1.8-.7-3.3-1.6-4.6C14.5 8 13.5 6.5 14 4.5 15.8 5.8 19 8.8 19 14a7 7 0 0 1-14 0C5 8.5 9.5 5 12 2z" fill="#e94b4b" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M12 12c.6 1.6-.9 2.3-.9 3.7a1.9 1.9 0 0 0 3.8 0c0-1.7-1.6-2.4-2.9-3.7z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1.4" stroke-linejoin="round"/></svg>',
    draabe: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 2.5C15.5 7.5 19 10.8 19 15a7 7 0 0 1-14 0c0-4.2 3.5-7.5 7-12.5z" fill="#9fd9ff" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M9 14.5a3.4 3.4 0 0 0 2 3.4" fill="none" stroke="#1a1a1a" stroke-width="1.6" stroke-linecap="round"/></svg>',
    blad: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M20 4C11 4 5.5 8 5 15c-.1 1.6.3 3 .9 4C9 20.5 14 20 17 16.5 20.2 12.8 20 7 20 4z" fill="#8adfae" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M4 21c3-5 7-9 12-12" fill="none" stroke="#1a1a1a" stroke-width="1.8" stroke-linecap="round"/></svg>',
    hjerte: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 21C6.5 16.7 2.5 13.2 2.5 8.9 2.5 6 4.8 4 7.4 4c1.8 0 3.5.9 4.6 2.6C13.1 4.9 14.8 4 16.6 4c2.6 0 4.9 2 4.9 4.9 0 4.3-4 7.8-9.5 12.1z" fill="#ffb3cd" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/></svg>',
    aeg: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 2.5c4 4.4 7 8.4 7 12.5a7 7 0 0 1-14 0c0-4.1 3-8.1 7-12.5z" fill="#fffdf5" stroke="#1a1a1a" stroke-width="2"/>' +
      '<path d="M7 13l2.4 2 2.3-2.6 2.5 2.4L16.8 12" fill="none" stroke="#1a1a1a" stroke-width="1.6" stroke-linejoin="round"/>' +
      '<circle cx="10" cy="8" r="1" fill="#8adfae"/><circle cx="14.5" cy="17" r="1" fill="#9fd9ff"/></svg>',
    kasket: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M3 13a9 9 0 0 1 18 0v2H3z" fill="#e94b4b" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M2 15h20l-1.6 3H3.6z" fill="#fffdf5" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '<circle cx="12" cy="9.5" r="2" fill="#fff" stroke="#1a1a1a" stroke-width="1.6"/></svg>',
    medalje: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M8 2h8l-2.5 6h-3z" fill="#9fd9ff" stroke="#1a1a1a" stroke-width="1.8" stroke-linejoin="round"/>' +
      '<circle cx="12" cy="15" r="6.5" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2"/>' +
      '<path d="M12 11.5l1.1 2.3 2.5.4-1.8 1.7.4 2.5-2.2-1.2-2.2 1.2.4-2.5-1.8-1.7 2.5-.4z" fill="#fff" stroke="#1a1a1a" stroke-width="1.2" stroke-linejoin="round"/></svg>',
    maane: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M20 14.5A8.5 8.5 0 1 1 9.5 4a7 7 0 0 0 10.5 10.5z" fill="#e7dcff" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M17 3l.7 1.6L19.3 5.3 17.7 6 17 7.6 16.3 6 14.7 5.3 16.3 4.6z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1.1" stroke-linejoin="round"/></svg>',
    pensel: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M20.5 3.5c-3.8 1.2-7.6 4.4-9.8 7.2l3.1 3.1c2.8-2.2 6-6 7.2-9.8z" fill="#9fd9ff" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M10.2 11.2c-1.6.3-2.7 1.4-3.2 3-.5 1.7-.4 3.4-3.5 4.6 1.6 1.6 5.7 2 7.8 0 1.3-1.2 2.3-2.6 2-4.5z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/></svg>',
    kurv: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M2.5 4h3l2.6 11.2a1.6 1.6 0 0 0 1.6 1.3h8.6a1.6 1.6 0 0 0 1.6-1.2L21.8 8H6.3" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round" stroke-linecap="round"/>' +
      '<path d="M6.8 8h15l-1.5 6.5H8.3z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1.6" stroke-linejoin="round"/>' +
      '<circle cx="10.3" cy="20" r="1.7" fill="#fff" stroke="#1a1a1a" stroke-width="1.8"/>' +
      '<circle cx="17.6" cy="20" r="1.7" fill="#fff" stroke="#1a1a1a" stroke-width="1.8"/></svg>',
    mappe: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<rect x="4" y="2.5" width="16" height="19" rx="2.5" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2"/>' +
      '<path d="M4 5a2.5 2.5 0 0 1 2.5-2.5H9v19H6.5A2.5 2.5 0 0 1 4 19z" fill="#1a1a1a" opacity="0.18"/>' +
      '<line x1="9" y1="2.5" x2="9" y2="21.5" stroke="#1a1a1a" stroke-width="1.6"/>' +
      '<circle cx="6.5" cy="8" r="1.1" fill="#fffdf5" stroke="#1a1a1a" stroke-width="1.2"/>' +
      '<circle cx="6.5" cy="16" r="1.1" fill="#fffdf5" stroke="#1a1a1a" stroke-width="1.2"/>' +
      '<rect x="11.4" y="9" width="6.4" height="6" rx="1" fill="#fffdf5" stroke="#1a1a1a" stroke-width="1.5"/></svg>',
    /* Nye stregtegninger (mtw-streg: 2px ink, gule accenter) */
    byt: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M5.8 9.5A7 7 0 0 1 17.6 6" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M19 2.2v5h-5z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1.6" stroke-linejoin="round"/>' +
      '<path d="M18.2 14.5A7 7 0 0 1 6.4 18" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M5 21.8v-5h5z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1.6" stroke-linejoin="round"/></svg>',
    lup: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle cx="10.5" cy="10.5" r="6.8" fill="#fffdf5" stroke="#1a1a1a" stroke-width="2"/>' +
      '<path d="M6.6 9.6a4.1 4.1 0 0 1 3-3" fill="none" stroke="#FFCB03" stroke-width="2" stroke-linecap="round"/>' +
      '<line x1="15.7" y1="15.7" x2="21.2" y2="21.2" stroke="#1a1a1a" stroke-width="2.6" stroke-linecap="round"/></svg>',
    stak: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<rect x="2.6" y="6.4" width="10.2" height="14.2" rx="1.6" transform="rotate(-9 7.7 13.5)" fill="#efece1" stroke="#1a1a1a" stroke-width="1.8"/>' +
      '<rect x="7" y="4.8" width="10.2" height="14.2" rx="1.6" fill="#fffdf5" stroke="#1a1a1a" stroke-width="1.8"/>' +
      '<rect x="11.2" y="3.8" width="10" height="14" rx="1.6" transform="rotate(8 16.2 10.8)" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1.8"/>' +
      '<path d="M17.6 8.2l.7 1.7 1.8.3-1.3 1.2.3 1.8-1.5-.9-1.6.9.3-1.8-1.3-1.2 1.9-.3z" fill="#fff" stroke="#1a1a1a" stroke-width="1.1" stroke-linejoin="round"/></svg>',
    /* 4.0: UI-ikoner til visnings-skiftet (aldrig i udseende-vælgeren) */
    gitter: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<rect x="3" y="3" width="7.6" height="7.6" rx="1.6" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2"/>' +
      '<rect x="13.4" y="3" width="7.6" height="7.6" rx="1.6" fill="#fffdf5" stroke="#1a1a1a" stroke-width="2"/>' +
      '<rect x="3" y="13.4" width="7.6" height="7.6" rx="1.6" fill="#fffdf5" stroke="#1a1a1a" stroke-width="2"/>' +
      '<rect x="13.4" y="13.4" width="7.6" height="7.6" rx="1.6" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2"/></svg>',
    opslag: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 5c-2.2-1.6-5.4-2-9-1.4v15c3.6-.6 6.8-.2 9 1.4 2.2-1.6 5.4-2 9-1.4v-15C17.4 3 14.2 3.4 12 5z" fill="#fffdf5" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '<line x1="12" y1="5" x2="12" y2="20" stroke="#1a1a1a" stroke-width="2"/>' +
      '<rect x="5.4" y="7.2" width="4.2" height="5.6" rx="0.8" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1.4"/>' +
      '<rect x="14.4" y="7.2" width="4.2" height="5.6" rx="0.8" fill="#9fd9ff" stroke="#1a1a1a" stroke-width="1.4"/></svg>',
    /* 5.0: nye UI-ikoner (burger, lås, download, deck-liste, kopi, galleri, blyant) */
    prikker: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="5" r="2.1" fill="currentColor"/>' +
      '<circle cx="12" cy="12" r="2.1" fill="currentColor"/>' +
      '<circle cx="12" cy="19" r="2.1" fill="currentColor"/></svg>',
    laas: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<rect x="5" y="10.5" width="14" height="10" rx="2" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2"/>' +
      '<path d="M8 10.5V7.5a4 4 0 0 1 8 0v3" fill="none" stroke="#1a1a1a" stroke-width="2"/>' +
      '<circle cx="12" cy="15.5" r="1.7" fill="#1a1a1a"/></svg>',
    'laas-aaben': '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<rect x="5" y="10.5" width="14" height="10" rx="2" fill="#fffdf5" stroke="#1a1a1a" stroke-width="2"/>' +
      '<path d="M8 10.5V7.5a4 4 0 0 1 7.6-1.7" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round"/>' +
      '<circle cx="12" cy="15.5" r="1.7" fill="#1a1a1a"/></svg>',
    download: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M12 3v9.5" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M7.5 9.5L12 14.5l4.5-5z" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1.8" stroke-linejoin="round"/>' +
      '<path d="M4 15.5v3A2.5 2.5 0 0 0 6.5 21h11a2.5 2.5 0 0 0 2.5-2.5v-3" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round"/></svg>',
    liste: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<rect x="4" y="2.5" width="16" height="19" rx="2" fill="#fffdf5" stroke="#1a1a1a" stroke-width="2"/>' +
      '<circle cx="8" cy="8" r="1.1" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1"/>' +
      '<circle cx="8" cy="12.5" r="1.1" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1"/>' +
      '<circle cx="8" cy="17" r="1.1" fill="#FFCB03" stroke="#1a1a1a" stroke-width="1"/>' +
      '<line x1="10.8" y1="8" x2="17" y2="8" stroke="#1a1a1a" stroke-width="1.8" stroke-linecap="round"/>' +
      '<line x1="10.8" y1="12.5" x2="17" y2="12.5" stroke="#1a1a1a" stroke-width="1.8" stroke-linecap="round"/>' +
      '<line x1="10.8" y1="17" x2="14.5" y2="17" stroke="#1a1a1a" stroke-width="1.8" stroke-linecap="round"/></svg>',
    kopi: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M15.5 6.5V5A2 2 0 0 0 13.5 3h-8A2.5 2.5 0 0 0 3 5.5v8a2 2 0 0 0 2 2h1.5" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round"/>' +
      '<rect x="8" y="8" width="13" height="13" rx="2" fill="#FFCB03" stroke="#1a1a1a" stroke-width="2"/></svg>',
    globus: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<circle cx="12" cy="12" r="9.5" fill="#9fd9ff" stroke="#1a1a1a" stroke-width="2"/>' +
      '<ellipse cx="12" cy="12" rx="4.3" ry="9.5" fill="none" stroke="#1a1a1a" stroke-width="1.5"/>' +
      '<line x1="2.5" y1="12" x2="21.5" y2="12" stroke="#1a1a1a" stroke-width="1.5"/>' +
      '<path d="M4.4 7h15.2M4.4 17h15.2" fill="none" stroke="#1a1a1a" stroke-width="1.3"/></svg>',
    link: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M10.2 13.8a5 5 0 0 0 7.1 0l2.6-2.6a5 5 0 0 0-7.1-7.1l-1.5 1.5" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M13.8 10.2a5 5 0 0 0-7.1 0l-2.6 2.6a5 5 0 0 0 7.1 7.1l1.5-1.5" fill="none" stroke="#FFCB03" stroke-width="2" stroke-linecap="round"/>' +
      '<path d="M13.8 10.2a5 5 0 0 0-7.1 0l-2.6 2.6a5 5 0 0 0 7.1 7.1l1.5-1.5" fill="none" stroke="#1a1a1a" stroke-width="2" stroke-linecap="round" stroke-dasharray="2.5 3.5"/></svg>',
    blyant: '<svg class="mtwb2__ikon" viewBox="0 0 24 24" aria-hidden="true" focusable="false">' +
      '<path d="M4.5 19.5l1-4.2L16.6 4.2a2.1 2.1 0 0 1 3 0l0.9 0.9a2.1 2.1 0 0 1 0 3L9.4 19.2 4.5 20.5z" fill="#fffdf5" stroke="#1a1a1a" stroke-width="2" stroke-linejoin="round"/>' +
      '<path d="M14.6 6.4l3 3" fill="none" stroke="#1a1a1a" stroke-width="1.8"/>' +
      '<path d="M5.5 15.3l3.2 3.2" fill="none" stroke="#FFCB03" stroke-width="2"/></svg>'
  };
  /* Udseende-vælgeren: uændrede 22 ikoner (byt/lup/stak/gitter/opslag er kun UI-ikoner) */
  var IKON_NOEGLER = ['ball-roed', 'ball-blaa', 'ball-ink', 'ball-lilla', 'ball-guld', 'dex', 'kort', 'mappe', 'lyn', 'diamant', 'krone', 'klokke', 'stjerne', 'flamme', 'draabe', 'blad', 'hjerte', 'aeg', 'kasket', 'medalje', 'maane', 'pensel'];
  function mtwIkon(noegle) {
    return IKON_SVG[noegle] || '<span class="mtwb2__ikon-tekst">' + esc(noegle || '') + '</span>';
  }

  var toastT;
  function toast(t) {
    var el = document.querySelector('[data-mtwb2-toast]');
    if (!el) return;
    el.textContent = t;
    el.classList.add('mtwb2__toast--vis');
    clearTimeout(toastT);
    toastT = setTimeout(function () { el.classList.remove('mtwb2__toast--vis'); }, 2400);
  }

  function hent(url) {
    return fetch(url, { credentials: 'same-origin' }).then(function (r) {
      if (!r.ok) throw new Error('http ' + r.status);
      return r.json();
    });
  }

  /* Variant-id'er der ikke må lægges i kurven herfra, via smart-kollektioner (backendens matches har ikke tags):
     - forudbestillinger (regel: tag = forudbestilling): mangler kurv-egenskaben Forudbestilling
     - kommer-snart (regel: tag = kommer-snart): kan ikke købes endnu
     Ét kald pr. kollektion pr. side; fejler et kald (fx 404, kollektionen findes ikke), filtreres der ikke for den. */
  function tagVarianter(handle, tag) {
    return fetch('/collections/' + handle + '/products.json?limit=250', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        var ids = {};
        ((d && d.products) || []).forEach(function (p) {
          if ((p.tags || []).indexOf(tag) < 0) return;
          (p.variants || []).forEach(function (v) { ids[String(v.id)] = true; });
        });
        return ids;
      })
      .catch(function () { return {}; });
  }
  var _forud = null;
  function forudVarianter() {
    if (!_forud) {
      _forud = Promise.all([tagVarianter('forudbestillinger', 'Forudbestilling'), tagVarianter('kommer-snart', 'Kommer-snart')])
        .then(function (res) {
          var ids = {};
          res.forEach(function (m) { for (var k in m) ids[k] = true; });
          return ids;
        });
    }
    return _forud;
  }

  function post(data) {
    return fetch(PROXY, {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }

  function laasScroll(til) {
    document.documentElement.classList.toggle('mtwb2-laas', !!til);
  }

  function skeletKort(n) {
    var s = '';
    for (var i = 0; i < n; i++) s += '<div class="mtwb2__kort-skelet" aria-hidden="true"></div>';
    return s;
  }

  /* Stemplet: kortets delight-øjeblik (CSS-keyframes; reduced-motion slår det fra) */
  function stempl(el) {
    el.classList.remove('mtwb2__kort--nystemplet');
    void el.offsetWidth; /* genstart animation */
    el.classList.add('mtwb2__kort--nystemplet');
    setTimeout(function () { el.classList.remove('mtwb2__kort--nystemplet'); }, 600);
  }

  /* 4.0 Achievements: guld-medalje-bursten når 100 % rammes.
     Ren CSS-animation (ingen libraries); reduced motion → kun statisk badge. */
  function fejr() {
    if (REDUCERET) return;
    var f = document.createElement('div');
    f.className = 'mtwb2__fejr';
    f.setAttribute('aria-hidden', 'true');
    var html = '<span class="mtwb2__fejr-medalje">' + mtwIkon('medalje') + '</span>';
    var farver = ['#FFCB03', '#e94b4b', '#9fd9ff', '#8adfae', '#ffb3cd'];
    for (var i = 0; i < 10; i++) {
      var vinkel = (Math.PI * 2 * i) / 10 + Math.random() * 0.4;
      var dist = 90 + Math.random() * 70;
      html += '<span class="mtwb2__fejr-spark" style="background:' + farver[i % farver.length] +
        ';--dx:' + Math.round(Math.cos(vinkel) * dist) + 'px;--dy:' + Math.round(Math.sin(vinkel) * dist) + 'px' +
        ';animation-delay:' + ((i % 3) * 60) + 'ms"></span>';
    }
    f.innerHTML = html;
    (rod || document.body).appendChild(f);
    setTimeout(function () { if (f.parentNode) f.parentNode.removeChild(f); }, 1700);
  }

  /* Kopiér til udklipsholder — navigator.clipboard m. execCommand-fallback */
  function kopier(tekst, klar) {
    function fallback() {
      var ta = document.createElement('textarea');
      ta.value = tekst;
      ta.setAttribute('readonly', '');
      ta.style.position = 'fixed';
      ta.style.opacity = '0';
      document.body.appendChild(ta);
      ta.select();
      var ok = false;
      try { ok = document.execCommand('copy'); } catch (eC) { ok = false; }
      document.body.removeChild(ta);
      if (ok) klar(); else toast('Markér linket og kopiér det manuelt');
    }
    if (navigator.clipboard && navigator.clipboard.writeText) {
      navigator.clipboard.writeText(tekst).then(klar, fallback);
    } else {
      fallback();
    }
  }

  /* Fjerner dynamiske modaler (udseende/fuldfør/deling) — opret-modalen fredes */
  function fjernLoseModaler() {
    document.querySelectorAll('.mtwb2__modal-bag').forEach(function (b) {
      if (!b.hasAttribute('data-mtwb2-opret')) b.remove();
    });
  }

  /* ---------- 5.0-hjælpere ---------- */

  /* Stabil sortering efter sort_key (null/ukendt bevarer rækkefølgen bagerst) */
  function sorterSlots(slots) {
    var dekoreret = slots.map(function (s, i) { return { s: s, i: i }; });
    dekoreret.sort(function (a, b) {
      var ak = (a.s.sort_key == null) ? 1000000 + a.i : a.s.sort_key;
      var bk = (b.s.sort_key == null) ? 1000000 + b.i : b.s.sort_key;
      if (ak !== bk) return ak - bk;
      /* master set: ved samme nøgle ligger kortet før sin Reverse Holo-lomme */
      var ar = erRh(a.s) ? 1 : 0, br = erRh(b.s) ? 1 : 0;
      if (ar !== br) return ar - br;
      return a.i - b.i;
    });
    return dekoreret.map(function (d) { return d.s; });
  }

  function erPlaceholder(s) { return s && s.pk_card_id == null; }

  /* ---------- Master set: hvert kort + dets Reverse Holo-udgave.
     Lommer har udgave 'normal' | 'rh'. Felterne mangler hos en ældre
     backend: så er intet master, og siden opfører sig som før. ---------- */
  function erRh(s) { return !!(s && s.udgave === 'rh'); }
  function erMaster(b) { return !!(b && b.master === true); }
  function rhMaerke() { return '<span class="mtwb2__rh-badge" aria-hidden="true">RH</span>'; }
  function rhNavn(s) { return erRh(s) ? ' <em class="mtwb2__rh-navn">RH</em>' : ''; }
  function rhTitel(s) { return (s.title || '') + (erRh(s) ? ' (Reverse Holo)' : ''); }
  /* Banneret "Samler du også Reverse Holo?" kan lukkes og huskes lokalt pr. binder */
  function msBannerLukket(id) {
    try { return localStorage.getItem('mtwb2_ms_banner_' + id) === '1'; } catch (eL) { return false; }
  }
  function lukMsBanner(id) {
    try { localStorage.setItem('mtwb2_ms_banner_' + id, '1'); } catch (eL) { /* privat browsing */ }
  }
  /* Optælling pr. udgave: { normal: {har, total}, rh: {har, total} } */
  function taelUdgaver(slots) {
    var t = { normal: { har: 0, total: 0 }, rh: { har: 0, total: 0 } };
    slots.forEach(function (s) {
      var u = erRh(s) ? t.rh : t.normal;
      u.total++;
      if (s.har) u.har++;
    });
    return t;
  }
  function pctAf(har, total) { return total ? Math.round((har / total) * 100) : 0; }
  function rhLommer(n) { return n + (n === 1 ? ' Reverse Holo-lomme' : ' Reverse Holo-lommer'); }

  /* Lomme-fordeling: kort m. sort_key lander på deres lomme (0-baseret,
     på tværs af sider); kort uden nøgle (eller m. kollision) får første
     ledige lomme. Kort i bakken holdes udenfor. */
  function fordelLommer(slots) {
    var pladser = {};
    var uden = [];
    var maxIdx = -1;
    slots.forEach(function (s) {
      if (s.i_bakke) return;
      var k = s.sort_key;
      if (typeof k === 'string' && k !== '' && !isNaN(k)) k = parseInt(k, 10);
      if (typeof k === 'number' && k >= 0 && !pladser[k]) {
        pladser[k] = s;
        if (k > maxIdx) maxIdx = k;
      } else {
        uden.push(s);
      }
    });
    var naeste = 0;
    uden.forEach(function (s) {
      while (pladser[naeste]) naeste++;
      pladser[naeste] = s;
      if (naeste > maxIdx) maxIdx = naeste;
      naeste++;
    });
    return { pladser: pladser, maxIdx: maxIdx };
  }

  /* Gridder pr. lomme-format: 4 = 2×2, 9 = 3×3, 12 = 3×4 */
  function formatKolonner(format) { return format === 4 ? 2 : 3; }
  function formatRaekker(format) { return format === 4 ? 2 : (format === 12 ? 4 : 3); }

  /* Indholdet i én lomme (billede / placeholder-bagside / mangler-nummer).
     Bruges af både den private side-visning og de offentlige visninger. */
  function lommeIndhold(s) {
    var antal = s.antal > 1 ? s.antal : 1;
    if (erPlaceholder(s) && !s.image_url) {
      /* 5.0 Placeholder: stiliseret kort-bagside i mtw-streg — aldrig Pokémon-tegning */
      return '<span class="mtwb2__ph">' +
        '<span class="mtwb2__ph-cirkel" aria-hidden="true">' + mtwIkon('kort') + '</span>' +
        '<span class="mtwb2__ph-titel">' + esc(s.title || 'Eget kort') + '</span>' +
        ((s.set_name || s.number) ? '<span class="mtwb2__ph-meta">' + esc(trimF((s.set_name || '') + ' ' + (s.number ? '#' + s.number : ''))) + '</span>' : '') +
        '<span class="mtwb2__ph-badge">Eget kort</span>' +
        '</span>' +
        (s.har && antal > 1 ? '<span class="mtwb2__kort-antal">×' + antal + '</span>' : '');
    }
    var rh = erRh(s) ? rhMaerke() : '';
    if (s.har || s.image_url) {
      var art = s.image_url
        ? '<img src="' + esc(s.image_url) + '" alt="' + esc(rhTitel(s)) + '" loading="lazy" draggable="false">'
        : '<span class="mtwb2__kort-fallback" aria-hidden="true">' + mtwIkon('kort') + '</span>';
      if (s.har) {
        return art + rh + (antal > 1 ? '<span class="mtwb2__kort-antal">×' + antal + '</span>' : '');
      }
      /* mangler m. billede: ghost-udgave */
      return art + rh;
    }
    return '<span class="mtwb2__lomme-nr">' + (s.number ? '#' + esc(s.number) : '?') + '</span>' + rh;
  }

  /* Butiks-match-nøgler (samme normalisering som serveren) */
  function normSet(s) { return trimF(s).toLowerCase(); }
  function normNr(n) { return trimF(n).replace(/^0+(\d)/, '$1').toLowerCase(); }

  /* Klient-side fil-download: Blob m. dataURI-fallback */
  function downloadFil(navn, indhold, mime) {
    navn = String(navn || 'binder').replace(/[\\/:*?"<>|]/g, '-');
    var a = document.createElement('a');
    a.style.display = 'none';
    var url = null;
    try {
      if (window.Blob && window.URL && URL.createObjectURL) {
        url = URL.createObjectURL(new Blob([indhold], { type: mime + ';charset=utf-8' }));
        a.href = url;
      } else {
        a.href = 'data:' + mime + ';charset=utf-8,' + encodeURIComponent(indhold);
      }
    } catch (eB) {
      a.href = 'data:' + mime + ';charset=utf-8,' + encodeURIComponent(indhold);
    }
    a.download = navn;
    document.body.appendChild(a);
    a.click();
    setTimeout(function () {
      if (a.parentNode) a.parentNode.removeChild(a);
      if (url) { try { URL.revokeObjectURL(url); } catch (eU) { /* stille */ } }
    }, 400);
  }

  /* CSV: Titel;Sæt;Nummer;Har;Antal — semikolon (dansk Excel), BOM for æøå.
     Har binderen Reverse Holo-lommer (master set), kommer kolonnen Udgave (Normal / Reverse Holo) til sidst. */
  function csvFelt(v) {
    v = String(v == null ? '' : v);
    if (v.indexOf(';') > -1 || v.indexOf('"') > -1 || v.indexOf('\n') > -1) {
      v = '"' + v.replace(/"/g, '""') + '"';
    }
    return v;
  }
  function downloadCsv(binder, slots) {
    var udgKol = slots.some(erRh);
    var linjer = ['Titel;Sæt;Nummer;Har;Antal' + (udgKol ? ';Udgave' : '')];
    slots.forEach(function (s) {
      var felter = [
        csvFelt(s.title),
        csvFelt(s.set_name || ''),
        csvFelt(s.number || ''),
        s.har ? 'Ja' : 'Nej',
        s.antal > 1 ? s.antal : 1
      ];
      if (udgKol) felter.push(erRh(s) ? 'Reverse Holo' : 'Normal');
      linjer.push(felter.join(';'));
    });
    downloadFil(binder.name + '.csv', '﻿' + linjer.join('\r\n'), 'text/csv');
    toast('CSV downloadet — ' + slots.length + ' kort');
  }

  /* Deck-liste (.txt): "<antal> <titel> [<sæt> <nummer>]" — alle kort; RH-lommer som "<titel> (Reverse Holo)" */
  function downloadDeck(binder, slots) {
    var linjer = slots.map(function (s) {
      var antal = s.antal > 1 ? s.antal : 1;
      var hale = '';
      if (s.set_name || s.number) {
        hale = ' [' + trimF((s.set_name || '') + ' ' + (s.number || '')) + ']';
      }
      return antal + ' ' + rhTitel(s) + hale;
    });
    downloadFil(binder.name + '-deckliste.txt', linjer.join('\n') + '\n', 'text/plain');
    toast('Deck-liste downloadet');
  }

  /* Slots til eksport: brug den åbne binders levende kopi, ellers hent */
  function hentSlotsTil(binderId) {
    if (aktivBinder && String(aktivBinder.id) === String(binderId)) {
      return Promise.resolve(aktivSlots);
    }
    return hent(PROXY + '?binder=' + encodeURIComponent(binderId)).then(function (d) {
      return (d && d.slots) || [];
    });
  }

  /* ---------- 5.0 Fortryd-toasten: ink-bar m. gul Fortryd-knap ---------- */
  function visFortryd(tekst, paaFortryd) {
    var gammel = document.querySelector('[data-mtwb2-fortryd]');
    if (gammel) gammel.remove();
    clearTimeout(fortrydT);
    var bar = document.createElement('div');
    bar.className = 'mtwb2__fortryd';
    bar.setAttribute('data-mtwb2-fortryd', '');
    bar.setAttribute('role', 'status');
    bar.innerHTML = '<span class="mtwb2__fortryd-tekst">' + esc(tekst) + '</span>' +
      '<button type="button" class="mtwb2__fortryd-knap" data-fortryd-knap>Fortryd</button>';
    (rod || document.body).appendChild(bar);
    function vaek() {
      clearTimeout(fortrydT);
      if (bar.parentNode) bar.parentNode.removeChild(bar);
    }
    bar.querySelector('[data-fortryd-knap]').addEventListener('click', function () {
      vaek();
      paaFortryd();
    });
    fortrydT = setTimeout(vaek, 5200);
  }

  /* Genopret et fjernet slot (best effort): pk-kort via tilfoej_slot,
     placeholders via tilfoej_placeholder — har/antal følger med bagefter. */
  function genopretSlot(binderId, s) {
    var basis;
    if (erPlaceholder(s)) {
      basis = post({ action: 'tilfoej_placeholder', binder_id: binderId, titel: s.title || 'Eget kort', saet: s.set_name || '', nummer: s.number || '' })
        .then(function (d) {
          if (!(d && d.ok && d.slot)) throw new Error('ph');
          if (s.har) return post({ action: 'toggle', binder_id: binderId, slot_id: d.slot.id, har: true }).then(function () { return d.slot.id; });
          return d.slot.id;
        });
    } else {
      var gen = { action: 'tilfoej_slot', binder_id: binderId, pk_card_id: s.pk_card_id, har: !!s.har, sort_key: s.sort_key };
      if (erRh(s)) gen.udgave = 'rh'; /* master set: RH-lommen kommer tilbage som RH */
      basis = post(gen)
        .then(function (d) {
          if (!(d && (d.ok || d.slot_id))) throw new Error('slot');
          return d.slot_id;
        });
    }
    basis.then(function (slotId) {
      var faerdig = (s.antal > 1 && slotId)
        ? post({ action: 'antal', binder_id: binderId, slot_id: slotId, antal: s.antal })
        : Promise.resolve(null);
      faerdig.then(function () {
        toast('"' + (s.title ? rhTitel(s) : 'Kortet') + '" er tilbage');
        if (aktivBinder && String(aktivBinder.id) === String(binderId)) visDetalje(binderId);
      });
    }).catch(function () {
      toast('Kunne ikke genoprette kortet — prøv at tilføje det igen');
    });
  }

  /* ---------- 5.0 Rediger detaljer: navn + beskrivelse (max 280 tegn) ---------- */
  function aabnRediger(binder, efter) {
    fjernLoseModaler();
    var bag = document.createElement('div');
    bag.className = 'mtwb2__modal-bag';
    bag.innerHTML =
      '<div class="mtwb2__modal" role="dialog" aria-modal="true" aria-label="Rediger detaljer">' +
      '<button type="button" class="mtwb2__modal-luk" data-red-luk aria-label="Luk">✕</button>' +
      '<h3>' + mtwIkon('blyant') + ' Rediger detaljer</h3>' +
      '<label class="mtwb2__red-label">Navn' +
      '<input class="mtwb2__soeg" data-red-navn type="text" maxlength="80" value="' + esc(binder.name) + '">' +
      '</label>' +
      '<label class="mtwb2__red-label">Beskrivelse <small>(vises i galleriet og på delte links)</small>' +
      '<textarea class="mtwb2__red-tekst" data-red-tekst maxlength="280" rows="4" placeholder="Fortæl kort om samlingen — fx hvad du jagter lige nu">' + esc(binder.beskrivelse || '') + '</textarea>' +
      '</label>' +
      '<div class="mtwb2__red-taeller"><span data-red-taeller></span> / 280</div>' +
      '<div style="margin-top:14px;text-align:right"><button type="button" class="mtwb2__knap mtwb2__knap--lille" data-red-gem>Gem</button></div>' +
      '</div>';
    (rod || document.body).appendChild(bag);
    var navnEl = bag.querySelector('[data-red-navn]');
    var tekstEl = bag.querySelector('[data-red-tekst]');
    var taellerEl = bag.querySelector('[data-red-taeller]');
    function opdaterT() { taellerEl.textContent = tekstEl.value.length; }
    opdaterT();
    tekstEl.addEventListener('input', opdaterT);
    function lukRed() { bag.remove(); }
    bag.addEventListener('click', function (e) { if (e.target === bag) lukRed(); });
    bag.querySelector('[data-red-luk]').addEventListener('click', lukRed);
    bag.querySelector('[data-red-gem]').addEventListener('click', function () {
      var navn = trimF(navnEl.value);
      if (!navn) { toast('Binderen skal have et navn'); return; }
      var beskrivelse = trimF(tekstEl.value).slice(0, 280);
      post({ action: 'rediger', binder_id: binder.id, navn: navn, beskrivelse: beskrivelse }).then(function (d) {
        if (d && d.ok) {
          binder.name = navn;
          binder.beskrivelse = beskrivelse;
          galleriData = null; /* beskrivelsen kan ses i galleriet */
          lukRed();
          toast('Gemt ✓');
          if (efter) efter();
        } else {
          toast((d && d.fejl) || (d && d.error) || 'Kunne ikke gemme — prøv igen');
        }
      }).catch(function () { toast('Kunne ikke gemme — tjek forbindelsen'); });
    });
    setTimeout(function () { navnEl.focus(); }, 60);
  }

  /* ---------- 5.0 Burger-menuen (⋮): handlinger pr. binder.
     Bruges BÅDE fra hylde-tiles og inde i binder-visningen. Renders som
     bund-ark på mobil / centreret modal på desktop (samme modal-mønster). ---------- */
  function aabnBinderMenu(binder, kontekst) {
    fjernLoseModaler();
    var iGalleri = !!binder.public_listed;
    var format = binder.lomme_format || 9;
    var raekker =
      '<button type="button" class="mtwb2__bm-rk" data-bm="galleri">' + mtwIkon('globus') +
      '<span><b>' + (iGalleri ? 'Fjern fra galleriet' : 'Offentliggør i galleriet') + '</b>' +
      '<small>Din samling kan ses af alle i galleriet — uden navn</small></span>' +
      '<span class="mtwb2__bm-tilstand' + (iGalleri ? ' mtwb2__bm-tilstand--til' : '') + '">' + (iGalleri ? 'TIL' : 'FRA') + '</span></button>' +
      '<button type="button" class="mtwb2__bm-rk" data-bm="rediger">' + mtwIkon('blyant') + '<span><b>Rediger detaljer</b><small>Navn og beskrivelse</small></span></button>' +
      '<button type="button" class="mtwb2__bm-rk" data-bm="dupliker">' + mtwIkon('kopi') + '<span><b>Duplikér</b><small>Ny binder med alle kortene</small></span></button>' +
      '<button type="button" class="mtwb2__bm-rk" data-bm="delelink">' + mtwIkon('link') + '<span><b>Få delelink</b><small>Privat link — kun dem du sender det til</small></span></button>' +
      '<button type="button" class="mtwb2__bm-rk" data-bm="csv">' + mtwIkon('download') + '<span><b>Download CSV</b><small>Titel, sæt, nummer, har, antal</small></span></button>' +
      '<button type="button" class="mtwb2__bm-rk" data-bm="deck">' + mtwIkon('liste') + '<span><b>Eksportér deck-liste</b><small>Tekstfil — alle kort</small></span></button>' +
      (kontekst === 'detalje'
        ? '<div class="mtwb2__bm-format"><span class="mtwb2__bm-format-label">' + mtwIkon('opslag') + ' Lommer pr. side</span>' +
          '<span class="mtwb2__bm-format-valg" role="group" aria-label="Lommer pr. side">' +
          [4, 9, 12].map(function (f) {
            return '<button type="button" data-bm-format="' + f + '" aria-pressed="' + (f === format ? 'true' : 'false') + '">' + f + '</button>';
          }).join('') + '</span></div>'
        : '') +
      '<button type="button" class="mtwb2__bm-rk mtwb2__bm-rk--slet" data-bm="slet">✕<span><b>Slet binderen</b><small>Kan ikke fortrydes</small></span></button>';
    var bag = document.createElement('div');
    bag.className = 'mtwb2__modal-bag mtwb2__modal-bag--bm';
    bag.innerHTML =
      '<div class="mtwb2__modal mtwb2__bm" role="dialog" aria-modal="true" aria-label="Binder-handlinger">' +
      '<button type="button" class="mtwb2__modal-luk" data-bm-luk aria-label="Luk">✕</button>' +
      '<h3>' + esc(binder.name) + '</h3>' +
      '<div class="mtwb2__bm-liste">' + raekker + '</div>' +
      '</div>';
    (rod || document.body).appendChild(bag);
    function lukBm() { bag.remove(); }
    bag.addEventListener('click', function (e) { if (e.target === bag) lukBm(); });
    bag.querySelector('[data-bm-luk]').addEventListener('click', lukBm);
    bag.querySelectorAll('[data-bm-format]').forEach(function (k) {
      k.addEventListener('click', function () {
        var f = parseInt(k.getAttribute('data-bm-format'), 10);
        post({ action: 'lomme_format', binder_id: binder.id, format: f }).then(function (d) {
          if (d && d.ok) {
            binder.lomme_format = f;
            if (aktivBinder && String(aktivBinder.id) === String(binder.id)) aktivBinder.lomme_format = f;
            bag.querySelectorAll('[data-bm-format]').forEach(function (x) {
              x.setAttribute('aria-pressed', x === k ? 'true' : 'false');
            });
            if (aktivTegnSider) aktivTegnSider();
            toast(f + ' lommer pr. side');
          } else toast('Kunne ikke skifte format — prøv igen');
        }).catch(function () { toast('Kunne ikke skifte format — tjek forbindelsen'); });
      });
    });
    bag.querySelectorAll('[data-bm]').forEach(function (k) {
      k.addEventListener('click', function () {
        var hvad = k.getAttribute('data-bm');
        if (hvad === 'galleri') {
          k.disabled = true;
          post({ action: 'offentliggoer', binder_id: binder.id, til: !iGalleri }).then(function (d) {
            if (d && d.ok) {
              binder.public_listed = !iGalleri;
              galleriData = null; /* galleriet er ændret — hent igen næste gang */
              lukBm();
              toast(!iGalleri ? 'Binderen er nu i galleriet — uden dit navn' : 'Fjernet fra galleriet');
            } else {
              k.disabled = false;
              toast((d && d.fejl) || (d && d.error) || 'Kunne ikke opdatere — prøv igen');
            }
          }).catch(function () { k.disabled = false; toast('Kunne ikke opdatere — tjek forbindelsen'); });
          return;
        }
        if (hvad === 'rediger') {
          lukBm();
          aabnRediger(binder, function () {
            if (aktivBinder && String(aktivBinder.id) === String(binder.id)) visDetalje(binder.id);
            else visHylde();
          });
          return;
        }
        if (hvad === 'dupliker') {
          k.disabled = true;
          toast('Kopierer binderen …');
          post({ action: 'dupliker', binder_id: binder.id }).then(function (d) {
            if (d && d.ok && d.id) {
              lukBm();
              toast('Kopien er klar');
              visDetalje(d.id);
            } else {
              k.disabled = false;
              toast((d && d.fejl) || (d && d.error) || 'Kunne ikke kopiere — prøv igen');
            }
          }).catch(function () { k.disabled = false; toast('Kunne ikke kopiere — tjek forbindelsen'); });
          return;
        }
        if (hvad === 'delelink') {
          lukBm();
          aabnDeling(binder);
          return;
        }
        if (hvad === 'csv' || hvad === 'deck') {
          k.disabled = true;
          hentSlotsTil(binder.id).then(function (slots) {
            lukBm();
            if (!slots.length) { toast('Binderen er tom — intet at eksportere'); return; }
            if (hvad === 'csv') downloadCsv(binder, slots);
            else downloadDeck(binder, slots);
          }).catch(function () {
            k.disabled = false;
            toast('Kunne ikke hente kortene — prøv igen');
          });
          return;
        }
        if (hvad === 'slet') {
          if (!window.confirm('Slet "' + binder.name + '"? Det kan ikke fortrydes.')) return;
          lukBm();
          post({ action: 'slet', binder_id: binder.id }).then(visHylde);
        }
      });
    });
  }

  /* ---------- Data-lag: saet_liste + opdag + popularitet hentes ÉN gang,
     caches i sessionStorage (TTL 1 time) og deles af hylde-browser OG
     katalog-arkets sæt-vælger. Fejl nulstiller promiset, så næste kald
     prøver igen. ---------- */
  var CACHE_TTL = 3600000; /* 1 time */
  function cacheHent(noegle) {
    try {
      var c = JSON.parse(sessionStorage.getItem(noegle) || 'null');
      if (c && c.t && (Date.now() - c.t) < CACHE_TTL) return c.d;
    } catch (e) { /* privat browsing / korrupt */ }
    return null;
  }
  function cacheGem(noegle, d) {
    try { sessionStorage.setItem(noegle, JSON.stringify({ t: Date.now(), d: d })); } catch (e) { /* fuldt/privat */ }
  }
  var saetPromise = null;
  var opdagPromise = null;
  var kunstnerPromise = null;
  var popPromise = null;
  var popMap = null; /* {'set|swsh1': 3, ...} — kun 2+ samlere (serveren filtrerer) */
  function hentSaetListe() {
    if (saetPromise) return saetPromise;
    var c = cacheHent('mtwb2_c_saet2');
    if (c) { saetPromise = Promise.resolve(c); return saetPromise; }
    saetPromise = post({ action: 'saet_liste' }).then(function (d) {
      var s = (d && d.saet) || [];
      if (s.length) cacheGem('mtwb2_c_saet2', s);
      return s;
    }).catch(function () { saetPromise = null; return []; });
    return saetPromise;
  }
  function hentOpdag() {
    if (opdagPromise) return opdagPromise;
    var c = cacheHent('mtwb2_c_opdag2');
    if (c) { opdagPromise = Promise.resolve(c); return opdagPromise; }
    opdagPromise = post({ action: 'opdag' }).then(function (d) {
      d = d || {};
      if (d.nyeste || d.klassikere || d.jagte || d.kunstnere) cacheGem('mtwb2_c_opdag2', d);
      return d;
    }).catch(function () { opdagPromise = null; return {}; });
    return opdagPromise;
  }
  function hentKunstnere() {
    if (kunstnerPromise) return kunstnerPromise;
    kunstnerPromise = post({ action: 'kunstner_liste' }).then(function (d) {
      return (d && d.kunstnere) || [];
    }).catch(function () { kunstnerPromise = null; return []; });
    return kunstnerPromise;
  }
  /* 4.0 Social proof: popularitet → map, cachet 1 t (versioneret nøgle) */
  function hentPopularitet() {
    if (popPromise) return popPromise;
    var c = cacheHent('mtwb2_c_pop2');
    if (c) { popMap = c; popPromise = Promise.resolve(c); return popPromise; }
    popPromise = post({ action: 'popularitet' }).then(function (d) {
      var m = {};
      ((d && d.popularitet) || []).forEach(function (p) {
        if (p && p.type && p.key && p.samlere >= 2) m[p.type + '|' + p.key] = p.samlere;
      });
      cacheGem('mtwb2_c_pop2', m);
      popMap = m;
      return m;
    }).catch(function () { popPromise = null; popMap = popMap || {}; return {}; });
    return popPromise;
  }
  function toemBrowserCache() {
    saetPromise = null;
    opdagPromise = null;
    try {
      sessionStorage.removeItem('mtwb2_c_saet2');
      sessionStorage.removeItem('mtwb2_c_opdag2');
    } catch (e) { /* privat browsing */ }
  }

  /* ---------- Hylden ---------- */
  var FARVE_NAVNE = ['gul', 'blaa', 'roed', 'groen', 'lilla', 'pink', 'orange', 'turkis', 'graa', 'ink'];
  var hyldeBinders = [];

  function sidsteBinder() {
    try { return JSON.parse(localStorage.getItem('mtwb2_sidste') || 'null'); } catch (e) { return null; }
  }

  function visHylde() {
    paaEscape = null;
    laasScroll(false);
    detalje.hidden = true;
    hylde.hidden = false;
    aktivBinder = null;
    udgaveBinderId = null; /* næste åbning af en binder starter med begge udgaver */
    /* Performance: browser-data affyres PARALLELT med hylde-GET'et */
    var pSaet = hentSaetListe();
    var pOpdag = hentOpdag();
    var pPop = hentPopularitet();
    hent(PROXY).then(function (d) {
      var binders = (d && d.binders) || [];
      hyldeBinders = binders;
      var html = binders.map(function (b) {
        var pct = b.total > 0 ? Math.round((b.har / b.total) * 100) : 0;
        var krop;
        if (b.kind === 'oensker') {
          /* Ønsker-mappen: fast inventar — ingen completion, kun antal ønsker */
          krop = '<span class="mtwb2__binder-navn">' + esc(b.name) + '</span>' +
            '<span class="mtwb2__meta">' + (b.total > 0 ? '<b>' + b.total + ' kort</b> på ønskelisten' : 'Kort du drømmer om — samlet ét sted') + '</span>' +
            '<span class="mtwb2__meta">Besked ved lager kommer snart</span>';
        } else if (b.total === 0) {
          krop = '<span class="mtwb2__binder-navn">' + esc(b.name) + '</span>' +
            '<span class="mtwb2__meta">Tom binder — føj dine første kort til</span>';
        } else {
          krop = '<span class="mtwb2__binder-navn">' + esc(b.name) + '</span>' +
            '<span class="mtwb2__cbar' + (pct >= 100 ? ' mtwb2__cbar--fuld' : '') + '"><i style="width:' + pct + '%"></i></span>' +
            '<span class="mtwb2__meta">' + (b.har === 0 ? b.total + ' kort — begynd at stemple ✓' : b.har + ' af ' + b.total + ' kort · ' + pct + ' %') + '</span>' +
            /* 4.0 Binder-værdi: vejledende Cardmarket-sum for det du HAR */
            (b.har_vaerdi > 0 ? '<span class="mtwb2__meta mtwb2__meta--vaerdi" title="Vejledende Cardmarket-værdi">≈ ' + fmtKr(b.har_vaerdi) + ' kr</span>' : '');
        }
        var traek = b.kind === 'oensker' ? '' : ' draggable="true"';
        var farve = b.farve ? ' mtwb2__farve--' + esc(b.farve) : '';
        /* 4.0 Achievements: guld-medalje på fuldførte binders */
        var medalje = (b.kind !== 'oensker' && b.total > 0 && pct >= 100)
          ? '<span class="mtwb2__hylde-medalje" title="100 % fuldført" aria-hidden="true">' + mtwIkon('medalje') + '</span>'
          : '';
        /* 5.0 Burger-menu (⋮) pr. binder — span m. role=button (aldrig
           button-i-button); Ønsker-mappen har ingen menu */
        var tileMenu = b.kind === 'oensker' ? '' :
          '<span class="mtwb2__tile-menu" data-tile-menu role="button" tabindex="0" title="Flere handlinger" aria-label="Flere handlinger for ' + esc(b.name) + '">' + mtwIkon('prikker') + '</span>';
        return '<button type="button" class="mtwb2__binder mtwb2__binder--' + esc(b.kind) + farve + '" data-binder="' + esc(b.id) + '"' + traek + '>' +
          '<span class="mtwb2__binder-spine" aria-hidden="true"><i></i><i></i><i></i></span>' +
          tileMenu +
          medalje +
          '<span class="mtwb2__binder-ryg" aria-hidden="true">' + mtwIkon(b.cover || 'dex') + '</span>' +
          '<span class="mtwb2__binder-krop">' + krop + '</span></button>';
      }).join('');
      html += '<button type="button" class="mtwb2__binder mtwb2__binder--ny" data-mtwb2-ny>＋&nbsp; Ny binder</button>';
      liste.innerHTML = html;
      liste.querySelectorAll('[data-binder]').forEach(function (el) {
        function aabnTileMenu() {
          var bid = el.getAttribute('data-binder');
          var bObj = null;
          hyldeBinders.forEach(function (b) { if (String(b.id) === String(bid)) bObj = b; });
          if (bObj) aabnBinderMenu(bObj, 'hylde');
        }
        el.addEventListener('click', function (e) {
          if (e.target.closest && e.target.closest('[data-tile-menu]')) {
            e.stopPropagation();
            aabnTileMenu();
            return;
          }
          visDetalje(el.getAttribute('data-binder'));
        });
        el.addEventListener('keydown', function (e) {
          if ((e.key !== 'Enter' && e.key !== ' ') || !e.target.closest) return;
          if (!e.target.closest('[data-tile-menu]')) return;
          e.preventDefault();
          e.stopPropagation();
          aabnTileMenu();
        });
      });
      liste.querySelector('[data-mtwb2-ny]').addEventListener('click', aabnOpret);
      bindTraek();
      visFortsaet(binders);
      visOverblik(binders);
      visGalleri();
      return binders;
    }).catch(function () {
      liste.innerHTML = '<div class="mtwb2__tom">Kunne ikke hente dine binders lige nu.<br><br><button type="button" class="mtwb2__knap mtwb2__knap--lille" data-igen>Prøv igen</button></div>';
      liste.querySelector('[data-igen]').addEventListener('click', visHylde);
      return null;
    }).then(function (binders) {
      /* Browser + NYT-banner tegnes når data er inde — uafhængigt af GET-fejl.
         popularitet afventes også (resolver altid), så samler-badges er med
         fra første paint. */
      pSaet.then(function (saet) {
        if (binders) visNytBanner(saet, binders);
        pOpdag.then(function (opdag) {
          pPop.then(function () { renderBrowser(saet, opdag); });
        });
      });
    });
  }

  /* ---------- Overblik-strippen: samler-dashboardet. Regnes 100 % client-
     side fra binders-listen (ingen ekstra API-kald). Ét hero-øjeblik:
     ringen fylder + kort-tallet tæller op ved første paint. ---------- */
  function visOverblik(binders) {
    if (!overblik) return;
    var samlinger = binders.filter(function (b) { return b.kind !== 'oensker'; });
    var har = 0;
    var total = 0;
    var vaerdi = 0; /* 4.0: samlingens vejledende værdi */
    samlinger.forEach(function (b) {
      har += b.har || 0;
      total += b.total || 0;
      vaerdi += b.har_vaerdi || 0;
    });
    if (!total) { overblik.hidden = true; overblik.innerHTML = ''; return; }
    var pct = Math.round((har / total) * 100);
    var kvKnap = overblik.getAttribute('data-mtwb2-kv') === '1' && total - har > 0;
    var OMKREDS = 163.36; /* 2 * PI * 26 */
    overblik.hidden = false;
    overblik.setAttribute('aria-label', 'Dit overblik: ' + har + ' af ' + total + ' kort stemplet, ' + pct + ' procent samlet, ' + samlinger.length + (samlinger.length === 1 ? ' binder' : ' binders') + (vaerdi > 0 ? ', samling cirka ' + fmtKr(vaerdi) + ' kroner (vejledende Cardmarket-værdi)' : ''));
    overblik.innerHTML =
      '<svg class="mtwb2__ring' + (pct >= 100 ? ' mtwb2__ring--fuld' : '') + '" viewBox="0 0 64 64" aria-hidden="true" focusable="false">' +
      '<circle class="mtwb2__ring-spor" cx="32" cy="32" r="26"/>' +
      '<circle class="mtwb2__ring-fyld" cx="32" cy="32" r="26" stroke-dasharray="' + OMKREDS + '" stroke-dashoffset="' + OMKREDS + '" data-ring/>' +
      '<text class="mtwb2__ring-tal" x="32" y="36.5">' + pct + ' %</text>' +
      '<text class="mtwb2__ring-label" x="32" y="46">samlet</text></svg>' +
      '<div class="mtwb2__overblik-statter">' +
      '<span class="mtwb2__ostat"><b data-o-har>' + (REDUCERET ? har : 0) + '</b><small>kort stemplet</small></span>' +
      '<span class="mtwb2__ostat"><b>' + (total - har) + '</b><small>mangler endnu</small></span>' +
      '<span class="mtwb2__ostat"><b>' + samlinger.length + '</b><small>' + (samlinger.length === 1 ? 'binder' : 'binders') + '</small></span>' +
      /* 4.0 Binder-værdi: fjerde stat — vejledende Cardmarket-sum */
      (vaerdi > 0 ? '<span class="mtwb2__ostat" title="Vejledende Cardmarket-værdi"><b>≈ ' + fmtKr(vaerdi) + ' kr</b><small>samling</small></span>' : '') +
      '</div>' +
      /* Kort-vælgeren-indgang 6: kun når sektionen har givet flaget (tema-indstilling) og der mangler kort */
      (kvKnap ? '<a class="mtwkv-mangler" data-mtwkv="samlinger" href="/pages/byg-samling?mangler=1"><span class="mtwkv-mangler__t">Køb dine manglende kort <span aria-hidden="true">→</span></span><span class="mtwkv-mangler__sub">Se hvad vi har på lager</span></a>' : '');
    overblik.className = overblik.className.replace(/\s*\bmtwkv-har-knap\b/, '') + (kvKnap ? ' mtwkv-har-knap' : '');
    var ring = overblik.querySelector('[data-ring]');
    var maal = OMKREDS * (1 - Math.min(pct, 100) / 100);
    if (REDUCERET) {
      ring.style.strokeDashoffset = maal;
      return;
    }
    /* dobbelt rAF: første frame maler 0 %, anden sætter målet → CSS-transition fylder */
    requestAnimationFrame(function () {
      requestAnimationFrame(function () { ring.style.strokeDashoffset = maal; });
    });
    var harEl = overblik.querySelector('[data-o-har]');
    var start = null;
    function trin(t) {
      if (start === null) start = t;
      var k = Math.min((t - start) / 700, 1);
      k = 1 - Math.pow(1 - k, 3); /* ease-out */
      harEl.textContent = Math.round(har * k);
      if (k < 1) requestAnimationFrame(trin);
    }
    requestAnimationFrame(trin);
  }

  /* "Fortsæt hvor du slap": senest åbnede binder som bar over hylden */
  function visFortsaet(binders) {
    var gammel = hylde.querySelector('.mtwb2__fortsaet');
    if (gammel) gammel.remove();
    var sidste = sidsteBinder();
    if (!sidste) return;
    var match = null;
    binders.forEach(function (b) { if (b.id === sidste.id) match = b; });
    if (!match || match.total === 0) return;
    var bar = document.createElement('button');
    bar.type = 'button';
    bar.className = 'mtwb2__fortsaet';
    bar.innerHTML = '<span class="mtwb2__fortsaet-ikon" aria-hidden="true">' + mtwIkon('mappe') + '</span> <span>Fortsæt hvor du slap: <b>' + esc(match.name) + '</b></span> <span class="mtwb2__fortsaet-pil" aria-hidden="true">→</span>';
    hylde.insertBefore(bar, overblik || liste);
    bar.addEventListener('click', function () { visDetalje(match.id); });
  }

  /* NYT-banner: nyeste sæt (< 45 dage, ingen binder endnu) — ét tryk = binder */
  function visNytBanner(saet, binders) {
    var gammel = hylde.querySelector('.mtwb2__nytsaet');
    if (gammel) gammel.remove();
    var nyeste = saet && saet[0];
    if (!nyeste) return;
    var harAllerede = binders.some(function (b) {
      return b.template && b.template.type === 'set' && b.template.key === nyeste.set_id;
    });
    var dageSiden = nyeste.released ? (Date.now() - new Date(nyeste.released).getTime()) / 86400000 : 999;
    if (harAllerede || dageSiden < 0 || dageSiden > 45) return;
    var banner = document.createElement('button');
    banner.type = 'button';
    banner.className = 'mtwb2__nytsaet';
    banner.innerHTML = '<span class="mtwb2__nytsaet-badge">NYT</span> <span><b>' + esc(nyeste.set_name) + '</b> er landet — opret binderen med ét tryk</span> <span aria-hidden="true">→</span>';
    hylde.insertBefore(banner, hylde.querySelector('.mtwb2__fortsaet') || overblik || liste);
    banner.addEventListener('click', function () {
      opret('set', nyeste.set_id, nyeste.set_name || '', banner); /* navnet står i master set-valget */
    });
  }

  /* ---------- 5.0 "Udforsk samlinger": offentligt galleri under hylden.
     Samme fysiske binder-æstetik som egne tiles — klik åbner den
     eksisterende offentlige visning (?offentlig=token-vejen). Tomt
     galleri eller fejl → sektionen skjules helt (fail-soft). ---------- */
  function visGalleri() {
    var holder = document.querySelector('[data-mtwb2-galleri]');
    if (!holder) return;
    function tegn(g) {
      if (!g || !g.length) { holder.hidden = true; holder.innerHTML = ''; return; }
      holder.innerHTML =
        '<div class="mtwb2__browser-hoved">' +
        '<h2>' + mtwIkon('globus') + ' Udforsk samlinger</h2>' +
        '<p class="mtwb2__sub">Offentlige binders fra andre samlere — kig med, og lad dig inspirere.</p>' +
        '</div>' +
        '<div class="mtwb2__hylde mtwb2__hylde--galleri">' +
        g.map(function (b) {
          var pct = b.pct != null ? Math.round(b.pct) : (b.total > 0 ? Math.round((b.har / b.total) * 100) : 0);
          var farve = b.farve ? ' mtwb2__farve--' + esc(b.farve) : '';
          var besk = trimF(b.beskrivelse || '');
          if (besk.length > 90) besk = besk.slice(0, 88) + '…';
          return '<button type="button" class="mtwb2__binder mtwb2__binder--galleri' + farve + '" data-gal-token="' + esc(b.token) + '" aria-label="' + esc(b.navn) + ' — åbn den delte samling">' +
            '<span class="mtwb2__binder-spine" aria-hidden="true"><i></i><i></i><i></i></span>' +
            '<span class="mtwb2__binder-ryg" aria-hidden="true">' + mtwIkon(b.cover || 'dex') + '</span>' +
            '<span class="mtwb2__binder-krop">' +
            '<span class="mtwb2__binder-navn">' + esc(b.navn) + '</span>' +
            (b.total > 0
              ? '<span class="mtwb2__cbar' + (pct >= 100 ? ' mtwb2__cbar--fuld' : '') + '"><i style="width:' + pct + '%"></i></span>' +
                '<span class="mtwb2__meta">' + b.har + ' af ' + b.total + ' kort · ' + pct + ' %</span>'
              : '<span class="mtwb2__meta">Ny samling på vej</span>') +
            (besk ? '<span class="mtwb2__meta mtwb2__meta--besk">' + esc(besk) + '</span>' : '') +
            '</span></button>';
        }).join('') +
        '</div>';
      holder.hidden = false;
      holder.querySelectorAll('[data-gal-token]').forEach(function (el) {
        el.addEventListener('click', function () {
          visOffentlig(el.getAttribute('data-gal-token'), true);
        });
      });
    }
    if (galleriData) { tegn(galleriData); return; }
    hent(PROXY + '?galleri=1').then(function (d) {
      galleriData = (d && d.galleri) || [];
      tegn(galleriData);
    }).catch(function () {
      holder.hidden = true;
      holder.innerHTML = '';
    });
  }

  /* Træk-og-slip-sortering (desktop) — gemmes server-side pr. kunde */
  function bindTraek() {
    var trak = null;
    liste.querySelectorAll('[data-binder][draggable]').forEach(function (el) {
      el.addEventListener('dragstart', function (e) {
        trak = el;
        el.classList.add('mtwb2__binder--traek');
        if (e.dataTransfer) e.dataTransfer.effectAllowed = 'move';
      });
      el.addEventListener('dragend', function () {
        el.classList.remove('mtwb2__binder--traek');
        trak = null;
      });
      el.addEventListener('dragover', function (e) {
        if (!trak || trak === el) return;
        e.preventDefault();
        var r = el.getBoundingClientRect();
        var foer = e.clientX < r.left + r.width / 2;
        el.parentNode.insertBefore(trak, foer ? el : el.nextSibling);
      });
      el.addEventListener('drop', function (e) { e.preventDefault(); gemSortering(); });
    });
    liste.addEventListener('drop', function (e) { e.preventDefault(); });
    liste.addEventListener('dragover', function (e) { if (trak) e.preventDefault(); });
  }
  function gemSortering() {
    var ids = [];
    liste.querySelectorAll('[data-binder][draggable]').forEach(function (el) { ids.push(el.getAttribute('data-binder')); });
    if (ids.length) post({ action: 'sortering', ids: ids }).then(function (d) {
      if (d && d.ok) toast('Rækkefølgen er gemt ✓');
    });
  }

  /* ---------- "Start en ny samling"-browseren: Pokellector-loopet.
     Sæt som VISUELT grid (chase-kortet som artwork, completion-bar på de
     binders du allerede har) + søg-først-faner for Pokémon og Illustrator.
     4.0: social proof-badge ("X samlere bygger dette") på tiles. ---------- */
  var aktivFane = 'saet';
  var visAlleSaet = false;
  var bSaet = [];
  var bOpdag = {};

  function stort(s) { return s ? s.charAt(0).toUpperCase() + s.slice(1) : s; }

  function binderNoegler(type) {
    var m = {};
    hyldeBinders.forEach(function (b) {
      if (b.template && b.template.type === type && b.template.key) m[b.template.key] = b;
    });
    return m;
  }

  /* Bar-fyld ved første paint: bredder sættes efter dobbelt rAF, så CSS-
     transitionen animerer 0 → pct. Reduced motion: transition er slået fra. */
  function fyldBarer(rodEl) {
    var barer = rodEl.querySelectorAll('[data-b-pct]');
    if (!barer.length) return;
    requestAnimationFrame(function () {
      requestAnimationFrame(function () {
        for (var i = 0; i < barer.length; i++) {
          barer[i].style.width = barer[i].getAttribute('data-b-pct') + '%';
        }
      });
    });
  }

  function tileHtml(type, key, navn, meta, img, binder, logo) {
    var pct = binder && binder.total > 0 ? Math.round((binder.har / binder.total) * 100) : 0;
    var art = img
      ? '<img src="' + esc(img) + '" alt="" loading="lazy" width="140" height="196">'
      : mtwIkon('stak');
    var fod;
    if (binder) {
      fod = '<span class="mtwb2__cbar mtwb2__cbar--mini' + (pct >= 100 ? ' mtwb2__cbar--fuld' : '') + '"><i style="width:0%" data-b-pct="' + pct + '"></i></span>' +
        '<small class="mtwb2__stile-frem">' + binder.har + ' af ' + binder.total + ' · <b>Åbn →</b></small>';
    } else {
      fod = '<span class="mtwb2__stile-cta">＋ Opret binder</span>';
    }
    /* 4.0 Social proof: "X samlere bygger dette" (serveren viser kun 2+) */
    var samlere = popMap ? popMap[type + '|' + key] : null;
    var proof = samlere
      ? '<small class="mtwb2__samlere">' + mtwIkon('flamme') + ' ' + samlere + ' samlere bygger dette</small>'
      : '';
    return '<button type="button" class="mtwb2__stile' + (binder ? ' mtwb2__stile--min' : '') + '" data-st-type="' + esc(type) + '" data-st-key="' + esc(key) + '"' +
      (binder ? ' data-st-binder="' + esc(binder.id) + '"' : '') +
      ' aria-label="' + esc(navn) + (binder ? ' — åbn din binder' : ' — opret binder') + '">' +
      '<span class="mtwb2__stile-art" aria-hidden="true">' + art +
      (binder && pct >= 100 ? '<span class="mtwb2__stile-badge">Fuldført ✓</span>' : '') +
      '</span>' +
      '<span class="mtwb2__stile-info">' +
      /* 5.0 Sæt-logo over navnet — onerror fjerner billedet stille */
      (logo ? '<img class="mtwb2__stile-logo" src="' + esc(logo) + '" alt="" loading="lazy" onerror="this.parentNode&amp;&amp;this.parentNode.removeChild(this)">' : '') +
      '<b>' + esc(navn) + '</b><small>' + esc(meta) + '</small>' + proof + fod + '</span>' +
      '</button>';
  }

  function rkHtml(type, key, navn, meta, binder) {
    return '<button type="button" class="mtwb2__l-rk" data-st-type="' + esc(type) + '" data-st-key="' + esc(key) + '"' +
      (binder ? ' data-st-binder="' + esc(binder.id) + '"' : '') + '>' +
      '<span><b>' + esc(navn) + '</b>' + (meta ? '<small>' + esc(meta) + '</small>' : '') + '</span>' +
      '<span class="mtwb2__l-opret">' + (binder ? 'Åbn →' : 'Opret →') + '</span></button>';
  }

  function bindTiles(rodEl) {
    rodEl.querySelectorAll('[data-st-type]').forEach(function (t) {
      t.addEventListener('click', function () {
        var bid = t.getAttribute('data-st-binder');
        if (bid) { visDetalje(bid); return; }
        t.disabled = true;
        var navnEl = t.querySelector('b'); /* vises i master set-valget; serveren navngiver selv sæt-binders */
        opret(t.getAttribute('data-st-type'), t.getAttribute('data-st-key'), navnEl ? navnEl.textContent : '', t);
      });
    });
  }

  function renderBrowser(saet, opdag) {
    if (!browserKrop) return;
    bSaet = saet || [];
    bOpdag = opdag || {};
    var faner = [
      { id: 'saet', navn: 'Sæt' },
      { id: 'pokemon', navn: 'Pokémon' },
      { id: 'artist', navn: 'Illustrator' }
    ];
    browserKrop.innerHTML =
      '<div class="mtwb2__seg mtwb2__seg--browser" role="group" aria-label="Vælg hvad du vil samle på">' +
      faner.map(function (f) {
        return '<button type="button" class="mtwb2__seg-knap" data-b-fane="' + f.id + '" aria-pressed="' + (aktivFane === f.id ? 'true' : 'false') + '">' + f.navn + '</button>';
      }).join('') +
      '</div>' +
      '<div data-b-panel></div>';
    browserKrop.querySelectorAll('[data-b-fane]').forEach(function (k) {
      k.addEventListener('click', function () {
        aktivFane = k.getAttribute('data-b-fane');
        browserKrop.querySelectorAll('[data-b-fane]').forEach(function (x) {
          x.setAttribute('aria-pressed', x === k ? 'true' : 'false');
        });
        renderPanel();
      });
    });
    renderPanel();
  }

  function renderPanel() {
    var panel = browserKrop.querySelector('[data-b-panel]');
    if (!panel) return;
    if (aktivFane === 'saet') renderFaneSaet(panel);
    else if (aktivFane === 'pokemon') renderFanePokemon(panel);
    else renderFaneIllustrator(panel);
  }

  /* Sæt-fanen: det visuelle grid — Pokellector-følelsen */
  function renderFaneSaet(panel) {
    if (!bSaet.length) {
      panel.innerHTML = '<div class="mtwb2__tom">Kunne ikke hente sættene lige nu.<br><br><button type="button" class="mtwb2__knap mtwb2__knap--lille" data-b-igen>Prøv igen</button></div>';
      panel.querySelector('[data-b-igen]').addEventListener('click', function () {
        toemBrowserCache();
        panel.innerHTML = '<div class="mtwb2__stiler">' + skeletTiles(6) + '</div>';
        hentSaetListe().then(function (s) {
          hentOpdag().then(function (o) { renderBrowser(s, o); });
        });
      });
      return;
    }
    var mine = binderNoegler('set');
    /* Chase-artwork på ALLE sæt: saet_liste bærer nu chase_img pr. sæt;
       opdag-data supplerer som fallback. */
    var chase = {};
    (bOpdag.nyeste || []).concat(bOpdag.klassikere || []).forEach(function (s) {
      if (s.set_id && s.chase_img) chase[s.set_id] = s.chase_img;
    });
    bSaet.forEach(function (s) {
      if (s.set_id && s.chase_img) chase[s.set_id] = s.chase_img;
    });
    panel.innerHTML =
      '<input class="mtwb2__b-filter" data-b-filter type="search" placeholder="Find et sæt — fx 151, Prismatic, Base …" autocomplete="off" aria-label="Filtrér sæt">' +
      '<div class="mtwb2__stiler" data-b-grid></div>';
    var gridEl = panel.querySelector('[data-b-grid]');
    var filterEl = panel.querySelector('[data-b-filter]');
    function tegn(q) {
      q = (q || '').toLowerCase();
      var vis = bSaet.filter(function (s) { return !q || String(s.set_name).toLowerCase().indexOf(q) > -1; });
      var beskaaret = !q && !visAlleSaet && vis.length > 12;
      var rk = beskaaret ? vis.slice(0, 12) : vis.slice(0, 250);
      var html = rk.map(function (s) {
        var aar = s.released ? String(s.released).slice(0, 4) : '';
        return tileHtml('set', s.set_id, s.set_name, s.cards + ' kort' + (aar ? ' · ' + aar : ''), chase[s.set_id] || '', mine[s.set_id] || null, s.logo || '');
      }).join('');
      if (beskaaret) html += '<button type="button" class="mtwb2__knap mtwb2__knap--ghost mtwb2__b-mere" data-b-mere>Vis alle ' + bSaet.length + ' sæt</button>';
      gridEl.innerHTML = html || '<p class="mtwb2__b-note">Ingen sæt matcher "' + esc(q) + '" — prøv en kortere søgning.</p>';
      bindTiles(gridEl);
      var mere = gridEl.querySelector('[data-b-mere]');
      if (mere) mere.addEventListener('click', function () {
        visAlleSaet = true;
        tegn(filterEl.value.trim());
      });
      fyldBarer(gridEl);
    }
    filterEl.addEventListener('input', function () { tegn(filterEl.value.trim()); });
    tegn('');
  }

  /* Pokémon-fanen: søg-først + populære jagte som visuelle tiles */
  function renderFanePokemon(panel) {
    var mine = binderNoegler('pokemon');
    var jagte = bOpdag.jagte || [];
    panel.innerHTML =
      '<input class="mtwb2__b-filter" data-b-soeg type="search" placeholder="Skriv navnet — fx Charizard, Eevee, Umbreon …" autocomplete="off" aria-label="Søg Pokémon">' +
      '<div class="mtwb2__b-rk-liste" data-b-res aria-live="polite"></div>' +
      (jagte.length
        ? '<p class="mtwb2__b-label">' + mtwIkon('flamme') + ' Populære jagte lige nu</p>' +
          '<div class="mtwb2__stiler" data-b-grid>' +
          jagte.map(function (j) {
            return tileHtml('pokemon', j.navn, stort(j.navn), j.antal + ' kort', j.chase_img || '', mine[j.navn] || null);
          }).join('') + '</div>'
        : '');
    var grid = panel.querySelector('[data-b-grid]');
    if (grid) { bindTiles(grid); fyldBarer(grid); }
    var soeg = panel.querySelector('[data-b-soeg]');
    var res = panel.querySelector('[data-b-res]');
    var t;
    soeg.addEventListener('input', function () {
      clearTimeout(t);
      var q = soeg.value.trim();
      if (q.length < 3) {
        res.innerHTML = q ? '<p class="mtwb2__b-note">Skriv mindst 3 bogstaver — engelske navne.</p>' : '';
        return;
      }
      t = setTimeout(function () {
        res.innerHTML = '<p class="mtwb2__b-note">Søger …</p>';
        post({ action: 'soeg_skabelon', q: q }).then(function (d) {
          if (soeg.value.trim() !== q) return; /* forældet svar */
          var poke = ((d && d.forslag) || []).filter(function (f) { return f.type === 'pokemon'; });
          res.innerHTML = poke.map(function (f) {
            return rkHtml('pokemon', f.key, stort(f.key), f.antal + ' kort som slots', mine[f.key] || null);
          }).join('') || '<p class="mtwb2__b-note">Ingen Pokémon matcher "' + esc(q) + '" — tjek stavningen (engelske navne).</p>';
          bindTiles(res);
        });
      }, 300);
    });
  }

  /* Illustrator-fanen: søg-først + elskede illustratorer som visuelle tiles */
  function renderFaneIllustrator(panel) {
    var mine = binderNoegler('artist');
    var pop = bOpdag.kunstnere || [];
    panel.innerHTML =
      '<input class="mtwb2__b-filter" data-b-soeg type="search" placeholder="Find en illustrator — fx Arita, Komiya, Saitou …" autocomplete="off" aria-label="Søg illustrator">' +
      '<div class="mtwb2__b-rk-liste" data-b-res aria-live="polite"></div>' +
      (pop.length
        ? '<p class="mtwb2__b-label">' + mtwIkon('pensel') + ' Elskede illustratorer</p>' +
          '<div class="mtwb2__stiler" data-b-grid>' +
          pop.map(function (a) {
            return tileHtml('artist', a.navn, a.navn, a.antal + ' kort', a.chase_img || '', mine[a.navn] || null);
          }).join('') + '</div>'
        : '');
    var grid = panel.querySelector('[data-b-grid]');
    if (grid) { bindTiles(grid); fyldBarer(grid); }
    var soeg = panel.querySelector('[data-b-soeg]');
    var res = panel.querySelector('[data-b-res]');
    var alle = null;
    function tegn(q) {
      if (!q) { res.innerHTML = ''; return; }
      if (!alle) { res.innerHTML = '<p class="mtwb2__b-note">Henter illustratorer …</p>'; return; }
      var qq = q.toLowerCase();
      var vis = alle.filter(function (a) { return String(a.artist).toLowerCase().indexOf(qq) > -1; }).slice(0, 60);
      res.innerHTML = vis.map(function (a) {
        return rkHtml('artist', a.artist, a.artist, a.cards + ' kort' + (a.cards > 500 ? ' · binderen får de første 500' : ''), mine[a.artist] || null);
      }).join('') || '<p class="mtwb2__b-note">Ingen illustrator matcher "' + esc(q) + '".</p>';
      bindTiles(res);
    }
    soeg.addEventListener('input', function () {
      var q = soeg.value.trim();
      if (!alle) {
        hentKunstnere().then(function (k) {
          alle = k;
          tegn(soeg.value.trim());
        });
      }
      tegn(q);
    });
  }

  function skeletTiles(n) {
    var s = '';
    for (var i = 0; i < n; i++) s += '<div class="mtwb2__stile-skelet" aria-hidden="true"></div>';
    return s;
  }

  /* ---------- Opret ---------- */
  function aabnOpret() {
    opretModal.hidden = false;
    soegInput.value = '';
    forslagHolder.innerHTML = '';
    setTimeout(function () { soegInput.focus(); }, 60);
  }
  function lukOpret() { opretModal.hidden = true; }

  /* Master set-valget ved oprettelse af en sæt-samling: "Kun kortene"
     (N lommer) eller "Master set" (N + M lommer). Vises kun når sættet
     har Reverse Holo-kort; standard er "Kun kortene". */
  function lommerTekst(n) { return n + (n === 1 ? ' lomme' : ' lommer'); }
  function aabnMasterValg(type, key, navn, knap, n, m) {
    fjernLoseModaler();
    var valgt = 'normal';
    function opt(id, mini, titel, tekst, antal) {
      return '<button type="button" class="mtwb2__msv-opt" data-msv="' + id + '" role="radio" aria-checked="' + (id === valgt ? 'true' : 'false') + '" tabindex="' + (id === valgt ? '0' : '-1') + '">' +
        '<span class="mtwb2__ms-mini" aria-hidden="true">' + mini + '</span>' +
        '<span class="mtwb2__msv-tekst"><b>' + titel + '</b><small>' + tekst + '</small></span>' +
        '<span class="mtwb2__msv-tal">' + lommerTekst(antal) + '</span></button>';
    }
    var bag = document.createElement('div');
    bag.className = 'mtwb2__modal-bag';
    bag.innerHTML =
      '<div class="mtwb2__modal mtwb2__msv" role="dialog" aria-modal="true" aria-labelledby="mtwb2-msv-titel">' +
      '<button type="button" class="mtwb2__modal-luk" data-msv-luk aria-label="Luk">✕</button>' +
      '<h3 id="mtwb2-msv-titel">' + esc(navn || 'Ny sæt-samling') + '</h3>' +
      '<p class="mtwb2__sub">Hvad vil du samle?</p>' +
      '<div class="mtwb2__msv-valg" role="radiogroup" aria-label="Hvad vil du samle?">' +
      opt('normal', '<i></i>', 'Kun kortene', 'Ét af hvert kort i sættet', n) +
      opt('master', '<i></i><i class="mtwb2__ms-mini-rh"></i>', 'Master set', 'Hvert kort + dets Reverse Holo-udgave', n + m) +
      '</div>' +
      '<button type="button" class="mtwb2__knap mtwb2__msv-opret" data-msv-opret>Opret samlingen</button>' +
      '</div>';
    (rod || document.body).appendChild(bag);
    function annuller() {
      bag.remove();
      if (knap) {
        knap.disabled = false;
        knap.style.opacity = '';
        if (document.body.contains(knap)) { try { knap.focus(); } catch (eF) { /* gammel browser */ } }
      }
    }
    bag.addEventListener('click', function (e) { if (e.target === bag) annuller(); });
    bag.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape') return;
      e.stopPropagation(); /* luk kun valget, ikke opret-vinduet bagved */
      annuller();
    });
    bag.querySelector('[data-msv-luk]').addEventListener('click', annuller);
    var valg = bag.querySelectorAll('[data-msv]');
    function vaelg(k) {
      valgt = k.getAttribute('data-msv');
      valg.forEach(function (x) {
        x.setAttribute('aria-checked', x === k ? 'true' : 'false');
        x.setAttribute('tabindex', x === k ? '0' : '-1');
      });
    }
    valg.forEach(function (k, i) {
      k.addEventListener('click', function () { vaelg(k); });
      /* Radiogruppe: piletasterne flytter valget (og fokus) mellem de to muligheder */
      k.addEventListener('keydown', function (e) {
        var fr = e.key === 'ArrowDown' || e.key === 'ArrowRight' ? 1 : e.key === 'ArrowUp' || e.key === 'ArrowLeft' ? -1 : 0;
        if (!fr) return;
        e.preventDefault();
        var ny = valg[(i + fr + valg.length) % valg.length];
        vaelg(ny);
        ny.focus();
      });
    });
    bag.querySelector('[data-msv-opret]').addEventListener('click', function () {
      bag.remove();
      opret(type, key, navn, knap, valgt === 'master');
    });
    setTimeout(function () {
      var f = bag.querySelector('[data-msv="normal"]');
      if (f) f.focus();
    }, 60);
  }

  /* "Henter sættet …" på knappen, mens skabelon_info svarer: knappens egen "Opret"-tekst skiftes ud,
     ellers lægges en linje til. henter(knap, false) sætter knappen tilbage. */
  function henter(knap, til) {
    if (!knap) return;
    var mrk = knap.querySelector('.mtwb2__stile-cta, .mtwb2__l-opret');
    var ekstra = knap.querySelector('.mtwb2__henter');
    if (til) {
      knap.setAttribute('aria-busy', 'true');
      if (mrk) {
        if (mrk.__mtwb2Tekst == null) mrk.__mtwb2Tekst = mrk.textContent;
        mrk.textContent = 'Henter sættet …';
      } else if (!ekstra) {
        knap.insertAdjacentHTML('beforeend', '<span class="mtwb2__henter">Henter sættet …</span>');
      }
      return;
    }
    knap.removeAttribute('aria-busy');
    if (mrk && mrk.__mtwb2Tekst != null) { mrk.textContent = mrk.__mtwb2Tekst; mrk.__mtwb2Tekst = null; }
    if (ekstra) ekstra.remove();
  }

  function opret(type, key, navn, knap, master) {
    if (knap) { knap.disabled = true; knap.style.opacity = '0.6'; }
    /* Sæt-samling: spørg først om sættet har Reverse Holo-kort (skabelon_info).
       Svarer serveren ikke (ældre backend/fejl), oprettes som i dag. */
    if (type === 'set' && master === undefined) {
      henter(knap, true);
      toast('Henter sættet …');
      post({ action: 'skabelon_info', key: key }).then(function (d) {
        henter(knap, false);
        var n = d && typeof d.kort === 'number' ? d.kort : 0;
        var m = d && typeof d.rh === 'number' ? d.rh : 0;
        if (n > 0 && m > 0) aabnMasterValg(type, key, navn, knap, n, m);
        else opret(type, key, navn, knap, false);
      }).catch(function () { henter(knap, false); opret(type, key, navn, knap, false); });
      return;
    }
    toast('Bygger din binder …');
    var payload = { action: 'opret', type: type, key: key, navn: type === 'custom' ? (navn || '') : '' };
    if (master === true && type === 'set') payload.master = true;
    post(payload).then(function (d) {
      if (d && d.ok) {
        lukOpret();
        toast('Binderen er klar — ' + (d.slots || 0) + ' slots');
        if (d.binder_id) visDetalje(d.binder_id);
        else visHylde();
      } else {
        toast((d && d.fejl) || 'Noget gik galt — prøv igen');
        if (knap) { knap.disabled = false; knap.style.opacity = ''; }
      }
    });
  }

  /* Opret-bindinger findes kun i logget-ind-markup */
  if (opretModal && soegInput) {
    var soegT;
    soegInput.addEventListener('input', function () {
      clearTimeout(soegT);
      var q = soegInput.value.trim();
      if (q.length < 2) { forslagHolder.innerHTML = ''; return; }
      soegT = setTimeout(function () {
        post({ action: 'soeg_skabelon', q: q }).then(function (d) {
          var forslag = (d && d.forslag) || [];
          var ikoner = { set: mtwIkon('kort'), pokemon: mtwIkon('ball-roed'), artist: mtwIkon('stjerne') };
          var typer = { set: 'Sæt', pokemon: 'Pokémon', artist: 'Illustrator' };
          forslagHolder.innerHTML = forslag.map(function (f) {
            return '<button type="button" class="mtwb2__skabelon" data-type="' + esc(f.type) + '" data-key="' + esc(f.key) + '" data-navn="' + esc(f.navn) + '">' +
              (ikoner[f.type] || mtwIkon('dex')) + ' <span><b>' + esc(typer[f.type] || '') + ': ' + esc(f.navn) + '</b><br><small>' + f.antal + ' kort som slots</small></span></button>';
          }).join('') || '<p class="mtwb2__sub" style="margin:8px 0 0">Ingen match — prøv et sætnavn, en Pokémon eller en illustrator.</p>';
          forslagHolder.querySelectorAll('[data-type]').forEach(function (el) {
            el.addEventListener('click', function () { opret(el.getAttribute('data-type'), el.getAttribute('data-key'), el.getAttribute('data-navn'), el); });
          });
        });
      }, 300);
    });

    document.querySelector('[data-mtwb2-opret-luk]').addEventListener('click', lukOpret);
    opretModal.addEventListener('click', function (e) { if (e.target === opretModal) lukOpret(); });
    var tomKnap = document.querySelector('[data-mtwb2-tom]');
    if (tomKnap) tomKnap.addEventListener('click', function () {
      var navn = window.prompt('Hvad skal din binder hedde?', 'Min binder');
      if (navn) opret('custom', '', navn, null);
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (opretModal && !opretModal.hidden) { lukOpret(); return; }
    if (paaEscape) paaEscape();
  });
  /* Luk popovers (redigér-menu, sæt-vælger) ved klik udenfor — delegation,
     så det overlever re-renders af detaljen. */
  document.addEventListener('click', function (e) {
    var mp = document.querySelector('[data-menu-pop]');
    if (mp && !mp.hidden && !e.target.closest('[data-menu]')) mp.hidden = true;
    var sp = document.querySelector('[data-saet-pop]');
    if (sp && !sp.hidden && !e.target.closest('[data-saet]')) sp.hidden = true;
  });

  /* ---------- Detalje ---------- */
  function visDetalje(id) {
    laasScroll(false);
    hylde.hidden = true;
    detalje.hidden = false;
    aktivFilter = 'alle';
    /* Udgave-filter og fyld-udgave overlever, når samme binder tegnes forfra (marker_numre, Fortryd,
       gør til / fjern master set). En anden binder starter forfra. */
    if (String(id) !== String(udgaveBinderId)) { aktivUdgave = 'alle'; fyldUdgave = 'normal'; udgaveBinderId = id; }
    detalje.innerHTML = '<div class="mtwb2__skelet" aria-hidden="true"></div>';
    hent(PROXY + '?binder=' + encodeURIComponent(id)).then(function (d) {
      aktivBinder = d.binder;
      try { localStorage.setItem('mtwb2_sidste', JSON.stringify({ id: d.binder.id })); } catch (e) { /* privat browsing */ }
      renderDetalje(d.binder, d.slots || []);
    }).catch(function () {
      detalje.innerHTML = '<button type="button" class="mtwb2__tilbage" data-tilbage>← Mine samlinger</button><div class="mtwb2__tom">Kunne ikke hente binderen.</div>';
      detalje.querySelector('[data-tilbage]').addEventListener('click', visHylde);
    });
  }

  function slotHtml(s) {
    var antal = s.antal > 1 ? s.antal : 1;
    var ph = erPlaceholder(s) && !s.image_url;
    var art;
    if (ph) {
      /* 5.0 Placeholder: stiliseret kort-bagside i mtw-streg */
      art = '<span class="mtwb2__ph">' +
        '<span class="mtwb2__ph-cirkel" aria-hidden="true">' + mtwIkon('kort') + '</span>' +
        '<span class="mtwb2__ph-titel">' + esc(s.title || 'Eget kort') + '</span>' +
        ((s.set_name || s.number) ? '<span class="mtwb2__ph-meta">' + esc(trimF((s.set_name || '') + ' ' + (s.number ? '#' + s.number : ''))) + '</span>' : '') +
        '<span class="mtwb2__ph-badge">Eget kort</span>' +
        '</span>';
    } else {
      art = s.image_url
        ? '<img src="' + esc(s.image_url) + '" alt="" loading="lazy" draggable="false">'
        : '<span class="mtwb2__kort-fallback" aria-hidden="true">' + mtwIkon('kort') + '</span>';
    }
    var rh = erRh(s);
    var klasser = 'mtwb2__kort ' + (s.har ? 'mtwb2__kort--har' : 'mtwb2__kort--mangler') +
      (s.vendt ? ' mtwb2__kort--vendt' : '') +
      (s.laast ? ' mtwb2__kort--laastslot' : '') +
      (ph ? ' mtwb2__kort--ph' : '') +
      (rh ? ' mtwb2__kort--rh' : '');
    return '<button type="button" class="' + klasser + '" data-slot="' + esc(s.id) + '" data-har="' + (s.har ? '1' : '0') + '" data-antal="' + antal + '" data-udgave="' + (rh ? 'rh' : 'normal') + '" aria-label="' + esc(rhTitel(s)) + '">' +
      '<span class="mtwb2__kort-art">' + art +
      (s.number && !ph ? '<span class="mtwb2__kort-nr">#' + esc(s.number) + '</span>' : '') +
      /* Master set: "RH"-mærkat øverst til højre på Reverse Holo-lommen */
      (rh ? rhMaerke() : '') +
      /* 4.0 Antal pr. slot: ×N-badge når du har dubletter til byt */
      '<span class="mtwb2__kort-antal" data-antal-badge' + (s.har && antal > 1 ? '' : ' hidden') + '>×' + antal + '</span>' +
      '<span class="mtwb2__kort-stamp" aria-hidden="true">✓</span>' +
      /* 5.0 Lås: hængelås-badge på låste kort */
      '<span class="mtwb2__kort-laas" data-laas-badge' + (s.laast ? '' : ' hidden') + ' aria-hidden="true">' + mtwIkon('laas') + '</span>' +
      '</span>' +
      /* 5.0 Hover-knapper (desktop): runde ikon-knapper oven på kortet */
      '<span class="mtwb2__kort-akt" data-akt>' +
      '<span class="mtwb2__akt-knap" role="button" tabindex="0" data-akt-forstoer title="Forstør" aria-label="Forstør ' + esc(rhTitel(s)) + '">' + mtwIkon('lup') + '</span>' +
      '<span class="mtwb2__akt-knap" role="button" tabindex="0" data-akt-toggle title="' + (s.har ? 'Markér som mangler' : 'Markér som har') + '" aria-label="Skift har/mangler">✓</span>' +
      '<span class="mtwb2__akt-knap" role="button" tabindex="0" data-akt-vend title="Vend kortet på hovedet" aria-label="Vend kortet">' + mtwIkon('byt') + '</span>' +
      '<span class="mtwb2__akt-knap" role="button" tabindex="0" data-akt-laas title="' + (s.laast ? 'Lås op' : 'Lås fast') + '" aria-label="Lås kortet">' + mtwIkon(s.laast ? 'laas' : 'laas-aaben') + '</span>' +
      '<span class="mtwb2__akt-knap mtwb2__akt-knap--fjern" role="button" tabindex="0" data-fjern title="Fjern kortet fra binderen" aria-label="Fjern">✕</span>' +
      '</span>' +
      /* 4.0 Trade-stakken: −/＋ steppers (vises kun på HAR-kort i fyld-mode) */
      '<span class="mtwb2__antal-step" data-step>' +
      '<span role="button" tabindex="0" data-antal-minus aria-label="Én færre af kortet">−</span>' +
      '<b data-antal-tal>' + antal + '</b>' +
      '<span role="button" tabindex="0" data-antal-plus aria-label="Én mere af kortet">＋</span>' +
      '</span>' +
      '<span class="mtwb2__kort-navn">' + esc(s.title) + rhNavn(s) + '</span>' +
      '</button>';
  }

  /* 4.0 Binder-værdi: vejledende Cardmarket-sum ud fra slot-priserne */
  function beregnVaerdi(slots) {
    var v = { har: 0, mangler: 0, ukendte: 0 };
    slots.forEach(function (s) {
      if (s.pris == null) { if (!s.har) v.ukendte++; return; }
      if (s.har) v.har += s.pris;
      else v.mangler += s.pris;
    });
    return v;
  }

  function opdaterVaerdiLinje() {
    var el = detalje.querySelector('[data-vaerdi-linje]');
    if (!el) return;
    var v = beregnVaerdi(aktivSlots);
    if (!v.har && !v.mangler) { el.hidden = true; el.innerHTML = ''; return; }
    el.hidden = false;
    el.innerHTML = 'din samling <b>≈ ' + fmtKr(v.har) + ' kr</b>' +
      (v.mangler ? ' · mangler for <b>≈ ' + fmtKr(v.mangler) + ' kr</b>' : '') +
      '<small>vejledende Cardmarket-værdi</small>';
  }

  /* 4.0 Fuldfør-hjælperen: manglerne sorteret billigst-først m. løbende sum */
  function aabnFuldfoer() {
    if (!aktivBinder) return;
    fjernLoseModaler();
    var mangler = aktivSlots.filter(function (s) { return !s.har; });
    if (!mangler.length) { toast('Ingen mangler — binderen er 100 %'); return; }
    var medPris = mangler.filter(function (s) { return s.pris != null; }).sort(function (a, b) { return a.pris - b.pris; });
    var udenPris = mangler.filter(function (s) { return s.pris == null; });
    var akk = 0;
    var rk = medPris.map(function (s, i) {
      akk += s.pris;
      return '<div class="mtwb2__fu-rk">' +
        '<span class="mtwb2__fu-nr">' + (s.number ? '#' + esc(s.number) : '·') + '</span>' +
        '<span class="mtwb2__fu-navn">' + esc(s.title) + rhNavn(s) + (s.set_name ? '<small>' + esc(s.set_name) + '</small>' : '') + '</span>' +
        '<span class="mtwb2__fu-pris">' + fmtKr(s.pris) + ' kr</span>' +
        '<span class="mtwb2__fu-akk">≈ ' + fmtKr(akk) + ' kr for de ' + (i + 1) + ' billigste</span>' +
        '</div>';
    }).join('');
    if (udenPris.length) {
      rk += '<p class="mtwb2__b-label mtwb2__fu-label">Pris ukendt — men stadig dine</p>' +
        udenPris.map(function (s) {
          return '<div class="mtwb2__fu-rk">' +
            '<span class="mtwb2__fu-nr">' + (s.number ? '#' + esc(s.number) : '·') + '</span>' +
            '<span class="mtwb2__fu-navn">' + esc(s.title) + rhNavn(s) + (s.set_name ? '<small>' + esc(s.set_name) + '</small>' : '') + '</span>' +
            '<span class="mtwb2__fu-pris mtwb2__fu-ukendt">pris ukendt</span>' +
            '</div>';
        }).join('');
    }
    var teaser = '';
    if (medPris.length) {
      var n = Math.min(10, medPris.length);
      var sumN = 0;
      for (var i = 0; i < n; i++) sumN += medPris[i].pris;
      teaser = '<div class="mtwb2__fu-teaser">' + mtwIkon('lyn') +
        ' <span>De næste <b>' + n + ' kort</b> koster tilsammen <b>≈ ' + fmtKr(sumN) + ' kr</b> — du er tættere på 100 % end du tror.</span></div>';
    }
    var bag = document.createElement('div');
    bag.className = 'mtwb2__modal-bag';
    bag.innerHTML =
      '<div class="mtwb2__modal" role="dialog" aria-modal="true" aria-label="Fuldfør binderen">' +
      '<button type="button" class="mtwb2__modal-luk" data-fu-luk aria-label="Luk">✕</button>' +
      '<h3>' + mtwIkon('medalje') + ' Fuldfør binderen</h3>' +
      '<p class="mtwb2__sub">Du mangler <b>' + mangler.length + ' kort</b> — her er den billigste vej til 100 %.</p>' +
      teaser +
      (bulkMatches.length
        ? '<button type="button" class="mtwb2__knap mtwb2__knap--lille mtwb2__fu-bulk" data-fu-bulk>' + mtwIkon('kurv') + ' ' + bulkMatches.length + ' af dem er på lager — læg alle i kurven</button>'
        : '') +
      '<div class="mtwb2__fu-liste">' + rk + '</div>' +
      '<p class="mtwb2__fu-note">vejledende Cardmarket-priser — ikke Matraws-priser</p>' +
      '</div>';
    (rod || document.body).appendChild(bag);
    function lukFu() { bag.remove(); }
    bag.addEventListener('click', function (e) { if (e.target === bag) lukFu(); });
    bag.querySelector('[data-fu-luk]').addEventListener('click', lukFu);
    var fuBulk = bag.querySelector('[data-fu-bulk]');
    if (fuBulk) fuBulk.addEventListener('click', function () {
      lukFu();
      var kob = detalje.querySelector('[data-bulk-kob]');
      var bulkBar = detalje.querySelector('.mtwb2__bulk');
      if (bulkBar && bulkBar.scrollIntoView) bulkBar.scrollIntoView({ block: 'center' });
      if (kob && !kob.disabled) kob.click();
    });
  }

  /* 4.0 Print mangellisten: skjult print-container + window.print() */
  function printMangelliste(binder) {
    var mangler = aktivSlots.filter(function (s) { return !s.har; });
    if (!mangler.length) { toast('Ingen mangler — binderen er 100 %'); return; }
    var gammel = document.getElementById('mtwb2-print');
    if (gammel && gammel.parentNode) gammel.parentNode.removeChild(gammel);
    var MDR = ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'];
    var nu = new Date();
    var dato = nu.getDate() + '. ' + MDR[nu.getMonth()] + ' ' + nu.getFullYear();
    var sum = 0;
    var ukendte = 0;
    var rk = mangler.map(function (s) {
      var pris;
      if (s.pris == null) { ukendte++; pris = '—'; }
      else { sum += s.pris; pris = fmtKr(s.pris) + ' kr'; }
      return '<tr><td>' + (s.number ? '#' + esc(s.number) : '') + '</td><td>' + esc(rhTitel(s)) + '</td><td>' + esc(s.set_name || '') + '</td><td>' + pris + '</td></tr>';
    }).join('');
    var div = document.createElement('div');
    div.id = 'mtwb2-print';
    div.className = 'mtwb2-print';
    div.innerHTML =
      '<h1>Mangelliste — ' + esc(binder.name) + '</h1>' +
      '<p class="mtwb2-print__dato">' + dato + ' · ' + mangler.length + ' kort mangler</p>' +
      '<table><thead><tr><th>#nummer</th><th>navn</th><th>sæt</th><th>pris</th></tr></thead>' +
      '<tbody>' + rk + '</tbody>' +
      '<tfoot><tr><td></td><td></td><td>I alt (vejledende Cardmarket)</td><td>≈ ' + fmtKr(sum) + ' kr' + (ukendte ? ' + ' + ukendte + ' kort uden pris' : '') + '</td></tr></tfoot></table>' +
      '<p class="mtwb2-print__fod">matraws.dk</p>';
    document.body.appendChild(div);
    document.documentElement.classList.add('mtwb2-print-aktiv');
    function ryd() {
      document.documentElement.classList.remove('mtwb2-print-aktiv');
      if (div.parentNode) div.parentNode.removeChild(div);
      window.removeEventListener('afterprint', ryd);
    }
    window.addEventListener('afterprint', ryd);
    setTimeout(function () { window.print(); }, 60);
  }

  /* 4.0 Deling: engangs-token → offentligt link + stop-knap */
  function aabnDeling(binder) {
    if (!binder) return;
    fjernLoseModaler();
    var bag = document.createElement('div');
    bag.className = 'mtwb2__modal-bag';
    bag.innerHTML =
      '<div class="mtwb2__modal" role="dialog" aria-modal="true" aria-label="Del binderen">' +
      '<button type="button" class="mtwb2__modal-luk" data-del-luk aria-label="Luk">✕</button>' +
      '<h3>Del binderen</h3>' +
      '<p class="mtwb2__sub">Alle med linket kan se <b>' + esc(binder.name) + '</b> — også uden login. De kan ikke ændre noget.</p>' +
      '<div data-del-krop><p class="mtwb2__b-note">Henter dit link …</p></div>' +
      '</div>';
    (rod || document.body).appendChild(bag);
    function lukDel() { bag.remove(); }
    bag.addEventListener('click', function (e) { if (e.target === bag) lukDel(); });
    bag.querySelector('[data-del-luk]').addEventListener('click', lukDel);
    var krop = bag.querySelector('[data-del-krop]');
    post({ action: 'del', binder_id: binder.id }).then(function (d) {
      if (!(d && d.ok && d.token)) {
        krop.innerHTML = '<p class="mtwb2__b-note">Kunne ikke oprette linket — prøv igen om lidt.</p>';
        return;
      }
      binder.share_token = d.token;
      var link = window.location.origin + window.location.pathname + '?del=' + d.token;
      krop.innerHTML =
        '<div class="mtwb2__del-link">' +
        '<input type="text" readonly value="' + esc(link) + '" data-del-input aria-label="Delelink">' +
        '<button type="button" class="mtwb2__knap mtwb2__knap--lille" data-del-kopier>Kopiér</button>' +
        '</div>' +
        '<button type="button" class="mtwb2__del-stop" data-del-stop>Stop deling — linket holder op med at virke</button>';
      var inp = krop.querySelector('[data-del-input]');
      inp.addEventListener('click', function () { inp.select(); });
      var kop = krop.querySelector('[data-del-kopier]');
      kop.addEventListener('click', function () {
        kopier(link, function () {
          kop.textContent = 'Kopieret ✓';
          toast('Linket er kopieret');
        });
      });
      krop.querySelector('[data-del-stop]').addEventListener('click', function () {
        if (!window.confirm('Stop delingen? Linket holder op med at virke — du kan altid dele igen.')) return;
        post({ action: 'del_stop', binder_id: binder.id }).then(function (r) {
          if (r && r.ok) {
            binder.share_token = null;
            lukDel();
            toast('Delingen er stoppet');
          } else {
            toast('Kunne ikke stoppe delingen — prøv igen');
          }
        });
      });
    });
  }

  /* 4.0 CSV-import: hent samlingen med fra andre platforme (TCGplayer/
     Pokellector-agtige CSV-eksporter). Alt parses client-side i ren ES5 —
     ingen libraries. Serveren matcher og stempler HAR; den gætter aldrig. */
  function parseCsvLinje(linje, skille) {
    /* simpel CSV-splitter m. "citat"-håndtering ("" = escaped citat) */
    var felter = [];
    var felt = '';
    var iCitat = false;
    for (var i = 0; i < linje.length; i++) {
      var c = linje.charAt(i);
      if (iCitat) {
        if (c === '"') {
          if (linje.charAt(i + 1) === '"') { felt += '"'; i++; }
          else iCitat = false;
        } else felt += c;
      } else if (c === '"') {
        iCitat = true;
      } else if (c === skille) {
        felter.push(felt);
        felt = '';
      } else felt += c;
    }
    felter.push(felt);
    return felter;
  }

  function trimF(s) { return String(s == null ? '' : s).replace(/^\s+|\s+$/g, ''); }

  function parseCsv(tekst) {
    var linjer = String(tekst || '').replace(/\r\n?/g, '\n').split('\n').filter(function (l) {
      return trimF(l.replace(/[;,"]/g, '')) !== '';
    });
    if (linjer.length < 2) {
      return { fejl: 'CSV\'en skal have en header-linje og mindst én række — indsæt hele eksporten.' };
    }
    /* Skilletegn: komma eller semikolon — det hyppigste i headeren vinder */
    var kommaer = (linjer[0].match(/,/g) || []).length;
    var semier = (linjer[0].match(/;/g) || []).length;
    var skille = semier > kommaer ? ';' : ',';
    var hoved = parseCsvLinje(linjer[0], skille).map(function (h) {
      return trimF(h).toLowerCase().replace(/["'.:]/g, '');
    });
    var navnKol = -1;
    var saetKol = -1;
    var nrKol = -1;
    var i;
    for (i = 0; i < hoved.length; i++) {
      var h = hoved[i];
      if (saetKol === -1 && (h.indexOf('set') > -1 || h.indexOf('expansion') > -1)) saetKol = i;
      if (nrKol === -1 && (h.indexOf('number') > -1 || h === 'no' || h === '#' || h === 'nr')) nrKol = i;
    }
    for (i = 0; i < hoved.length; i++) {
      var hn = hoved[i];
      if (i === saetKol || i === nrKol) continue;
      if ((hn.indexOf('name') > -1 || hn.indexOf('card') > -1 || hn.indexOf('product') > -1) &&
          hn.indexOf('set') === -1 && hn.indexOf('expansion') === -1 && hn.indexOf('number') === -1) {
        navnKol = i;
        break;
      }
    }
    var harSaetNr = saetKol > -1 && nrKol > -1;
    if (navnKol === -1 && !harSaetNr) {
      return { fejl: 'Kunne ikke genkende kolonnerne — headeren skal have en navne-kolonne (name/card/product) eller både sæt og nummer.' };
    }
    var raekker = [];
    var medSaet = 0;
    var kunNavn = 0;
    var beskaaret = false;
    for (var r = 1; r < linjer.length; r++) {
      if (raekker.length >= 500) { beskaaret = true; break; }
      var felter = parseCsvLinje(linjer[r], skille);
      var navn = navnKol > -1 ? trimF(felter[navnKol]) : '';
      var sn = saetKol > -1 ? trimF(felter[saetKol]) : '';
      var nr = nrKol > -1 ? trimF(felter[nrKol]) : '';
      if (harSaetNr && sn && nr) {
        raekker.push({ set_name: sn, number: nr });
        medSaet++;
      } else if (navn) {
        raekker.push({ name: navn });
        kunNavn++;
      }
      /* tomme rækker springes stille over */
    }
    if (!raekker.length) {
      return { fejl: 'Fandt ingen brugbare rækker — tjek at CSV\'en har indhold under headeren.' };
    }
    return { fejl: null, raekker: raekker, medSaet: medSaet, kunNavn: kunNavn, beskaaret: beskaaret };
  }

  function aabnImport(binder) {
    if (!aktivBinder) return;
    fjernLoseModaler();
    var klarRaekker = null; /* sat efter vellykket parse */
    var bag = document.createElement('div');
    bag.className = 'mtwb2__modal-bag';
    bag.innerHTML =
      '<div class="mtwb2__modal" role="dialog" aria-modal="true" aria-label="Importér din samling">' +
      '<button type="button" class="mtwb2__modal-luk" data-imp-luk aria-label="Luk">✕</button>' +
      '<h3>' + mtwIkon('stak') + ' Importér din samling</h3>' +
      '<p class="mtwb2__sub">Eksportér din samling fra en anden platform som CSV — vi matcher kortene mod kataloget og stempler dem <b>HAR</b>. Vi gætter aldrig: kan et kort ikke matches entydigt, springes det over.</p>' +
      '<textarea class="mtwb2__imp-tekst" data-imp-tekst placeholder="Indsæt CSV-indholdet her — første linje skal være headeren (fx Name, Set, Number)" aria-label="CSV-indhold"></textarea>' +
      '<label class="mtwb2__imp-fil-label">… eller vælg en CSV-fil:' +
      '<input class="mtwb2__imp-fil" data-imp-fil type="file" accept=".csv,text/csv" aria-label="Vælg CSV-fil">' +
      '</label>' +
      '<div class="mtwb2__imp-status" data-imp-status hidden aria-live="polite"></div>' +
      '<div class="mtwb2__imp-knapper">' +
      '<button type="button" class="mtwb2__knap mtwb2__knap--lille mtwb2__knap--ghost" data-imp-tjek>Tjek CSV\'en</button>' +
      '<button type="button" class="mtwb2__knap mtwb2__knap--lille" data-imp-send hidden>Importér</button>' +
      '</div>' +
      '</div>';
    (rod || document.body).appendChild(bag);
    var tekstEl = bag.querySelector('[data-imp-tekst]');
    var filEl = bag.querySelector('[data-imp-fil]');
    var statusEl = bag.querySelector('[data-imp-status]');
    var tjekKnap = bag.querySelector('[data-imp-tjek]');
    var sendKnap = bag.querySelector('[data-imp-send]');
    function lukImp() { bag.remove(); }
    bag.addEventListener('click', function (e) { if (e.target === bag) lukImp(); });
    bag.querySelector('[data-imp-luk]').addEventListener('click', lukImp);

    function visStatus(html) {
      statusEl.hidden = false;
      statusEl.innerHTML = html;
    }
    function tjek() {
      klarRaekker = null;
      sendKnap.hidden = true;
      var res = parseCsv(tekstEl.value);
      if (res.fejl) { visStatus(esc(res.fejl)); return; }
      klarRaekker = res.raekker;
      visStatus('Fandt <b>' + res.raekker.length + ' rækker</b> — ' + res.medSaet + ' med sæt+nummer, ' + res.kunNavn + ' kun med navn.' +
        (res.beskaaret ? '<br>CSV\'en var længere — vi tager de første 500 rækker ad gangen.' : ''));
      sendKnap.hidden = false;
      sendKnap.disabled = false;
      sendKnap.textContent = 'Importér ' + res.raekker.length + ' kort';
    }
    tjekKnap.addEventListener('click', tjek);
    /* Fil-valg: læses som tekst og parses med det samme */
    filEl.addEventListener('change', function () {
      var fil = filEl.files && filEl.files[0];
      if (!fil) return;
      if (!window.FileReader) { visStatus('Din browser kan ikke læse filer — indsæt indholdet i feltet i stedet.'); return; }
      var laeser = new FileReader();
      laeser.onload = function () {
        tekstEl.value = String(laeser.result || '');
        tjek();
      };
      laeser.onerror = function () {
        visStatus('Kunne ikke læse filen — prøv at indsætte indholdet i feltet i stedet.');
      };
      laeser.readAsText(fil);
    });
    sendKnap.addEventListener('click', function () {
      if (!klarRaekker || !klarRaekker.length) { tjek(); return; }
      sendKnap.disabled = true;
      sendKnap.textContent = 'Importerer …';
      tjekKnap.hidden = true;
      post({ action: 'import', binder_id: aktivBinder.id, rows: klarRaekker }).then(function (d) {
        if (d && d.ok) {
          var oprettet = d.oprettet || 0;
          var sprunget = d.sprunget || 0;
          visStatus('<b>' + oprettet + ' kort importeret</b> og stemplet HAR' +
            (sprunget ? ' · ' + sprunget + ' kunne ikke matches entydigt (sprunget over — vi gætter aldrig)' : '') + '.');
          sendKnap.hidden = true;
          var faerdig = document.createElement('button');
          faerdig.type = 'button';
          faerdig.className = 'mtwb2__knap mtwb2__knap--lille';
          faerdig.textContent = 'Færdig';
          bag.querySelector('.mtwb2__imp-knapper').appendChild(faerdig);
          faerdig.addEventListener('click', function () {
            lukImp();
            visDetalje(aktivBinder.id);
          });
        } else {
          visStatus(esc((d && d.fejl) || 'Importen fejlede — prøv igen om lidt.'));
          sendKnap.disabled = false;
          sendKnap.textContent = 'Importér ' + klarRaekker.length + ' kort';
          tjekKnap.hidden = false;
        }
      }).catch(function () {
        visStatus('Importen fejlede — tjek din forbindelse og prøv igen.');
        sendKnap.disabled = false;
        sendKnap.textContent = 'Importér ' + klarRaekker.length + ' kort';
        tjekKnap.hidden = false;
      });
    });
  }

  function renderDetalje(binder, slots) {
    /* 5.0 Positions-systemet: kort sorteres efter sort_key overalt */
    slots = sorterSlots(slots);
    var har = slots.filter(function (s) { return s.har; }).length;
    var pct = slots.length ? Math.round((har / slots.length) * 100) : 0;
    aktivSlots = slots;
    bulkMatches = [];
    forrigePct = pct; /* fejr kun NÅR 100 % rammes — ikke hvis binderen åbnes fuld */
    sideNr = 0;
    aktivTegnSider = null;

    /* Master set: delbjælker, udgave-filter, fyld-valg og menupunkter.
       kan_master/rh_antal kommer fra serveren; mangler de, vises intet nyt. */
    var master = erMaster(binder);
    if (!master) { aktivUdgave = 'alle'; fyldUdgave = 'normal'; } /* fx efter fjern_master */
    var udgTal = taelUdgaver(slots);
    var kanMaster = !master && binder.kan_master === true;
    var rhAntal = Number(binder.rh_antal) || 0;
    var visMsBanner = kanMaster && rhAntal > 0 && slots.length > 0 && !msBannerLukket(binder.id);

    var html =
      /* Rolig top: tilbage + redigér-menu */
      '<div class="mtwb2__d-top">' +
      '<button type="button" class="mtwb2__tilbage" data-tilbage>← Mine samlinger</button>' +
      (binder.kind === 'oensker'
        ? '<div class="mtwb2__menu" data-menu><div data-menu-pop hidden></div></div>'
        : '<div class="mtwb2__d-top-hoejre">' +
          '<div class="mtwb2__menu" data-menu>' +
          '<button type="button" class="mtwb2__menu-knap" data-menu-knap aria-haspopup="true">Redigér binderen ▾</button>' +
          '<div class="mtwb2__menu-pop" data-menu-pop hidden>' +
          '<button type="button" data-omdob>Omdøb</button>' +
          '<button type="button" data-udseende>Skift udseende</button>' +
          '<button type="button" data-del-binder>Del binderen</button>' +
          '<button type="button" data-import-csv>Importér fra CSV</button>' +
          '<button type="button" data-print-mangler>Print mangelliste</button>' +
          (kanMaster ? '<button type="button" data-goer-master>Gør til master set</button>' : '') +
          (master ? '<button type="button" data-fjern-master>Fjern Reverse Holo-lommer</button>' : '') +
          '<button type="button" class="mtwb2__menu-slet" data-slet>Slet binderen</button>' +
          '</div></div>' +
          /* 5.0 Burger-menuen (⋮): galleri, rediger, duplikér, eksport, format */
          '<button type="button" class="mtwb2__d-burger" data-d-burger title="Flere handlinger" aria-label="Flere handlinger" aria-haspopup="true">' + mtwIkon('prikker') + '</button>' +
          '</div>') +
      '</div>' +
      /* Hero: ikon-badge, navn, én progress-linje, én primær handling */
      '<div class="mtwb2__d-hoved">' +
      '<div class="mtwb2__d-titel">' +
      '<span class="mtwb2__d-emoji" aria-hidden="true">' + mtwIkon(binder.cover || 'dex') + '</span>' +
      '<div><span class="mtwb2__d-logo" data-d-logo hidden></span><h1>' + esc(binder.name) + (master ? '<span class="mtwb2__ms-titel"> · Master set</span>' : '') + '</h1>' +
      /* 4.0 Achievements: medalje-badge når binderen er 100 % */
      '<span class="mtwb2__d-medalje" data-d-medalje' + (slots.length && pct >= 100 ? '' : ' hidden') + '>' + mtwIkon('medalje') + ' Fuldført</span>' +
      '<div class="mtwb2__frem">' +
      '<span class="mtwb2__cbar' + (pct >= 100 ? ' mtwb2__cbar--fuld' : '') + '" data-cbar><i data-cfill style="width:' + pct + '%"></i></span>' +
      '<span class="mtwb2__frem-tal"><b data-frem-tekst>' + har + ' af ' + slots.length + ' kort</b> · <span data-frem-pct>' + pct + ' %</span></span>' +
      '</div>' +
      /* Master set: to delbjælker under den samlede (Kortene / Reverse Holo) */
      (master
        ? '<div class="mtwb2__frem2" data-frem2>' +
          '<span class="mtwb2__frem2-navn">Kortene</span>' +
          '<span class="mtwb2__cbar mtwb2__cbar--mini"><i data-cfill-normal style="width:' + pctAf(udgTal.normal.har, udgTal.normal.total) + '%"></i></span>' +
          '<b data-frem-normal>' + udgTal.normal.har + ' / ' + udgTal.normal.total + '</b>' +
          '<span class="mtwb2__frem2-navn">Reverse Holo</span>' +
          '<span class="mtwb2__cbar mtwb2__cbar--mini mtwb2__cbar--rh"><i data-cfill-rh style="width:' + pctAf(udgTal.rh.har, udgTal.rh.total) + '%"></i></span>' +
          '<b data-frem-rh>' + udgTal.rh.har + ' / ' + udgTal.rh.total + '</b>' +
          '</div>'
        : '') +
      /* 4.0 Binder-værdi: din samling ≈ X kr · mangler for ≈ Y kr */
      '<div class="mtwb2__d-vaerdi" data-vaerdi-linje hidden></div>' +
      '</div></div>' +
      '<div class="mtwb2__d-knapper">' +
      '<button type="button" class="mtwb2__knap" data-kort-knap>＋ Tilføj kort</button>' +
      '<button type="button" class="mtwb2__knap mtwb2__knap--ghost" data-fyld-knap>' + mtwIkon('lyn') + ' Fyld binderen</button>' +
      /* 4.0 Fuldfør-hjælperen */
      (binder.kind !== 'oensker'
        ? '<button type="button" class="mtwb2__knap mtwb2__knap--ghost" data-fuldfoer-knap' + (slots.length - har > 0 ? '' : ' hidden') + '>' + mtwIkon('medalje') + ' Fuldfør binderen</button>'
        : '') +
      '</div>' +
      '</div>' +
      /* Master set-banner: eksisterende sæt-samling med Reverse Holo-kort */
      (visMsBanner
        ? '<div class="mtwb2__ms-banner" data-ms-banner>' +
          '<span class="mtwb2__ms-mini" aria-hidden="true"><i></i><i class="mtwb2__ms-mini-rh"></i></span>' +
          '<p><b>Samler du også Reverse Holo?</b><br>Gør samlingen til et master set. Vi tilføjer ' + rhLommer(rhAntal) +
          (har > 0 ? ', og ' + (har === 1 ? 'dit ene kort' : 'dine ' + har + ' kort') + ' bliver liggende.' : '.') + '</p>' +
          '<button type="button" class="mtwb2__knap mtwb2__knap--lille" data-goer-master>Gør til master set</button>' +
          '<button type="button" class="mtwb2__ms-banner-luk" data-ms-banner-luk aria-label="Luk beskeden">✕</button>' +
          '</div>'
        : '') +
      /* Ét segmenteret filter m. tællere + 4.0 visnings-skift (grid/sider) */
      '<div class="mtwb2__d-raekke' + (master ? ' mtwb2__d-raekke--master' : '') + '">' +
      '<div class="mtwb2__seg" role="group" aria-label="Filtrér kort">' +
      '<button type="button" class="mtwb2__seg-knap" aria-pressed="true" data-filter="alle">Alle <b data-antal="alle">' + slots.length + '</b></button>' +
      '<button type="button" class="mtwb2__seg-knap" aria-pressed="false" data-filter="har">✓ Har <b data-antal="har">' + har + '</b></button>' +
      '<button type="button" class="mtwb2__seg-knap" aria-pressed="false" data-filter="mangler">Mangler <b data-antal="mangler">' + (slots.length - har) + '</b></button>' +
      '</div>' +
      /* Master set: udgave-filter, virker sammen med Alle/Har/Mangler */
      (master
        ? '<div class="mtwb2__udg" role="group" aria-label="Udgave">' +
          '<button type="button" class="mtwb2__udg-chip" aria-pressed="' + (aktivUdgave === 'alle') + '" data-udg="alle">Begge udgaver</button>' +
          '<button type="button" class="mtwb2__udg-chip" aria-pressed="' + (aktivUdgave === 'normal') + '" data-udg="normal">Kun kortene</button>' +
          '<button type="button" class="mtwb2__udg-chip" aria-pressed="' + (aktivUdgave === 'rh') + '" data-udg="rh">Kun Reverse Holo</button>' +
          '</div>'
        : '') +
      (slots.length
        ? '<div class="mtwb2__vis-skift" role="group" aria-label="Skift visning">' +
          '<button type="button" class="mtwb2__vis-knap" data-vis="grid" aria-pressed="true" title="Grid-visning" aria-label="Grid-visning">' + mtwIkon('gitter') + '</button>' +
          '<button type="button" class="mtwb2__vis-knap" data-vis="sider" aria-pressed="false" title="Binder-sider" aria-label="Binder-side-visning">' + mtwIkon('opslag') + '</button>' +
          '</div>'
        : '') +
      '</div>' +
      /* Fyld-mode (numre) — gemt bag redigér-menuen */
      '<div class="mtwb2__fyld" data-fyld-bar>' +
      '<b>' + mtwIkon('lyn') + ' Fyld binderen:</b> <span>tap kortene du har — brug −/＋ til dubletter — eller tast numrene:</span>' +
      /* Master set: numrene markeres på kortene eller på Reverse Holo-lommerne */
      (master
        ? '<span class="mtwb2__fyld-udg" role="group" aria-label="Markér numrene på">' +
          '<button type="button" data-fyld-udg="normal" aria-pressed="' + (fyldUdgave !== 'rh') + '">Kort</button>' +
          '<button type="button" data-fyld-udg="rh" aria-pressed="' + (fyldUdgave === 'rh') + '">Reverse Holo</button>' +
          '</span>'
        : '') +
      '<input data-nr-input placeholder="fx 1-12, 15, 22-40">' +
      '<button type="button" class="mtwb2__knap mtwb2__knap--lille" data-nr-marker>Markér ✓ Har</button>' +
      '<button type="button" class="mtwb2__fyld-chip" data-vend-om title="Markér alt som HAR — og fjern så dine få mangler">' + mtwIkon('byt') + ' Jeg har de fleste — vend om</button>' +
      '<button type="button" class="mtwb2__fyld-luk" data-fyld-luk aria-label="Luk fyld-mode">✕</button>' +
      '</div>' +
      /* Binder-gridden — kortene, uden rammer om rammerne */
      '<div class="mtwb2__grid" data-slots></div>' +
      /* 4.0 Binder-side-visning: 3x3-lommer (2x3 på mobil) */
      '<div class="mtwb2__sider" data-sider hidden></div>' +
      /* Katalog-arket: fuldskærms-skuffe i stedet for panel-i-panel */
      '<div class="mtwb2__sheet" data-sheet hidden>' +
      '<div class="mtwb2__sheet-panel" role="dialog" aria-modal="true" aria-label="Tilføj kort">' +
      '<div class="mtwb2__sheet-top">' +
      '<div class="mtwb2__sheet-titel"><b>Tilføj kort</b><span class="mtwb2__pill mtwb2__pill--ok" data-kat-taeller hidden></span></div>' +
      '<button type="button" class="mtwb2__knap mtwb2__knap--lille" data-sheet-luk>✓ Færdig</button>' +
      '</div>' +
      '<div class="mtwb2__sheet-bar">' +
      '<input data-kort-input type="search" placeholder="Søg blandt 26.000+ kort …" autocomplete="off">' +
      '<div class="mtwb2__saet" data-saet>' +
      '<button type="button" class="mtwb2__saet-knap" data-saet-knap aria-expanded="false" aria-haspopup="true">' + mtwIkon('kort') + ' Sæt</button>' +
      '<div class="mtwb2__saet-pop" data-saet-pop hidden>' +
      '<input data-saet-filter placeholder="Find sæt …" autocomplete="off">' +
      '<div class="mtwb2__saet-liste" data-saet-liste></div>' +
      '</div></div></div>' +
      '<p class="mtwb2__sheet-hint">Tap kortet når du <b>har</b> det — <b>＋ Mangler</b> gemmer det som ønske</p>' +
      '<div class="mtwb2__sheet-grid" data-kort-resultater>' +
      '<p class="mtwb2__sheet-start">Søg på kortnavn — eller åbn et sæt og bladr det igennem</p>' +
      '</div></div></div>';
    detalje.innerHTML = html;

    var grid = detalje.querySelector('[data-slots]');
    var invite = binder.kind === 'oensker'
      ? '<div class="mtwb2__invite">' +
        '<span class="mtwb2__invite-ikon" aria-hidden="true">' + mtwIkon('klokke') + '</span>' +
        '<h3>Din ønskeliste er tom</h3>' +
        '<p>Tilføj kort du drømmer om — er de på lager, kan du købe dem med ét tryk. Besked når de lander, kommer snart.</p>' +
        '<button type="button" class="mtwb2__knap" data-invite-cta>＋ Tilføj ønsker</button>' +
        '</div>'
      : '<div class="mtwb2__invite">' +
        '<span class="mtwb2__invite-ikon" aria-hidden="true">' + mtwIkon('stjerne') + '</span>' +
        '<h3>Din binder venter på sit første kort</h3>' +
        '<p>Søg i hele kataloget — 26.000+ kort — og stempl dem du har.</p>' +
        '<button type="button" class="mtwb2__knap" data-invite-cta>＋ Tilføj kort</button>' +
        '</div>';
    grid.innerHTML = slots.length ? slots.map(slotHtml).join('') : invite;

    opdaterVaerdiLinje();
    if (aktivUdgave !== 'alle') { anvendFilter(); opdaterTaellere(); } /* husket udgave-filter efter en gen-tegning */

    detalje.querySelector('[data-tilbage]').addEventListener('click', visHylde);
    detalje.querySelectorAll('[data-filter]').forEach(function (c) {
      c.addEventListener('click', function () {
        aktivFilter = c.getAttribute('data-filter');
        detalje.querySelectorAll('[data-filter]').forEach(function (x) { x.setAttribute('aria-pressed', 'false'); });
        c.setAttribute('aria-pressed', 'true');
        anvendFilter();
      });
    });
    detalje.querySelectorAll('[data-udg]').forEach(function (c) {
      c.addEventListener('click', function () {
        aktivUdgave = c.getAttribute('data-udg');
        detalje.querySelectorAll('[data-udg]').forEach(function (x) { x.setAttribute('aria-pressed', x === c ? 'true' : 'false'); });
        anvendFilter();
        opdaterTaellere(); /* Alle/Har/Mangler tæller den valgte udgave */
      });
    });

    /* Delegation: tap = toggle (m. stempel), ✕ = fjern, −/＋ = antal,
       invite-CTA = åbn arket */
    grid.addEventListener('click', function (e) {
      if (e.target.closest('[data-invite-cta]')) { aabnSheet(); return; }
      var slot = e.target.closest('[data-slot]');
      if (!slot) return;
      if (e.target.closest('[data-antal-minus]')) {
        e.stopPropagation();
        saetAntal(slot, (parseInt(slot.getAttribute('data-antal'), 10) || 1) - 1);
        return;
      }
      if (e.target.closest('[data-antal-plus]')) {
        e.stopPropagation();
        saetAntal(slot, (parseInt(slot.getAttribute('data-antal'), 10) || 1) + 1);
        return;
      }
      var slotId = slot.getAttribute('data-slot');
      /* 5.0 Hover-knapperne (og fjern uden confirm — Fortryd-toast i stedet) */
      if (e.target.closest('[data-fjern]')) { e.stopPropagation(); fjernSlotMedFortryd(slotId); return; }
      if (e.target.closest('[data-akt-forstoer]')) { e.stopPropagation(); aabnForstoer(slotId); return; }
      if (e.target.closest('[data-akt-vend]')) { e.stopPropagation(); vendSlot(slotId); return; }
      if (e.target.closest('[data-akt-laas]')) { e.stopPropagation(); laasSlot(slotId); return; }
      if (e.target.closest('[data-akt-toggle]')) { e.stopPropagation(); toggleSlot(slot); return; }
      /* 5.0 Mobil (ingen hover) udenfor fyld-mode: action-sheet i stedet
         for direkte toggle — fyld-mode beholder det hurtige stempel-tap */
      var touch = false;
      try { touch = !!(window.matchMedia && window.matchMedia('(hover: none)').matches); } catch (eT) { /* gamle browsere */ }
      if (touch && !grid.classList.contains('mtwb2__grid--fyld')) { aabnKortSheet(slotId); return; }
      toggleSlot(slot);
    });
    /* 5.0 Tastatur på hover-knapperne (role=button) */
    grid.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var akt = e.target.closest ? e.target.closest('[data-akt-forstoer],[data-akt-vend],[data-akt-laas],[data-akt-toggle],[data-fjern]') : null;
      if (!akt) return;
      var slot = e.target.closest('[data-slot]');
      if (!slot) return;
      e.preventDefault();
      e.stopPropagation();
      var slotId = slot.getAttribute('data-slot');
      if (akt.hasAttribute('data-fjern')) fjernSlotMedFortryd(slotId);
      else if (akt.hasAttribute('data-akt-forstoer')) aabnForstoer(slotId);
      else if (akt.hasAttribute('data-akt-vend')) vendSlot(slotId);
      else if (akt.hasAttribute('data-akt-laas')) laasSlot(slotId);
      else toggleSlot(slot);
    });
    /* Tastatur på stepperne (role=button) */
    grid.addEventListener('keydown', function (e) {
      if (e.key !== 'Enter' && e.key !== ' ') return;
      var m = e.target.closest ? e.target.closest('[data-antal-minus],[data-antal-plus]') : null;
      if (!m) return;
      e.preventDefault();
      e.stopPropagation();
      var slot = e.target.closest('[data-slot]');
      if (!slot) return;
      var n = parseInt(slot.getAttribute('data-antal'), 10) || 1;
      saetAntal(slot, m.hasAttribute('data-antal-minus') ? n - 1 : n + 1);
    });

    /* ---- Redigér-menu ---- */
    var menuPop = detalje.querySelector('[data-menu-pop]');
    var menuKnapEl = detalje.querySelector('[data-menu-knap]');
    if (menuKnapEl) menuKnapEl.addEventListener('click', function () {
      menuPop.hidden = !menuPop.hidden;
    });

    /* ---- 5.0 Burger-menuen (⋮) i binder-visningen ---- */
    var burgerKnap = detalje.querySelector('[data-d-burger]');
    if (burgerKnap) burgerKnap.addEventListener('click', function () {
      if (menuPop) menuPop.hidden = true;
      aabnBinderMenu(binder, 'detalje');
    });

    /* ---- 5.0 Sæt-logo i headeren (kun sæt-binders — kun hvis logoet
       allerede ligger i den cachede sæt-liste) ---- */
    (function () {
      var logoHolder = detalje.querySelector('[data-d-logo]');
      if (!logoHolder) return;
      var tpl = binder.template || null;
      if (!tpl) {
        hyldeBinders.forEach(function (b) {
          if (String(b.id) === String(binder.id) && b.template) tpl = b.template;
        });
      }
      if (!tpl || tpl.type !== 'set' || !tpl.key) return;
      hentSaetListe().then(function (saet) {
        var logo = null;
        (saet || []).forEach(function (s) { if (s.set_id === tpl.key && s.logo) logo = s.logo; });
        if (!logo || !logoHolder.parentNode) return;
        logoHolder.hidden = false;
        logoHolder.innerHTML = '<img src="' + esc(logo) + '" alt="" loading="lazy" onerror="if(this.parentNode)this.parentNode.hidden=true">';
      });
    })();

    /* ---- 4.0 Binder-side-visning (grid ↔ sider) ---- */
    var siderEl = detalje.querySelector('[data-sider]');
    var visKnapper = detalje.querySelectorAll('[data-vis]');
    /* 5.0 Positions-systemet: SIDER af lommer efter lomme_format (4=2×2,
       9=3×3, 12=3×4). sort_key = lomme-index (0-baseret, på tværs af
       sider). Tomme lommer = "Tilføj kort her". Bakken øverst = kort uden
       plads (i_bakke). Træk-og-slip via pointer events (touch + mus). */
    var sidsteFordeling = null; /* seneste lomme-fordeling — swap slås op her */
    function tegnSider() {
      var format = (binder.lomme_format === 4 || binder.lomme_format === 12) ? binder.lomme_format : 9;
      var bakke = aktivSlots.filter(function (s) { return s.i_bakke; });
      var fordelt = fordelLommer(aktivSlots);
      sidsteFordeling = fordelt;
      var antalSider = Math.max(1, Math.ceil((fordelt.maxIdx + 1) / format));
      /* er sidste side helt fuld, får mappen en tom side at vokse ind i */
      if (fordelt.maxIdx >= 0 && (fordelt.maxIdx + 1) >= antalSider * format) antalSider++;
      if (sideNr >= antalSider) sideNr = antalSider - 1;
      if (sideNr < 0) sideNr = 0;
      var start = sideNr * format;
      var lommer = '';
      for (var i = start; i < start + format; i++) {
        var s = fordelt.pladser[i];
        if (s) {
          lommer += '<div class="mtwb2__lomme ' + (s.har ? 'mtwb2__lomme--har' : 'mtwb2__lomme--mangler') +
            (s.vendt ? ' mtwb2__lomme--vendt' : '') +
            (s.laast ? ' mtwb2__lomme--laast' : '') +
            (erPlaceholder(s) && !s.image_url ? ' mtwb2__lomme--ph' : '') +
            (erRh(s) ? ' mtwb2__lomme--rh' : '') +
            '" data-l-slot="' + esc(s.id) + '" data-l-idx="' + i + '" title="' + esc(rhTitel(s)) + '">' +
            lommeIndhold(s) +
            (s.laast ? '<span class="mtwb2__kort-laas" aria-hidden="true">' + mtwIkon('laas') + '</span>' : '') +
            '</div>';
        } else {
          lommer += '<div class="mtwb2__lomme mtwb2__lomme--tom" data-l-idx="' + i + '" data-l-tom role="button" tabindex="0" aria-label="Tilføj kort her — lomme ' + (i + 1) + '">' +
            '<span class="mtwb2__lomme-plus" aria-hidden="true">＋</span>' +
            '<span class="mtwb2__lomme-hint">Tilføj kort her</span></div>';
        }
      }
      var bakkeHtml = bakke.map(function (s) {
        return '<div class="mtwb2__bakke-kort' +
          (s.vendt ? ' mtwb2__lomme--vendt' : '') +
          (s.laast ? ' mtwb2__lomme--laast' : '') +
          (erPlaceholder(s) && !s.image_url ? ' mtwb2__lomme--ph' : '') +
          (erRh(s) ? ' mtwb2__lomme--rh' : '') +
          '" data-l-slot="' + esc(s.id) + '" data-l-bakke="1" title="' + esc(rhTitel(s)) + '">' +
          lommeIndhold(s) +
          (s.laast ? '<span class="mtwb2__kort-laas" aria-hidden="true">' + mtwIkon('laas') + '</span>' : '') +
          '</div>';
      }).join('');
      siderEl.innerHTML =
        '<div class="mtwb2__bakke' + (bakke.length ? '' : ' mtwb2__bakke--tom') + '" data-bakke>' +
        '<span class="mtwb2__bakke-label">' + mtwIkon('stak') + ' Bakken — kort uden plads</span>' +
        '<div class="mtwb2__bakke-holder">' +
        (bakkeHtml || '<span class="mtwb2__bakke-tomtekst">Træk kort herop for at parkere dem</span>') +
        '</div></div>' +
        '<div class="mtwb2__side mtwb2__side--f' + format + '">' +
        '<div class="mtwb2__side-lommer mtwb2__side-lommer--f' + format + '">' + lommer + '</div></div>' +
        '<div class="mtwb2__side-nav">' +
        '<button type="button" class="mtwb2__knap mtwb2__knap--lille mtwb2__knap--ghost" data-side-forrige' + (sideNr === 0 ? ' disabled' : '') + '>← Forrige</button>' +
        '<span class="mtwb2__side-tal">side ' + (sideNr + 1) + ' af ' + antalSider + '</span>' +
        '<button type="button" class="mtwb2__knap mtwb2__knap--lille mtwb2__knap--ghost" data-side-naeste' + (sideNr + 1 >= antalSider ? ' disabled' : '') + '>Næste →</button>' +
        '</div>';
      siderEl.querySelector('[data-side-forrige]').addEventListener('click', function () { sideNr--; tegnSider(); });
      siderEl.querySelector('[data-side-naeste]').addEventListener('click', function () { sideNr++; tegnSider(); });
      /* Tom lomme → søge-flowet m. sort_key på den lomme */
      siderEl.querySelectorAll('[data-l-tom]').forEach(function (el) {
        function tilfoejHer() {
          pendingSortKey = parseInt(el.getAttribute('data-l-idx'), 10);
          aabnSheet();
        }
        el.addEventListener('click', tilfoejHer);
        el.addEventListener('keydown', function (e) {
          if (e.key !== 'Enter' && e.key !== ' ') return;
          e.preventDefault();
          tilfoejHer();
        });
      });
    }
    aktivTegnSider = tegnSider;

    /* ---- 5.0 Træk-og-slip i side-visningen (pointer events, delegation
       på siderEl så det overlever re-renders) ---- */
    var traekState = null;
    var undertrykKlik = false;
    function rydMaal() {
      siderEl.querySelectorAll('.mtwb2__maal').forEach(function (m) { m.classList.remove('mtwb2__maal'); });
    }
    function findMaalEl(x, y) {
      var el = null;
      try { el = document.elementFromPoint(x, y); } catch (eE) { el = null; }
      if (!el || !el.closest) return null;
      var lomme = el.closest('[data-l-idx]');
      if (lomme && siderEl.contains(lomme)) return lomme;
      var bakkeEl = el.closest('[data-bakke]');
      if (bakkeEl && siderEl.contains(bakkeEl)) return bakkeEl;
      return null;
    }
    function opdaterGridEfterFlyt() {
      /* hold grid-visningen i takt med den nye rækkefølge */
      aktivSlots = sorterSlots(aktivSlots);
      grid.innerHTML = aktivSlots.length ? aktivSlots.map(slotHtml).join('') : invite;
      anvendFilter();
    }
    function udfoerFlyt(id, fraIdx, fraBakke, maalEl) {
      var s = slotData(id);
      if (!s || !aktivBinder) return;
      var flyt = [];
      if (maalEl.hasAttribute('data-bakke')) {
        if (fraBakke) return;
        s.i_bakke = true;
        flyt.push({ id: s.id, sort_key: (typeof s.sort_key === 'number' ? s.sort_key : (fraIdx == null ? 0 : fraIdx)), i_bakke: true });
      } else {
        var idx = parseInt(maalEl.getAttribute('data-l-idx'), 10);
        if (!fraBakke && idx === fraIdx) return;
        var andet = sidsteFordeling && sidsteFordeling.pladser[idx];
        if (andet && String(andet.id) === String(id)) return;
        if (andet && andet.laast) { toast('Lommen er optaget af et låst kort'); return; }
        if (andet) {
          /* byt: det andet kort overtager det trukne korts plads */
          if (fraBakke) {
            andet.i_bakke = true;
            flyt.push({ id: andet.id, sort_key: idx, i_bakke: true });
          } else {
            andet.sort_key = fraIdx;
            andet.i_bakke = false;
            flyt.push({ id: andet.id, sort_key: fraIdx, i_bakke: false });
          }
        }
        s.sort_key = idx;
        s.i_bakke = false;
        flyt.push({ id: s.id, sort_key: idx, i_bakke: false });
      }
      tegnSider();
      opdaterGridEfterFlyt();
      var binderId = aktivBinder.id;
      post({ action: 'positioner', binder_id: binderId, flyt: flyt }).then(function (d) {
        if (!d || !d.ok) {
          toast('Kunne ikke gemme flytningen — prøv igen');
          if (aktivBinder && String(aktivBinder.id) === String(binderId)) visDetalje(binderId);
        }
      }).catch(function () {
        toast('Kunne ikke gemme flytningen — tjek forbindelsen');
        if (aktivBinder && String(aktivBinder.id) === String(binderId)) visDetalje(binderId);
      });
    }
    function afslutTraek(e, annulleret) {
      if (!traekState) return;
      var st = traekState;
      traekState = null;
      if (st.ghost && st.ghost.parentNode) st.ghost.parentNode.removeChild(st.ghost);
      if (st.el) st.el.classList.remove('mtwb2__lomme--traekkes');
      rydMaal();
      if (!st.aktiv || annulleret) return;
      undertrykKlik = true;
      setTimeout(function () { undertrykKlik = false; }, 60);
      var maalEl = findMaalEl(e.clientX, e.clientY);
      if (maalEl) udfoerFlyt(st.id, st.fraIdx, st.fraBakke, maalEl);
    }
    if (window.PointerEvent) {
      siderEl.addEventListener('pointerdown', function (e) {
        if (traekState) return;
        var kortEl = e.target.closest ? e.target.closest('[data-l-slot]') : null;
        if (!kortEl) return;
        if (e.pointerType === 'mouse' && e.button !== 0) return;
        var id = kortEl.getAttribute('data-l-slot');
        var s = slotData(id);
        if (!s || s.laast) return; /* låste kort kan IKKE trækkes */
        var idxAttr = kortEl.getAttribute('data-l-idx');
        traekState = {
          id: id,
          el: kortEl,
          fraIdx: idxAttr == null ? null : parseInt(idxAttr, 10),
          fraBakke: kortEl.hasAttribute('data-l-bakke'),
          startX: e.clientX,
          startY: e.clientY,
          aktiv: false,
          ghost: null
        };
        try { kortEl.setPointerCapture(e.pointerId); } catch (eP) { /* gamle browsere */ }
      });
      siderEl.addEventListener('pointermove', function (e) {
        if (!traekState) return;
        var dx = e.clientX - traekState.startX;
        var dy = e.clientY - traekState.startY;
        if (!traekState.aktiv) {
          if (Math.abs(dx) < 7 && Math.abs(dy) < 7) return;
          traekState.aktiv = true;
          var r = traekState.el.getBoundingClientRect();
          var ghost = traekState.el.cloneNode(true);
          ghost.className += ' mtwb2__traek-ghost';
          ghost.style.width = r.width + 'px';
          ghost.style.height = r.height + 'px';
          ghost.style.left = r.left + 'px';
          ghost.style.top = r.top + 'px';
          (rod || document.body).appendChild(ghost);
          traekState.ghost = ghost;
          traekState.el.classList.add('mtwb2__lomme--traekkes');
        }
        if (e.cancelable) e.preventDefault();
        traekState.ghost.style.transform = 'translate(' + dx + 'px,' + dy + 'px) scale(1.06) rotate(2deg)';
        rydMaal();
        var maalEl = findMaalEl(e.clientX, e.clientY);
        if (maalEl && !(traekState.fraIdx != null && maalEl.getAttribute && maalEl.getAttribute('data-l-idx') === String(traekState.fraIdx))) {
          maalEl.classList.add('mtwb2__maal');
        }
      });
      siderEl.addEventListener('pointerup', function (e) { afslutTraek(e, false); });
      siderEl.addEventListener('pointercancel', function (e) { afslutTraek(e, true); });
    }
    /* Klik (uden træk) på et kort i lomme/bakke → kort-arket m. handlinger */
    siderEl.addEventListener('click', function (e) {
      if (undertrykKlik) return;
      var kortEl = e.target.closest ? e.target.closest('[data-l-slot]') : null;
      if (!kortEl) return;
      aabnKortSheet(kortEl.getAttribute('data-l-slot'));
    });
    function skiftVisning(v) {
      visningsValg = v;
      var erSider = v === 'sider';
      detalje.classList.toggle('mtwb2__d--sider', erSider);
      grid.hidden = erSider;
      siderEl.hidden = !erSider;
      visKnapper.forEach(function (k) {
        k.setAttribute('aria-pressed', k.getAttribute('data-vis') === v ? 'true' : 'false');
      });
      if (erSider) tegnSider();
    }
    visKnapper.forEach(function (k) {
      k.addEventListener('click', function () { skiftVisning(k.getAttribute('data-vis')); });
    });
    if (visningsValg === 'sider' && slots.length) skiftVisning('sider');

    /* ---- Katalog-arket ---- */
    var sheet = detalje.querySelector('[data-sheet]');
    var kortInput = detalje.querySelector('[data-kort-input]');
    var kortRes = detalje.querySelector('[data-kort-resultater]');
    var katTaeller = detalje.querySelector('[data-kat-taeller]');
    var saetKnap = detalje.querySelector('[data-saet-knap]');
    var saetPop = detalje.querySelector('[data-saet-pop]');
    var saetListe = detalje.querySelector('[data-saet-liste]');
    var saetFilter = detalje.querySelector('[data-saet-filter]');
    var tilfoejede = 0;
    var saetHentet = false;
    var alleSaet = [];

    function aabnSheet() {
      sheet.hidden = false;
      laasScroll(true);
      hentSaet();
      setTimeout(function () { kortInput.focus(); }, 80);
    }
    function lukSheet() {
      sheet.hidden = true;
      saetPop.hidden = true;
      saetKnap.setAttribute('aria-expanded', 'false');
      laasScroll(false);
      pendingSortKey = null; /* 5.0: "Tilføj kort her" gælder kun dette ark-besøg */
      if (tilfoejede > 0) visDetalje(aktivBinder.id); /* synk gridden med alt det nye */
    }
    detalje.querySelector('[data-kort-knap]').addEventListener('click', aabnSheet);
    detalje.querySelector('[data-sheet-luk]').addEventListener('click', lukSheet);
    sheet.addEventListener('click', function (e) { if (e.target === sheet) lukSheet(); });
    paaEscape = function () {
      if (!saetPop.hidden) { saetPop.hidden = true; saetKnap.setAttribute('aria-expanded', 'false'); return; }
      if (menuPop && !menuPop.hidden) { menuPop.hidden = true; return; }
      if (!sheet.hidden) lukSheet();
    };

    /* Sæt-vælger: egen søgbar popover — deler den cachede sæt-liste, så den
       er øjeblikkelig */
    function hentSaet() {
      if (saetHentet) return;
      saetHentet = true;
      hentSaetListe().then(function (s) {
        alleSaet = s;
        tegnSaet(saetFilter.value || '');
      });
    }
    function tegnSaet(filter) {
      var f = String(filter || '').toLowerCase();
      var vis = alleSaet.filter(function (s) {
        return !f || String(s.set_name).toLowerCase().indexOf(f) !== -1;
      });
      saetListe.innerHTML = vis.map(function (s) {
        return '<button type="button" class="mtwb2__saet-valg" data-saet-id="' + esc(s.set_id) + '" data-saet-navn="' + esc(s.set_name) + '">' +
          '<span>' + esc(s.set_name) + '</span><small>' + s.cards + ' kort</small></button>';
      }).join('') || '<p class="mtwb2__saet-tom">Ingen sæt matcher</p>';
    }
    saetKnap.addEventListener('click', function () {
      var aabn = saetPop.hidden;
      saetPop.hidden = !aabn;
      saetKnap.setAttribute('aria-expanded', aabn ? 'true' : 'false');
      if (aabn) {
        hentSaet();
        setTimeout(function () { saetFilter.focus(); }, 60);
      }
    });
    saetFilter.addEventListener('input', function () { tegnSaet(saetFilter.value.trim()); });
    saetListe.addEventListener('click', function (e) {
      var valg = e.target.closest('[data-saet-id]');
      if (!valg) return;
      saetPop.hidden = true;
      saetKnap.setAttribute('aria-expanded', 'false');
      saetKnap.innerHTML = mtwIkon('kort') + ' ' + esc(valg.getAttribute('data-saet-navn'));
      kortInput.value = '';
      sidsteSoegning = ''; /* sæt-bladring er ikke en søgning */
      kortRes.innerHTML = skeletKort(8);
      post({ action: 'soeg_katalog', set_id: valg.getAttribute('data-saet-id'), binder_id: aktivBinder.id }).then(renderKatalog);
    });

    /* Katalog-kort: tap på kortet = ✓ Har (stempel) · ＋ Mangler = ønske */
    function katKortHtml(k, medlem) {
      var thumb = k.image_small
        ? '<img src="' + esc(k.image_small) + '" alt="" loading="lazy">'
        : '<span class="mtwb2__kort-fallback" aria-hidden="true">' + mtwIkon('kort') + '</span>';
      var state = medlem ? (medlem.har ? 'har' : 'mangler') : '';
      var fod = state === 'har' ? '<span class="mtwb2__kort-tag mtwb2__kort-tag--har">✓ Har</span>'
        : state === 'mangler' ? '<span class="mtwb2__kort-tag mtwb2__kort-tag--mangler">◌ Mangler</span>'
        : '<button type="button" class="mtwb2__kort-oenske" data-oenske>＋ Mangler</button>';
      return '<div class="mtwb2__kort mtwb2__kort--kat' + (state ? ' mtwb2__kort--' + state : '') + '" data-kat="' + esc(k.id) + '"' +
        (medlem ? ' data-slot-id="' + esc(medlem.slot_id) + '"' : '') + '>' +
        '<button type="button" class="mtwb2__kort-flip" data-flip aria-label="' + esc(k.name) + ' — tap: jeg har det">' +
        '<span class="mtwb2__kort-art">' + thumb +
        (k.number ? '<span class="mtwb2__kort-nr">#' + esc(k.number) + '</span>' : '') +
        '<span class="mtwb2__kort-stamp" aria-hidden="true">✓</span>' +
        '</span></button>' +
        '<span class="mtwb2__kort-navn">' + esc(k.name) + '</span>' +
        '<span class="mtwb2__kort-fod" data-fod>' + fod + '</span></div>';
    }

    /* 5.0 Placeholder-rækken: "Tilføj eget kort" ved få/ingen søgeresultater */
    var sidsteSoegning = '';
    function phRaekkeHtml(q) {
      return '<div class="mtwb2__ph-raekke" data-ph-raekke>' +
        '<button type="button" class="mtwb2__ph-cta" data-ph-cta>' + mtwIkon('kort') +
        ' <span>Tilføj eget kort: <b>&quot;' + esc(q) + '&quot;</b></span><span class="mtwb2__l-opret">＋</span></button>' +
        '<div class="mtwb2__ph-form" data-ph-form hidden>' +
        '<input data-ph-titel type="text" maxlength="120" placeholder="Titel" value="' + esc(q) + '" aria-label="Titel">' +
        '<div class="mtwb2__ph-form-rk">' +
        '<input data-ph-saet type="text" maxlength="80" placeholder="Sæt (valgfrit)" aria-label="Sæt">' +
        '<input data-ph-nummer type="text" maxlength="20" placeholder="Nr. (valgfrit)" aria-label="Nummer">' +
        '</div>' +
        '<button type="button" class="mtwb2__knap mtwb2__knap--lille" data-ph-gem>Tilføj kortet</button>' +
        '<p class="mtwb2__b-note">Eget kort vises som en tegnet kort-bagside — matcher det senere et kort i kataloget, får det selv sit billede.</p>' +
        '</div></div>';
    }
    function bindPhRaekke() {
      var rk = kortRes.querySelector('[data-ph-raekke]');
      if (!rk) return;
      var form = rk.querySelector('[data-ph-form]');
      rk.querySelector('[data-ph-cta]').addEventListener('click', function () {
        form.hidden = !form.hidden;
        if (!form.hidden) rk.querySelector('[data-ph-titel]').focus();
      });
      rk.querySelector('[data-ph-gem]').addEventListener('click', function () {
        var gemK = this;
        var titel = trimF(rk.querySelector('[data-ph-titel]').value);
        if (!titel) { toast('Kortet skal have en titel'); return; }
        gemK.disabled = true;
        var payload = {
          action: 'tilfoej_placeholder',
          binder_id: aktivBinder.id,
          titel: titel,
          saet: trimF(rk.querySelector('[data-ph-saet]').value),
          nummer: trimF(rk.querySelector('[data-ph-nummer]').value)
        };
        if (pendingSortKey != null) payload.sort_key = pendingSortKey;
        post(payload).then(function (d) {
          gemK.disabled = false;
          if (d && d.ok && d.slot) {
            if (pendingSortKey != null) {
              if (d.slot.sort_key == null) d.slot.sort_key = pendingSortKey;
              pendingSortKey = null;
            }
            aktivSlots.push(d.slot);
            tilfoejede++;
            katTaeller.hidden = false;
            katTaeller.textContent = tilfoejede + ' gemt';
            form.hidden = true;
            toast('"' + titel + '" er tilføjet som eget kort');
          } else {
            toast((d && d.fejl) || (d && d.error) || 'Kunne ikke tilføje — prøv igen');
          }
        }).catch(function () {
          gemK.disabled = false;
          toast('Kunne ikke tilføje — tjek forbindelsen');
        });
      });
    }

    function renderKatalog(d) {
      var kort = (d && d.kort) || [];
      var iBinder = (d && d.i_binder) || {};
      var html = kort.map(function (k) { return katKortHtml(k, iBinder[k.id]); }).join('');
      if (!html) {
        html = '<p class="mtwb2__sheet-start">Ingen match — prøv et andet navn' + (sidsteSoegning ? '' : ' eller vælg et sæt') + '.</p>';
      }
      /* 5.0: få/ingen resultater på en søgning → tilbyd altid eget kort */
      if (sidsteSoegning && kort.length < 6) html += phRaekkeHtml(sidsteSoegning);
      kortRes.innerHTML = html;
      bindPhRaekke();
    }

    function gemKat(kk, harNy) {
      if (kk.getAttribute('data-travlt') === '1') return;
      kk.setAttribute('data-travlt', '1');
      var slotId = kk.getAttribute('data-slot-id');
      var nyPayload = { action: 'tilfoej_slot', binder_id: aktivBinder.id, pk_card_id: kk.getAttribute('data-kat'), har: harNy };
      if (pendingSortKey != null) nyPayload.sort_key = pendingSortKey; /* 5.0: "Tilføj kort her" */
      var opgave = slotId
        ? post({ action: 'toggle', binder_id: aktivBinder.id, slot_id: slotId, har: harNy })
        : post(nyPayload);
      opgave.then(function (r) {
        kk.removeAttribute('data-travlt');
        if (r && (r.ok || !r.error)) {
          if (!slotId && r.slot_id) kk.setAttribute('data-slot-id', r.slot_id);
          if (!slotId && pendingSortKey != null) pendingSortKey = null; /* lommen er brugt nu */
          kk.classList.remove('mtwb2__kort--har', 'mtwb2__kort--mangler');
          kk.classList.add(harNy ? 'mtwb2__kort--har' : 'mtwb2__kort--mangler');
          kk.querySelector('[data-fod]').innerHTML = harNy
            ? '<span class="mtwb2__kort-tag mtwb2__kort-tag--har">✓ Har</span>'
            : '<span class="mtwb2__kort-tag mtwb2__kort-tag--mangler">◌ Mangler</span>';
          if (harNy) stempl(kk);
          tilfoejede++;
          katTaeller.hidden = false;
          katTaeller.textContent = tilfoejede + ' gemt';
        } else {
          toast((r && r.fejl) || 'Kunne ikke gemme — prøv igen');
        }
      });
    }

    kortRes.addEventListener('click', function (e) {
      var kk = e.target.closest('[data-kat]');
      if (!kk) return;
      if (e.target.closest('[data-oenske]')) { gemKat(kk, false); return; }
      if (e.target.closest('[data-flip]')) {
        gemKat(kk, !kk.classList.contains('mtwb2__kort--har'));
      }
    });

    var kortT;
    kortInput.addEventListener('input', function () {
      clearTimeout(kortT);
      var q = kortInput.value.trim();
      if (q.length < 2) return;
      saetKnap.innerHTML = mtwIkon('kort') + ' Sæt';
      kortT = setTimeout(function () {
        sidsteSoegning = q; /* 5.0: styrer "Tilføj eget kort"-rækken */
        kortRes.innerHTML = skeletKort(8);
        post({ action: 'soeg_katalog', q: q, binder_id: aktivBinder.id }).then(renderKatalog);
      }, 300);
    });

    /* Tom binder → arket åbner selv; invitationen ligger bag skuffen, aldrig som dublet */
    if (!slots.length) aabnSheet();

    /* ---- Broen: mangler på lager → kurven ---- */
    if (slots.length - har > 0) {
      var broBinderId = aktivBinder.id;
      Promise.all([post({ action: 'mangler_paa_lager', binder_id: broBinderId }), forudVarianter()]).then(function (res) {
        var d = res[0], forud = res[1];
        if (!aktivBinder || aktivBinder.id !== broBinderId) return; /* skiftet binder imens */
        /* Forudbestillinger (ingen kurv-egenskab Forudbestilling) og Kommer snart lægges ikke i kurven herfra */
        var matches = ((d && d.matches) || []).filter(function (m) { return !forud[String(m.variant_id)]; });
        if (!matches.length) return;
        bulkMatches = matches; /* 4.0: deles med Fuldfør-hjælperen */
        var total = matches.reduce(function (sum, m) { return sum + (m.pris || 0); }, 0);
        var totalTekst = total.toLocaleString('da-DK', { maximumFractionDigits: 0 });
        var bar = document.createElement('div');
        bar.className = 'mtwb2__bulk';
        var kobTekst = 'Læg alle i kurven';
        if (master) {
          /* Master set: serveren har valgt udgaven pr. lomme (Normal / Reverse Holo) */
          var nRh = matches.filter(function (m) { return m.udgave === 'rh'; }).length;
          var fordeling = [];
          if (matches.length - nRh > 0) fordeling.push((matches.length - nRh) + ' kort');
          if (nRh > 0) fordeling.push(nRh + ' Reverse Holo');
          kobTekst = 'Læg alle ' + matches.length + ' i kurven';
          /* De første 4 kort under baren ("#15 Virizion · Normal · 7 kr"), tegnet sammen med baren (intet layout-hop) */
          var vist = matches.slice(0, 4).map(function (m) {
            var s = slotData(m.slot_id) || {};
            var navn = s.title || String(m.title || '').split(' - ')[0];
            return '<li><span>' + (s.number ? '#' + esc(s.number) + ' ' : '') + esc(navn) + '</span>' +
              '<span>' + (m.udgave === 'rh' ? 'Reverse Holo' : 'Normal') + ' · ' + fmtKr(m.pris) + ' kr</span></li>';
          }).join('');
          if (matches.length > 4) vist += '<li><span aria-hidden="true">…</span><span class="mtwb2__bulk-mere">og ' + (matches.length - 4) + ' flere</span></li>';
          bar.classList.add('mtwb2__bulk--master');
          bar.innerHTML = '<span class="mtwb2__bulk-tekst">' + mtwIkon('kurv') + ' <strong>' + matches.length + ' af dine manglende kort er på lager hos os</strong><br>' +
            fordeling.join(' og ') + ' · ca. ' + totalTekst + ' kr i alt</span>' +
            '<button type="button" class="mtwb2__knap mtwb2__knap--lille" data-bulk-kob>' + kobTekst + '</button>' +
            '<ul class="mtwb2__bulk-liste" aria-label="Kort på lager">' + vist + '</ul>';
        } else {
          bar.innerHTML = '<span class="mtwb2__bulk-tekst">' + mtwIkon('kurv') + ' <strong>' + matches.length + ' af dine mangler</strong> er på lager lige nu — samlet <strong>' +
            totalTekst + ' kr</strong></span>' +
            '<button type="button" class="mtwb2__knap mtwb2__knap--lille" data-bulk-kob>Læg alle i kurven</button>';
        }
        /* Øverst — det vigtigste budskab skal ses med det samme */
        var anker = detalje.querySelector('.mtwb2__d-raekke') || detalje.querySelector('.mtwb2__seg');
        if (anker && anker.parentNode) anker.parentNode.insertBefore(bar, anker);
        else detalje.appendChild(bar);
        bar.querySelector('[data-bulk-kob]').addEventListener('click', function () {
          var knap = this;
          knap.disabled = true;
          knap.textContent = 'Lægger i kurven …';
          fetch('/cart/add.js', {
            method: 'POST',
            credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: matches.map(function (m) { return { id: Number(m.variant_id), quantity: 1 }; }) })
          }).then(function (r) {
            if (!r.ok) throw new Error('cart ' + r.status);
            knap.textContent = '✓ Lagt i kurven';
            knap.insertAdjacentHTML('afterend', '<a class="mtwb2__knap mtwb2__knap--lille" href="/cart">Se kurven →</a>');
            toast(matches.length + ' kort lagt i kurven');
          }).catch(function () {
            knap.disabled = false;
            knap.textContent = kobTekst;
            toast('Kunne ikke lægge alt i kurven — prøv igen');
          });
        });
      });
    }

    /* ---- 4.0 Fuldfør-hjælperen ---- */
    var fuKnap = detalje.querySelector('[data-fuldfoer-knap]');
    if (fuKnap) fuKnap.addEventListener('click', aabnFuldfoer);

    /* ---- Fyld-mode + omdøb/slet (fra redigér-menuen) ---- */
    var fyldBar = detalje.querySelector('[data-fyld-bar]');
    detalje.querySelector('[data-fyld-knap]').addEventListener('click', function () {
      if (menuPop) menuPop.hidden = true;
      var til = !fyldBar.classList.contains('mtwb2__fyld--vis');
      fyldBar.classList.toggle('mtwb2__fyld--vis', til);
      grid.classList.toggle('mtwb2__grid--fyld', til); /* 4.0: viser antal-steppers */
      if (til) toast('Tap dig gennem binderen — eller tast numre');
    });
    detalje.querySelector('[data-fyld-luk]').addEventListener('click', function () {
      fyldBar.classList.remove('mtwb2__fyld--vis');
      grid.classList.remove('mtwb2__grid--fyld');
    });
    detalje.querySelectorAll('[data-fyld-udg]').forEach(function (k) {
      k.addEventListener('click', function () {
        fyldUdgave = k.getAttribute('data-fyld-udg');
        detalje.querySelectorAll('[data-fyld-udg]').forEach(function (x) { x.setAttribute('aria-pressed', x === k ? 'true' : 'false'); });
      });
    });
    detalje.querySelector('[data-nr-marker]').addEventListener('click', function () {
      var numre = detalje.querySelector('[data-nr-input]').value.trim();
      if (!numre) { toast('Tast numre først — fx 1-12, 15'); return; }
      var nrPayload = { action: 'marker_numre', binder_id: aktivBinder.id, numre: numre };
      if (master) nrPayload.udgave = fyldUdgave;
      post(nrPayload).then(function (d) {
        if (d && d.ok) { toast(d.ramte + (master && fyldUdgave === 'rh' ? ' Reverse Holo' : ' kort') + ' markeret som HAR ✓'); visDetalje(aktivBinder.id); }
        else toast((d && d.fejl) || 'Ingen numre genkendt');
      });
    });
    detalje.querySelector('[data-vend-om]').addEventListener('click', function () {
      if (!window.confirm('Markér ALLE ' + slots.length + ' slots som HAR? (Du fjerner bagefter dine få mangler med et tap)')) return;
      post({ action: 'vend_om', binder_id: aktivBinder.id }).then(function () { visDetalje(aktivBinder.id); });
    });
    /* Udseende-vælger: ikon + farve for binderen */
    var udseendeKnap = detalje.querySelector('[data-udseende]');
    if (udseendeKnap) udseendeKnap.addEventListener('click', function () {
      menuPop.hidden = true;
      fjernLoseModaler();
      var valgtIkon = binder.cover || 'dex';
      var valgtFarve = binder.farve || '';
      var bag = document.createElement('div');
      bag.className = 'mtwb2__modal-bag';
      bag.innerHTML =
        '<div class="mtwb2__modal" role="dialog" aria-modal="true" aria-label="Skift udseende">' +
        '<button type="button" class="mtwb2__modal-luk" data-u-luk aria-label="Luk">✕</button>' +
        '<h3>Skift udseende</h3>' +
        '<p class="mtwb2__sub">Ikon:</p>' +
        '<div class="mtwb2__u-ikoner">' + IKON_NOEGLER.map(function (i) {
          return '<button type="button" class="mtwb2__u-ikon' + (i === valgtIkon ? ' mtwb2__u-valgt' : '') + '" data-u-ikon="' + i + '" aria-label="' + i + '">' + mtwIkon(i) + '</button>';
        }).join('') + '</div>' +
        '<p class="mtwb2__sub">Farve på ryggen:</p>' +
        '<div class="mtwb2__u-farver">' + FARVE_NAVNE.map(function (f) {
          return '<button type="button" class="mtwb2__u-farve mtwb2__farve--' + f + (f === valgtFarve ? ' mtwb2__u-valgt' : '') + '" data-u-farve="' + f + '" aria-label="' + f + '"></button>';
        }).join('') + '</div>' +
        '<div style="margin-top:16px;text-align:right"><button type="button" class="mtwb2__knap mtwb2__knap--lille" data-u-gem>Gem</button></div>' +
        '</div>';
      (rod || document.body).appendChild(bag);
      function lukU() { bag.remove(); }
      bag.addEventListener('click', function (e) { if (e.target === bag) lukU(); });
      bag.querySelector('[data-u-luk]').addEventListener('click', lukU);
      bag.querySelectorAll('[data-u-ikon]').forEach(function (k) {
        k.addEventListener('click', function () {
          valgtIkon = k.getAttribute('data-u-ikon');
          bag.querySelectorAll('[data-u-ikon]').forEach(function (x) { x.classList.remove('mtwb2__u-valgt'); });
          k.classList.add('mtwb2__u-valgt');
        });
      });
      bag.querySelectorAll('[data-u-farve]').forEach(function (k) {
        k.addEventListener('click', function () {
          valgtFarve = k.getAttribute('data-u-farve');
          bag.querySelectorAll('[data-u-farve]').forEach(function (x) { x.classList.remove('mtwb2__u-valgt'); });
          k.classList.add('mtwb2__u-valgt');
        });
      });
      bag.querySelector('[data-u-gem]').addEventListener('click', function () {
        post({ action: 'udseende', binder_id: aktivBinder.id, cover: valgtIkon, farve: valgtFarve }).then(function (d) {
          lukU();
          if (d && d.ok) { toast('Udseendet er gemt'); visDetalje(aktivBinder.id); }
          else toast((d && d.fejl) || 'Kunne ikke gemme');
        });
      });
    });

    /* 4.0 Deling + print (fra redigér-menuen) */
    var delKnap = detalje.querySelector('[data-del-binder]');
    if (delKnap) delKnap.addEventListener('click', function () {
      menuPop.hidden = true;
      aabnDeling(binder);
    });
    var printKnap = detalje.querySelector('[data-print-mangler]');
    if (printKnap) printKnap.addEventListener('click', function () {
      menuPop.hidden = true;
      printMangelliste(binder);
    });
    var importKnap = detalje.querySelector('[data-import-csv]');
    if (importKnap) importKnap.addEventListener('click', function () {
      menuPop.hidden = true;
      aabnImport(binder);
    });

    /* ---- Master set: gør til master set / fjern Reverse Holo-lommer igen.
       Efter begge hentes binderen igen og tegnes forfra. ---- */
    function goerMaster() {
      if (!aktivBinder || goerMasterIGang) return;
      var binderId = aktivBinder.id;
      function knapper(slaa) {
        detalje.querySelectorAll('[data-goer-master]').forEach(function (k) { k.disabled = slaa; });
      }
      goerMasterIGang = true;
      knapper(true);
      toast('Laver master set …');
      post({ action: 'goer_master', binder_id: binderId }).then(function (d) {
        goerMasterIGang = false;
        if (d && d.ok) {
          var n = typeof d.tilfoejet === 'number' ? d.tilfoejet : null; /* portalens svar: { ok, tilfoejet } */
          toast(n != null ? 'Nu er det et master set. ' + rhLommer(n) + ' er tilføjet' : 'Nu er det et master set');
          if (aktivBinder && String(aktivBinder.id) === String(binderId)) visDetalje(binderId);
        } else {
          knapper(false);
          toast((d && d.fejl) || 'Kunne ikke lave master set. Prøv igen.');
        }
      }).catch(function () {
        goerMasterIGang = false;
        knapper(false);
        toast('Kunne ikke lave master set. Tjek forbindelsen.');
      });
    }
    function aabnFjernMaster() {
      if (!aktivBinder) return;
      fjernLoseModaler();
      var binderId = aktivBinder.id;
      var t = taelUdgaver(aktivSlots).rh;
      var bag = document.createElement('div');
      bag.className = 'mtwb2__modal-bag';
      bag.innerHTML =
        '<div class="mtwb2__modal mtwb2__ms-bekraeft" role="alertdialog" aria-modal="true" aria-labelledby="mtwb2-fm-titel" aria-describedby="mtwb2-fm-tekst">' +
        '<button type="button" class="mtwb2__modal-luk" data-fm-luk aria-label="Luk">✕</button>' +
        '<h3 id="mtwb2-fm-titel">Fjern Reverse Holo-lommer?</h3>' +
        '<p class="mtwb2__sub" id="mtwb2-fm-tekst">Samlingen bliver til "Kun kortene" igen. Vi fjerner ' + rhLommer(t.total) + '.' +
        (t.har ? ' Du har markeret ' + t.har + ' af dem, og de markeringer bliver slettet.' : '') +
        ' Dine almindelige kort bliver liggende.</p>' +
        '<div class="mtwb2__ms-knapper">' +
        '<button type="button" class="mtwb2__knap mtwb2__knap--ghost" data-fm-nej>Behold dem</button>' +
        '<button type="button" class="mtwb2__knap mtwb2__ms-fjern" data-fm-ja>Fjern lommerne</button>' +
        '</div></div>';
      (rod || document.body).appendChild(bag);
      function lukFm() { bag.remove(); }
      bag.addEventListener('click', function (e) { if (e.target === bag) lukFm(); });
      bag.addEventListener('keydown', function (e) { if (e.key === 'Escape') { e.stopPropagation(); lukFm(); } });
      bag.querySelector('[data-fm-luk]').addEventListener('click', lukFm);
      bag.querySelector('[data-fm-nej]').addEventListener('click', lukFm);
      bag.querySelector('[data-fm-ja]').addEventListener('click', function () {
        var ja = this;
        ja.disabled = true;
        post({ action: 'fjern_master', binder_id: binderId }).then(function (d) {
          if (d && d.ok) {
            lukFm();
            lukMsBanner(binderId); /* fravalgt med vilje: spørg ikke igen */
            toast('Reverse Holo-lommerne er fjernet');
            if (aktivBinder && String(aktivBinder.id) === String(binderId)) visDetalje(binderId);
          } else {
            ja.disabled = false;
            toast((d && d.fejl) || 'Kunne ikke fjerne lommerne. Prøv igen.');
          }
        }).catch(function () {
          ja.disabled = false;
          toast('Kunne ikke fjerne lommerne. Tjek forbindelsen.');
        });
      });
      setTimeout(function () { var n = bag.querySelector('[data-fm-nej]'); if (n) n.focus(); }, 60);
    }
    detalje.querySelectorAll('[data-goer-master]').forEach(function (k) {
      k.addEventListener('click', function () {
        if (menuPop) menuPop.hidden = true;
        goerMaster();
      });
    });
    var fjernMasterKnap = detalje.querySelector('[data-fjern-master]');
    if (fjernMasterKnap) fjernMasterKnap.addEventListener('click', function () {
      menuPop.hidden = true;
      aabnFjernMaster();
    });
    var msBanner = detalje.querySelector('[data-ms-banner]');
    if (msBanner) msBanner.querySelector('[data-ms-banner-luk]').addEventListener('click', function () {
      lukMsBanner(binder.id);
      msBanner.parentNode.removeChild(msBanner);
    });

    var omdobKnap = detalje.querySelector('[data-omdob]');
    if (omdobKnap) omdobKnap.addEventListener('click', function () {
      menuPop.hidden = true;
      var navn = window.prompt('Nyt navn:', binder.name);
      if (navn && navn.trim()) post({ action: 'omdob', binder_id: aktivBinder.id, navn: navn.trim() }).then(function () { visDetalje(aktivBinder.id); });
    });
    var sletKnap = detalje.querySelector('[data-slet]');
    if (sletKnap) sletKnap.addEventListener('click', function () {
      menuPop.hidden = true;
      if (!window.confirm('Slet "' + binder.name + '"? Det kan ikke fortrydes.')) return;
      post({ action: 'slet', binder_id: aktivBinder.id }).then(visHylde);
    });
  }

  /* Gen-tegn siderne hvis breakpointet krydses, mens side-visningen er åben */
  try {
    var mqSider = window.matchMedia('(min-width: 720px)');
    var mqLyt = function () {
      var s = detalje && detalje.querySelector('[data-sider]');
      if (s && !s.hidden && aktivTegnSider) aktivTegnSider();
    };
    if (mqSider.addEventListener) mqSider.addEventListener('change', mqLyt);
    else if (mqSider.addListener) mqSider.addListener(mqLyt);
  } catch (eMq) { /* gamle browsere */ }

  function anvendFilter() {
    detalje.querySelectorAll('[data-slot]').forEach(function (s) {
      var har = s.getAttribute('data-har') === '1';
      var okFilter = aktivFilter === 'alle' || (aktivFilter === 'har') === har;
      /* master set: udgave-filteret lægges oven på Alle/Har/Mangler */
      var okUdgave = aktivUdgave === 'alle' || (s.getAttribute('data-udgave') || 'normal') === aktivUdgave;
      s.style.display = okFilter && okUdgave ? '' : 'none';
    });
  }

  function saetKortState(el, har) {
    el.setAttribute('data-har', har ? '1' : '0');
    el.classList.toggle('mtwb2__kort--har', har);
    el.classList.toggle('mtwb2__kort--mangler', !har);
  }

  function synkSlotHar(id, har) {
    aktivSlots.forEach(function (s) { if (String(s.id) === String(id)) s.har = har; });
  }

  /* 4.0 Antal pr. slot: ×N-badge + steppertal holdes i sync */
  function visAntal(slotEl, n) {
    slotEl.setAttribute('data-antal', n);
    var tal = slotEl.querySelector('[data-antal-tal]');
    if (tal) tal.textContent = n;
    var badge = slotEl.querySelector('[data-antal-badge]');
    if (badge) {
      badge.textContent = '×' + n;
      badge.hidden = !(n > 1 && slotEl.getAttribute('data-har') === '1');
    }
  }

  function saetAntal(slotEl, ny) {
    ny = Math.max(1, Math.min(99, ny));
    var gammel = parseInt(slotEl.getAttribute('data-antal'), 10) || 1;
    if (ny === gammel) return;
    var id = slotEl.getAttribute('data-slot');
    /* Optimistisk UI — serveren sætter også har=true */
    visAntal(slotEl, ny);
    if (slotEl.getAttribute('data-har') !== '1') {
      saetKortState(slotEl, true);
      synkSlotHar(id, true);
      visAntal(slotEl, ny);
      opdaterTaellere();
      anvendFilter();
    }
    aktivSlots.forEach(function (s) { if (String(s.id) === String(id)) s.antal = ny; });
    post({ action: 'antal', binder_id: aktivBinder.id, slot_id: id, antal: ny }).then(function (d) {
      if (!d || !d.ok) {
        visAntal(slotEl, gammel);
        aktivSlots.forEach(function (s) { if (String(s.id) === String(id)) s.antal = gammel; });
        toast('Kunne ikke gemme antal — prøv igen');
      }
    });
  }

  function toggleSlot(el) {
    var nyHar = el.getAttribute('data-har') !== '1';
    saetKortState(el, nyHar);
    synkSlotHar(el.getAttribute('data-slot'), nyHar);
    visAntal(el, parseInt(el.getAttribute('data-antal'), 10) || 1);
    if (nyHar) stempl(el);
    opdaterTaellere();
    anvendFilter();
    post({ action: 'toggle', binder_id: aktivBinder.id, slot_id: el.getAttribute('data-slot'), har: nyHar })
      .then(function (d) {
        if (!d || d.error) {
          /* Rul optimistisk UI tilbage, så skærmen aldrig lyver */
          saetKortState(el, !nyHar);
          synkSlotHar(el.getAttribute('data-slot'), !nyHar);
          visAntal(el, parseInt(el.getAttribute('data-antal'), 10) || 1);
          opdaterTaellere();
          anvendFilter();
          toast('Kunne ikke gemme — prøv igen');
        }
      });
  }

  /* ---------- 5.0 Kort-handlinger (forstør / vend / lås / fjern) ---------- */
  function slotData(id) {
    var m = null;
    aktivSlots.forEach(function (s) { if (String(s.id) === String(id)) m = s; });
    return m;
  }
  function gridSlotEl(id) {
    return detalje.querySelector('[data-slots] [data-slot="' + String(id).replace(/"/g, '') + '"]');
  }
  function siderErAktive() {
    var s = detalje.querySelector('[data-sider]');
    return !!(s && !s.hidden);
  }
  function genTegnSider() {
    if (siderErAktive() && aktivTegnSider) aktivTegnSider();
  }

  /* 5.0 Fjern UDEN confirm(): kortet ryger straks — Fortryd-toasten
     genopretter via tilfoej_slot/tilfoej_placeholder (best effort). */
  function fjernSlotMedFortryd(id) {
    var s = slotData(id);
    if (!s || !aktivBinder) return;
    var binderId = aktivBinder.id;
    var kopi = {
      pk_card_id: s.pk_card_id, har: s.har, antal: s.antal, sort_key: s.sort_key,
      title: s.title, set_name: s.set_name, number: s.number, udgave: s.udgave
    };
    aktivSlots = aktivSlots.filter(function (x) { return String(x.id) !== String(id); });
    var el = gridSlotEl(id);
    if (el && el.parentNode) el.parentNode.removeChild(el);
    opdaterTaellere();
    genTegnSider();
    post({ action: 'fjern_slot', binder_id: binderId, slot_id: id }).then(function (d) {
      if (d && d.ok) {
        visFortryd('"' + (rhTitel(kopi) || 'Kortet') + '" er fjernet', function () {
          genopretSlot(binderId, kopi);
        });
      } else {
        toast('Kunne ikke fjerne — prøv igen');
        if (aktivBinder && String(aktivBinder.id) === String(binderId)) visDetalje(binderId);
      }
    }).catch(function () {
      toast('Kunne ikke fjerne — tjek forbindelsen');
      if (aktivBinder && String(aktivBinder.id) === String(binderId)) visDetalje(binderId);
    });
  }

  /* 5.0 Vend: flip på hovedet — persisteret via `vendt` */
  function vendSlot(id) {
    var s = slotData(id);
    if (!s || !aktivBinder) return;
    var til = !s.vendt;
    s.vendt = til;
    var el = gridSlotEl(id);
    if (el) el.classList.toggle('mtwb2__kort--vendt', til);
    genTegnSider();
    post({ action: 'vend', binder_id: aktivBinder.id, slot_id: id, til: til }).then(function (d) {
      if (!d || !d.ok) {
        s.vendt = !til;
        if (el) el.classList.toggle('mtwb2__kort--vendt', !til);
        genTegnSider();
        toast('Kunne ikke vende kortet — prøv igen');
      }
    }).catch(function () {
      s.vendt = !til;
      if (el) el.classList.toggle('mtwb2__kort--vendt', !til);
      genTegnSider();
      toast('Kunne ikke vende kortet — tjek forbindelsen');
    });
  }

  /* 5.0 Lås: låste kort kan ikke trækkes og springes over af serveren */
  function laasSlot(id) {
    var s = slotData(id);
    if (!s || !aktivBinder) return;
    var til = !s.laast;
    post({ action: 'laas', binder_id: aktivBinder.id, slot_id: id, til: til }).then(function (d) {
      if (d && d.ok) {
        s.laast = til;
        var el = gridSlotEl(id);
        if (el) {
          el.classList.toggle('mtwb2__kort--laastslot', til);
          var badge = el.querySelector('[data-laas-badge]');
          if (badge) badge.hidden = !til;
          var knap = el.querySelector('[data-akt-laas]');
          if (knap) {
            knap.innerHTML = mtwIkon(til ? 'laas' : 'laas-aaben');
            knap.title = til ? 'Lås op' : 'Lås fast';
          }
        }
        genTegnSider();
        toast(til ? 'Kortet er låst fast' : 'Kortet er låst op');
      } else {
        toast('Kunne ikke låse — prøv igen');
      }
    }).catch(function () { toast('Kunne ikke låse — tjek forbindelsen'); });
  }

  /* 5.0 Forstør: stort billede + data + butiks-match (match_produkter) */
  function aabnForstoer(id) {
    var s = slotData(id);
    if (!s) return;
    fjernLoseModaler();
    var ph = erPlaceholder(s) && !s.image_url;
    var art = ph
      ? '<span class="mtwb2__fs-ph"><span class="mtwb2__ph">' +
        '<span class="mtwb2__ph-cirkel" aria-hidden="true">' + mtwIkon('kort') + '</span>' +
        '<span class="mtwb2__ph-titel">' + esc(s.title || 'Eget kort') + '</span>' +
        '<span class="mtwb2__ph-badge">Eget kort</span></span></span>'
      : (s.image_url
        ? '<img class="mtwb2__fs-img' + (s.vendt ? ' mtwb2__fs-img--vendt' : '') + '" src="' + esc(s.image_url) + '" alt="' + esc(s.title) + '">'
        : '<span class="mtwb2__fs-ph"><span class="mtwb2__kort-fallback">' + mtwIkon('kort') + '</span></span>');
    var bag = document.createElement('div');
    bag.className = 'mtwb2__modal-bag';
    bag.innerHTML =
      '<div class="mtwb2__modal mtwb2__fs" role="dialog" aria-modal="true" aria-label="' + esc(rhTitel(s)) + '">' +
      '<button type="button" class="mtwb2__modal-luk" data-fs-luk aria-label="Luk">✕</button>' +
      '<div class="mtwb2__fs-art' + (erRh(s) ? ' mtwb2__fs-art--rh' : '') + '">' + art + '</div>' +
      '<h3>' + esc(s.title) + rhNavn(s) + '</h3>' +
      ((s.set_name || s.number)
        ? '<p class="mtwb2__sub">' + esc(s.set_name || '') + (s.number ? (s.set_name ? ' · ' : '') + '#' + esc(s.number) : '') + (erRh(s) ? ' · Reverse Holo' : '') + '</p>'
        : '') +
      (s.pris != null ? '<p class="mtwb2__fs-pris">≈ ' + fmtKr(s.pris) + ' kr <small>vejledende Cardmarket-værdi</small></p>' : '') +
      '<div class="mtwb2__fs-butik" data-fs-butik>' +
      ((s.set_name && s.number) ? '<p class="mtwb2__b-note">Tjekker lageret hos Matraws …</p>' : '') +
      '</div>' +
      '</div>';
    (rod || document.body).appendChild(bag);
    function lukFs() { bag.remove(); }
    bag.addEventListener('click', function (e) { if (e.target === bag) lukFs(); });
    bag.querySelector('[data-fs-luk]').addEventListener('click', lukFs);
    var butik = bag.querySelector('[data-fs-butik]');
    if (s.set_name && s.number) {
      /* Master set og RH-lommer: slå op med lommens udgave (butik["sæt|nr|normal"] / ["sæt|nr|rh"],
         kun varianter af netop den udgave). Den gamle nøgle "sæt|nr" (billigste af alle udgaver)
         gælder kun normale lommer i andre samlinger. master/udgave kommer kun fra en ny backend,
         så her findes de nye nøgler altid; mangler nøglen, har butikken ikke den udgave. */
      var udg = (erMaster(aktivBinder) || erRh(s)) ? (erRh(s) ? 'rh' : 'normal') : null;
      post({ action: 'match_produkter', butik: true, rows: [{ set: s.set_name, number: s.number }] }).then(function (d) {
        if (!butik.parentNode) return; /* modalen er lukket */
        var m = (d && d.butik) || {};
        var base = normSet(s.set_name) + '|' + normNr(s.number);
        var hit = udg ? m[base + '|' + udg] : (m[base] || m[s.set_name + '|' + s.number]);
        if (hit && hit.handle && hit.tilgaengelig !== false) {
          /* variant_id (ny backend) åbner produktsiden på netop lommens udgave */
          var vid = hit.variant_id != null && /^\d+$/.test(String(hit.variant_id)) ? '?variant=' + String(hit.variant_id) : '';
          butik.innerHTML =
            '<a class="mtwb2__knap mtwb2__knap--lille" href="/products/' + esc(hit.handle) + vid + '">' + mtwIkon('kurv') + ' Køb på Matraws →</a>' +
            (hit.pris ? '<span class="mtwb2__fs-butik-pris">' + fmtKr(hit.pris) + ' kr</span>' : '');
        } else {
          butik.innerHTML = '<p class="mtwb2__b-note">Ikke på lager hos os lige nu</p>';
        }
      }).catch(function () {
        if (butik.parentNode) butik.innerHTML = '<p class="mtwb2__b-note">Kunne ikke tjekke lageret lige nu</p>';
      });
    }
  }

  /* 5.0 Mobil: lille action-sheet i stedet for hover-knapper */
  function aabnKortSheet(id) {
    var s = slotData(id);
    if (!s) return;
    fjernLoseModaler();
    var bag = document.createElement('div');
    bag.className = 'mtwb2__modal-bag mtwb2__modal-bag--bm';
    bag.innerHTML =
      '<div class="mtwb2__modal mtwb2__bm" role="dialog" aria-modal="true" aria-label="' + esc(rhTitel(s)) + '">' +
      '<button type="button" class="mtwb2__modal-luk" data-ks-luk aria-label="Luk">✕</button>' +
      '<h3>' + esc(s.title) + rhNavn(s) + '</h3>' +
      '<div class="mtwb2__bm-liste">' +
      '<button type="button" class="mtwb2__bm-rk" data-ks="forstoer">' + mtwIkon('lup') + '<span><b>Forstør</b><small>Stort billede, pris og lager</small></span></button>' +
      '<button type="button" class="mtwb2__bm-rk" data-ks="toggle">✓<span><b>' + (s.har ? 'Markér som mangler' : 'Markér som har') + '</b></span></button>' +
      '<button type="button" class="mtwb2__bm-rk" data-ks="vend">' + mtwIkon('byt') + '<span><b>' + (s.vendt ? 'Vend rigtigt igen' : 'Vend på hovedet') + '</b></span></button>' +
      '<button type="button" class="mtwb2__bm-rk" data-ks="laas">' + mtwIkon(s.laast ? 'laas-aaben' : 'laas') + '<span><b>' + (s.laast ? 'Lås op' : 'Lås fast') + '</b><small>Låste kort bliver stående når andre flyttes</small></span></button>' +
      '<button type="button" class="mtwb2__bm-rk mtwb2__bm-rk--slet" data-ks="fjern">✕<span><b>Fjern fra binderen</b><small>Du kan fortryde i 5 sekunder</small></span></button>' +
      '</div></div>';
    (rod || document.body).appendChild(bag);
    function lukKs() { bag.remove(); }
    bag.addEventListener('click', function (e) { if (e.target === bag) lukKs(); });
    bag.querySelector('[data-ks-luk]').addEventListener('click', lukKs);
    bag.querySelectorAll('[data-ks]').forEach(function (k) {
      k.addEventListener('click', function () {
        var hvad = k.getAttribute('data-ks');
        lukKs();
        if (hvad === 'forstoer') { aabnForstoer(id); return; }
        if (hvad === 'vend') { vendSlot(id); return; }
        if (hvad === 'laas') { laasSlot(id); return; }
        if (hvad === 'fjern') { fjernSlotMedFortryd(id); return; }
        if (hvad === 'toggle') {
          var el = gridSlotEl(id);
          if (el) toggleSlot(el);
          genTegnSider();
        }
      });
    });
  }

  function opdaterTaellere() {
    var alle = detalje.querySelectorAll('[data-slot]');
    var har = detalje.querySelectorAll('[data-slot][data-har="1"]').length;
    var pct = alle.length ? Math.round((har / alle.length) * 100) : 0;
    var cfill = detalje.querySelector('[data-cfill]');
    if (cfill) cfill.style.width = pct + '%';
    var cbar = detalje.querySelector('[data-cbar]');
    if (cbar) cbar.classList.toggle('mtwb2__cbar--fuld', pct >= 100);
    var tekst = detalje.querySelector('[data-frem-tekst]');
    if (tekst) tekst.textContent = har + ' af ' + alle.length + ' kort';
    var pctEl = detalje.querySelector('[data-frem-pct]');
    if (pctEl) pctEl.textContent = pct + ' %';
    /* Alle/Har/Mangler tæller den valgte udgave (master set); ellers alt */
    var segAlle = alle.length, segHar = har;
    if (aktivUdgave !== 'alle') {
      segAlle = detalje.querySelectorAll('[data-slot][data-udgave="' + aktivUdgave + '"]').length;
      segHar = detalje.querySelectorAll('[data-slot][data-udgave="' + aktivUdgave + '"][data-har="1"]').length;
    }
    var aA = detalje.querySelector('[data-antal="alle"]');
    if (aA) aA.textContent = segAlle;
    var aH = detalje.querySelector('[data-antal="har"]');
    if (aH) aH.textContent = segHar;
    var aM = detalje.querySelector('[data-antal="mangler"]');
    if (aM) aM.textContent = segAlle - segHar;
    /* Master set: delbjælkerne "Kortene a / b" og "Reverse Holo c / d" */
    if (detalje.querySelector('[data-frem2]')) {
      ['normal', 'rh'].forEach(function (u) {
        var uAlle = detalje.querySelectorAll('[data-slot][data-udgave="' + u + '"]').length;
        var uHar = detalje.querySelectorAll('[data-slot][data-udgave="' + u + '"][data-har="1"]').length;
        var fill = detalje.querySelector('[data-cfill-' + u + ']');
        if (fill) fill.style.width = pctAf(uHar, uAlle) + '%';
        var t = detalje.querySelector('[data-frem-' + u + ']');
        if (t) t.textContent = uHar + ' / ' + uAlle;
      });
    }
    /* 4.0 Binder-værdi + Fuldfør-knap følger med */
    opdaterVaerdiLinje();
    var fuKnap = detalje.querySelector('[data-fuldfoer-knap]');
    if (fuKnap) fuKnap.hidden = (alle.length - har) === 0;
    /* 4.0 Achievements: medalje-badge + fejring i ØJEBLIKKET 100 % rammes */
    var dMedalje = detalje.querySelector('[data-d-medalje]');
    if (dMedalje) dMedalje.hidden = !(alle.length && pct >= 100);
    if (aktivBinder && alle.length && pct >= 100 && forrigePct !== null && forrigePct < 100 && !fejret[aktivBinder.id]) {
      fejret[aktivBinder.id] = 1;
      fejr();
      toast('100 % — binderen er fuldført. Flot samlet!');
    }
    forrigePct = pct;
  }

  /* ---------- 4.0 Deling: offentlig read-only visning (?del=<token>).
     Virker både logget ind og logget ud — ejeren får en genvej til den
     rigtige binder. ---------- */
  function pubCta() {
    return erKunde
      ? '<a class="mtwb2__knap" href="' + window.location.pathname + '">Byg din egen binder →</a>'
      : '<a class="mtwb2__knap" href="/customer_authentication/login?return_to=' + encodeURIComponent(window.location.pathname) + '">Byg din egen binder hos Matraws</a>';
  }

  function pubKortHtml(s) {
    var art = s.image_url
      ? '<img src="' + esc(s.image_url) + '" alt="" loading="lazy">'
      : '<span class="mtwb2__kort-fallback" aria-hidden="true">' + mtwIkon('kort') + '</span>';
    var antal = s.antal > 1 ? s.antal : 1;
    return '<div class="mtwb2__kort mtwb2__kort--laast ' + (s.har ? 'mtwb2__kort--har' : 'mtwb2__kort--mangler') + (s.vendt ? ' mtwb2__kort--vendt' : '') + (erRh(s) ? ' mtwb2__kort--rh' : '') + '">' +
      '<span class="mtwb2__kort-art">' + art +
      (s.number ? '<span class="mtwb2__kort-nr">#' + esc(s.number) + '</span>' : '') +
      (erRh(s) ? rhMaerke() : '') +
      (s.har && antal > 1 ? '<span class="mtwb2__kort-antal">×' + antal + '</span>' : '') +
      '<span class="mtwb2__kort-stamp" aria-hidden="true">✓</span>' +
      '</span>' +
      '<span class="mtwb2__kort-navn">' + esc(s.title) + rhNavn(s) + '</span>' +
      '</div>';
  }

  /* 5.0 Read-only side-visning til delte/offentlige binders — respekterer
     lomme_format + sort_key + vendt, ingen knapper på kortene. */
  function tegnPubSider(holder, binder, slots) {
    var format = binder.lomme_format === 4 || binder.lomme_format === 12 ? binder.lomme_format : 9;
    var fordelt = fordelLommer(slots);
    var antalSider = Math.max(1, Math.ceil((fordelt.maxIdx + 1) / format));
    var side = 0;
    function tegn() {
      if (side < 0) side = 0;
      if (side >= antalSider) side = antalSider - 1;
      var start = side * format;
      var lommer = '';
      for (var i = start; i < start + format; i++) {
        var s = fordelt.pladser[i];
        if (s) {
          lommer += '<div class="mtwb2__lomme ' + (s.har ? 'mtwb2__lomme--har' : 'mtwb2__lomme--mangler') +
            (s.vendt ? ' mtwb2__lomme--vendt' : '') + (erRh(s) ? ' mtwb2__lomme--rh' : '') + '" title="' + esc(rhTitel(s)) + '">' +
            lommeIndhold(s) + '</div>';
        } else {
          lommer += '<div class="mtwb2__lomme mtwb2__lomme--blank" aria-hidden="true"></div>';
        }
      }
      holder.innerHTML =
        '<div class="mtwb2__side mtwb2__side--f' + format + '">' +
        '<div class="mtwb2__side-lommer mtwb2__side-lommer--f' + format + '">' + lommer + '</div></div>' +
        (antalSider > 1
          ? '<div class="mtwb2__side-nav">' +
            '<button type="button" class="mtwb2__knap mtwb2__knap--lille mtwb2__knap--ghost" data-pside-forrige' + (side === 0 ? ' disabled' : '') + '>← Forrige</button>' +
            '<span class="mtwb2__side-tal">side ' + (side + 1) + ' af ' + antalSider + '</span>' +
            '<button type="button" class="mtwb2__knap mtwb2__knap--lille mtwb2__knap--ghost" data-pside-naeste' + (side + 1 >= antalSider ? ' disabled' : '') + '>Næste →</button>' +
            '</div>'
          : '');
      var f = holder.querySelector('[data-pside-forrige]');
      var n = holder.querySelector('[data-pside-naeste]');
      if (f) f.addEventListener('click', function () { side--; tegn(); });
      if (n) n.addEventListener('click', function () { side++; tegn(); });
    }
    tegn();
  }

  function renderOffentlig(binder, slots, token, fraGalleri) {
    var har = 0;
    slots.forEach(function (s) { if (s.har) har++; });
    var pct = slots.length ? Math.round((har / slots.length) * 100) : 0;
    var farve = binder.farve ? ' mtwb2__farve--' + esc(binder.farve) : '';
    /* 5.0: sider-visning når binderen bærer format/positioner */
    var brugSider = !!binder.lomme_format || slots.some(function (s) { return s.sort_key != null; });
    pub.innerHTML =
      (fraGalleri ? '<button type="button" class="mtwb2__tilbage" data-pub-tilbage>← Mine samlinger</button>' : '') +
      '<div data-pub-ejer></div>' +
      '<div class="mtwb2__pub-hoved">' +
      '<span class="mtwb2__d-emoji' + farve + '" aria-hidden="true">' + mtwIkon(binder.cover || 'dex') + '</span>' +
      '<div class="mtwb2__pub-titel">' +
      '<span class="mtwb2__pill mtwb2__pill--warn">Delt binder</span>' +
      '<h1>' + esc(binder.name) + '</h1>' +
      (slots.length
        ? '<div class="mtwb2__frem">' +
          '<span class="mtwb2__cbar' + (pct >= 100 ? ' mtwb2__cbar--fuld' : '') + '"><i style="width:' + pct + '%"></i></span>' +
          '<span class="mtwb2__frem-tal"><b>' + har + ' af ' + slots.length + ' kort</b> · ' + pct + ' %</span>' +
          '</div>'
        : '') +
      (slots.length && pct >= 100 ? '<span class="mtwb2__d-medalje">' + mtwIkon('medalje') + ' Fuldført</span>' : '') +
      (binder.beskrivelse ? '<p class="mtwb2__pub-besk">' + esc(binder.beskrivelse) + '</p>' : '') +
      '</div></div>' +
      (slots.length
        ? (brugSider
          ? '<div class="mtwb2__sider mtwb2__sider--pub" data-pub-sider></div>'
          : '<div class="mtwb2__grid mtwb2__grid--pub">' + slots.map(pubKortHtml).join('') + '</div>')
        : '<div class="mtwb2__tom">Binderen er tom endnu — men den er på vej.</div>') +
      '<div class="mtwb2__pub-cta">' +
      '<b>Kunne du tænke dig din egen binder?</b>' +
      '<p class="mtwb2__sub">Byg samlinger, stempl dine kort og se præcis hvad du mangler.</p>' +
      pubCta() +
      '</div>';
    if (slots.length && brugSider) {
      tegnPubSider(pub.querySelector('[data-pub-sider]'), binder, slots);
    }
    /* 5.0 Galleri-navigation: tilbage til hylden uden reload */
    var pubTilbage = pub.querySelector('[data-pub-tilbage]');
    if (pubTilbage) pubTilbage.addEventListener('click', function () {
      pub.hidden = true;
      pub.innerHTML = '';
      if (hylde) hylde.hidden = false;
    });
    /* Ejer-genvej: er den delte binder din egen, så hop til den rigtige */
    if (erKunde && hylde && detalje) {
      hent(PROXY).then(function (d) {
        var min = null;
        ((d && d.binders) || []).forEach(function (b) {
          if (b.share_token && b.share_token === token) min = b;
        });
        if (!min) return;
        var holder = pub.querySelector('[data-pub-ejer]');
        if (!holder) return;
        holder.innerHTML = '<button type="button" class="mtwb2__pub-ejer">' + mtwIkon('mappe') + ' <span>Dette er din delte binder — <b>Åbn den rigtige →</b></span></button>';
        holder.querySelector('button').addEventListener('click', function () {
          try { window.history.replaceState(null, '', window.location.pathname); } catch (eH) { /* gamle browsere */ }
          pub.hidden = true;
          visDetalje(min.id);
        });
      }).catch(function () { /* stille — genvejen er ren bonus */ });
    }
  }

  function visOffentlig(token, fraGalleri) {
    var login = document.querySelector('[data-mtwb2-login]');
    if (login) login.hidden = true;
    if (hylde) hylde.hidden = true;
    if (detalje) detalje.hidden = true;
    pub.hidden = false;
    pub.innerHTML = '<div class="mtwb2__skelet" aria-hidden="true"></div>';
    hent(PROXY + '?offentlig=' + encodeURIComponent(token)).then(function (d) {
      if (!d || !d.binder) throw new Error('tom');
      renderOffentlig(d.binder, d.slots || [], token, fraGalleri);
    }).catch(function () {
      pub.innerHTML =
        (fraGalleri ? '<button type="button" class="mtwb2__tilbage" data-pub-tilbage>← Mine samlinger</button>' : '') +
        '<div class="mtwb2__tom">Denne delte binder findes ikke længere — måske har ejeren stoppet delingen.</div>' +
        '<div class="mtwb2__pub-cta"><b>Byg din egen i stedet</b><p class="mtwb2__sub">Saml sæt, Pokémon eller illustratorer — og se præcis hvad du mangler.</p>' + pubCta() + '</div>';
      var t = pub.querySelector('[data-pub-tilbage]');
      if (t) t.addEventListener('click', function () {
        pub.hidden = true;
        pub.innerHTML = '';
        if (hylde) hylde.hidden = false;
      });
    });
  }

  /* ---------- Start ---------- */
  if (delToken && pub) visOffentlig(delToken);
  else if (hylde && detalje) visHylde();
})();
